import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // AdminNavbar
      "ERP System": "ERP System",
      "Clinic Admin Panel": "Clinic Admin Panel",
      Logout: "Logout",
      "Super Admin": "Super Admin",
      Admin: "Admin",

      // ErpNav
      "ERP Navigation": "ERP Navigation",
      Dashboard: "Dashboard",
      "Start Visit": "Start Visit",
      Doctors: "Doctors",
      Procedures: "Procedures",
      Patients: "Patients",
      Appointments: "Appointments",
      "Treatment Plans": "Treatment Plans",
      "Dental Records": "Dental Records",
      Invoices: "Invoices",
      Orders: "Orders",
      "Purchase Orders": "Purchase Orders",
      Reports: "Reports",
      "Clinic Settings": "Clinic Settings",

      // ErpDashboardHome - Header & Messages
      "Failed to load ERP dashboard.": "Failed to load ERP dashboard.",
      Retry: "Retry",
      "No dashboard data available.": "No dashboard data available.",
      "ERP Dashboard": "ERP Dashboard",
      "Clinic operations, billing, and payment overview":
        "Clinic operations, billing, and payment overview",
      Refresh: "Refresh",
      // ErpDashboardHome - KPIs
      Appointments: "Appointments",
      "Scheduled Today": "Scheduled Today",
      "Completed Today": "Completed Today",
      "Cancelled / No Show": "Cancelled / No Show",
      "Unpaid Invoices": "Unpaid Invoices",
      "Partially Paid": "Partially Paid",
      "Today Revenue": "Today Revenue",
      "Month Revenue": "Month Revenue",
      "Customer Credit Balance": "Customer Credit Balance",
      "Paid Invoices": "Paid Invoices",
      // ErpDashboardHome - Tables
      "Recent Appointments": "Recent Appointments",
      "Recent Invoices": "Recent Invoices",
      "Recent Payments": "Recent Payments",
      "View All": "View All",
      Patient: "Patient",
      Doctor: "Doctor",
      Date: "Date",
      Status: "Status",
      Number: "Number",
      Total: "Total",
      Issued: "Issued",
      Invoice: "Invoice",
      Applied: "Applied",
      Method: "Method",
      "Paid At": "Paid At",
      "No recent appointments.": "No recent appointments.",
      "No recent invoices.": "No recent invoices.",
      "No recent payments.": "No recent payments.",
      // ErpDashboardHome - Status Badges
      Paid: "Paid",
      Completed: "Completed",
      Unpaid: "Unpaid",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      "Partially Paid": "Partially Paid",
      Scheduled: "Scheduled",
      "In Progress": "In Progress",
      Pending: "Pending",
      // Reminders KPIs
      "Reminders Pending": "Reminders Pending",
      "Reminders Failed": "Reminders Failed",
      "Reminders Sent": "Reminders Sent",
      "Reminders Processing": "Reminders Processing",
      "Reminders Skipped": "Reminders Skipped",
      "Reminders Stuck": "Reminders Stuck",
      "Reminders Success Rate": "Reminders Success Rate",
      // Failed Reminders Table
      "Failed Reminders": "Failed Reminders",
      Appointment: "Appointment",
      Retries: "Retries",
      "Last Attempt": "Last Attempt",
      "No failed reminders.": "No failed reminders.",
      // Alerts Section - English
      "High failed reminders": "High failed reminders",
      "Reminders stuck in processing": "Reminders stuck in processing",
      "There are {{count}} failed reminders that need review":
        "There are {{count}} failed reminders that need review",
      "There are {{count}} reminders stuck for more than 10 minutes":
        "There are {{count}} reminders stuck for more than 10 minutes",
      // Additional
      "Doctor Name": "Doctor Name",
      "Appointment Date": "Appointment Date",
      "Reminder Stage": "Reminder Stage",

      // Activity Logs
      "Activity Logs": "Activity Logs",
      "No activity yet.": "No activity yet.",
      "New appointment created": "New appointment created",
      "Appointment updated": "Appointment updated",
      "Appointment deleted": "Appointment deleted",
      "New invoice created": "New invoice created",
      "Invoice paid": "Invoice paid",
      "New payment recorded": "New payment recorded",
      "Customer updated": "Customer updated",

      // Alert buttons
      Dismiss: "Dismiss",
      Acknowledge: "Acknowledge",
      // أضف ضمن كائن en:
      "Good Morning": "Good Morning",
      "Good Afternoon": "Good Afternoon",
      "Good Evening": "Good Evening",
      "Welcome to ERP Dashboard": "Welcome to ERP Dashboard",
      "Here's what's happening with your clinic today":
        "Here's what's happening with your clinic today",
      "Loading dashboard...": "Loading dashboard...",
      "Something went wrong": "Something went wrong",
      "Try Again": "Try Again",
      "No Data Available": "No Data Available",
      "Total Revenue": "Total Revenue",
      "Total Patients": "Total Patients",
      "Pending Reminders": "Pending Reminders",
      "Key Performance Indicators": "Key Performance Indicators",
      "Monitor your clinic's performance at a glance":
        "Monitor your clinic's performance at a glance",
      "Recent Activity": "Recent Activity",
      "Latest updates from your clinic": "Latest updates from your clinic",
      "Failed Reminders": "Failed Reminders",
      "No failed reminders.": "No failed reminders.",
      Retries: "Retries",
      "Last Attempt": "Last Attempt",

      // Common
      "Loading...": "Loading...",

      // ====================  Start Visit  ====================
      "Start Visit": "Start Visit",
      "Start the patient journey by selecting the patient and visit path":
        "Start the patient journey by selecting the patient and visit path",
      "New Patient": "New Patient",
      "New Treatment Plan": "New Treatment Plan",
      "Visit Starter": "Visit Starter",
      Patient: "Patient",
      "Select patient": "Select patient",
      "Visit Type": "Visit Type",
      "Existing Treatment Plan": "Existing Treatment Plan",
      "Select treatment plan": "Select treatment plan",
      "Select patient first": "Select patient first",
      "This patient has no treatment plans yet.":
        "This patient has no treatment plans yet. Create a dental record or treatment plan first.",
      "Selected Patient": "Selected Patient",
      "Selected Plan": "Selected Plan",
      Status: "Status",
      "Total Cost": "Total Cost",
      "Continuing...": "Continuing...",
      "Book Consultation": "Book Consultation",
      "Open Treatment Plan": "Open Treatment Plan",
      "Open Patient Profile": "Open Patient Profile",
      Cancel: "Cancel",
      "Workflow Preview": "Workflow Preview",
      "Consultation Flow": "Consultation Flow",
      "Treatment From Plan Flow": "Treatment From Plan Flow",
      "Emergency Treatment Flow": "Emergency Treatment Flow",
      "Failed to load reference data.": "Failed to load reference data.",
      "Please select a patient first.": "Please select a patient first.",
      "Please select a treatment plan first.":
        "Please select a treatment plan first.",
      "Invalid visit type selected.": "Invalid visit type selected.",
      Close: "Close",

      // وصف الكروت
      Consultation: "Consultation",
      "Treatment From Plan": "Treatment From Plan",
      "Emergency Treatment": "Emergency Treatment",
      consultation_desc:
        "Book a consultation appointment, collect consultation fee, then continue with exam and diagnosis.",
      treatment_plan_desc:
        "Use an existing treatment plan, open the plan, then start the required procedure and continue to billing.",
      emergency_desc:
        "Open the patient profile and dental chart first, add the urgent dental record, then convert it into treatment flow if needed.",
      consultation_next: "Goes to consultation booking",
      treatment_plan_next: "Goes to treatment plan details",
      emergency_next: "Goes to patient profile and dental chart",

      // Workflow steps
      "Book consultation appointment": "Book consultation appointment",
      "Consultation invoice is created": "Consultation invoice is created",
      "Doctor examines patient": "Doctor examines patient",
      "Complete appointment": "Complete appointment",
      "Go to invoice/payment page": "Go to invoice/payment page",
      "Create dental record if treatment is needed":
        "Create dental record if treatment is needed",
      "Open existing treatment plan": "Open existing treatment plan",
      "Select the required plan item": "Select the required plan item",
      "Start procedure": "Start procedure",
      "Create treatment appointment": "Create treatment appointment",
      "Create invoice and continue to payment":
        "Create invoice and continue to payment",
      "Open patient profile": "Open patient profile",
      "Add dental record from dental chart":
        "Add dental record from dental chart",
      "Convert to treatment plan item if needed":
        "Convert to treatment plan item if needed",
      "Start procedure and book slot": "Start procedure and book slot",
      "Complete appointment and continue to payment":
        "Complete appointment and continue to payment",
      "Dental Record and Treatment Plan remain part of the treatment workflow. Billing should happen only after a valid consultation or a valid treatment appointment completion.":
        "Dental Record and Treatment Plan remain part of the treatment workflow. Billing should happen only after a valid consultation or a valid treatment appointment completion.",

      // ====================  Appointments  ====================
      Appointments: "Appointments",
      "Daily schedule, doctor bookings, and patient appointments":
        "Daily schedule, doctor bookings, and patient appointments",
      Calendar: "Calendar",
      "Book Appointment": "Book Appointment",
      Refresh: "Refresh",
      "Search & Filters": "Search & Filters",
      Search: "Search",
      Date: "Date",
      Status: "Status",
      "All Statuses": "All Statuses",
      Scheduled: "Scheduled",
      Completed: "Completed",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      Loaded: "Loaded",
      Shown: "Shown",
      "Clear Filters": "Clear Filters",
      "Appointments List": "Appointments List",
      "No appointments found.": "No appointments found.",
      ID: "ID",
      Patient: "Patient",
      Doctor: "Doctor",
      Time: "Time",
      Type: "Type",
      Reminder: "Reminder",
      "Next Reminder": "Next Reminder",
      "Last Reminder": "Last Reminder",
      "Follow-up": "Follow-up",
      Invoice: "Invoice",
      "Treatment Plan": "Treatment Plan",
      Notes: "Notes",
      Actions: "Actions",
      Consultation: "Consultation",
      Treatment: "Treatment",
      Sent: "Sent",
      Pending: "Pending",
      "Not Needed": "Not Needed",
      Processing: "Processing",
      Retrying: "Retrying",
      Stopped: "Stopped",
      Skipped: "Skipped",
      Retries: "Retries",
      Next: "Next",
      "View Patient": "View Patient",
      "View Activity": "View Activity",
      "View Invoice": "View Invoice",
      "View Treatment Plan": "View Treatment Plan",
      Cancel: "Cancel",
      "Mark as No Show": "Mark as No Show",
      "Send Reminder": "Send Reminder",
      Complete: "Complete",
      Reschedule: "Reschedule",
      "Reschedule Appointment": "Reschedule Appointment",
      "Select doctor": "Select doctor",
      Confirm: "Confirm",
      "Saving...": "Saving...",
      Close: "Close",
      "Failed to load appointments.": "Failed to load appointments.",
      "Action failed.": "Action failed.",
      "Cancel this appointment?": "Cancel this appointment?",
      "Appointment cancelled successfully.":
        "Appointment cancelled successfully.",
      "Mark this appointment as no-show?": "Mark this appointment as no-show?",
      "Appointment marked as no-show.": "Appointment marked as no-show.",
      "Send reminder for this appointment?":
        "Send reminder for this appointment?",
      "Reminder sent successfully.": "Reminder sent successfully.",
      "Failed to send reminder.": "Failed to send reminder.",
      "Complete this {{type}} appointment?":
        "Complete this {{type}} appointment?",
      "Appointment completed successfully.":
        "Appointment completed successfully.",
      "Failed to complete appointment.": "Failed to complete appointment.",
      "Appointment rescheduled successfully.":
        "Appointment rescheduled successfully.",
      "Failed to reschedule appointment.": "Failed to reschedule appointment.",

      // ====================  Book Appointment  ====================
      "Book Consultation Appointment": "Book Consultation Appointment",
      "Create a consultation appointment and continue the patient journey":
        "Create a consultation appointment and continue the patient journey",
      "Back to Appointments": "Back to Appointments",
      "Appointment Details": "Appointment Details",
      Patient: "Patient",
      Doctor: "Doctor",
      "Appointment Type": "Appointment Type",
      Consultation: "Consultation",
      Date: "Date",
      "Available Slots": "Available Slots",
      "Loading Slots...": "Loading Slots...",
      "Reload Slots": "Reload Slots",
      Time: "Time",
      "Select slot": "Select slot",
      Unavailable: "Unavailable",
      "No slots available for this date": "No slots available for this date",
      Notes: "Notes",
      "Optional notes...": "Optional notes...",
      "Booking Summary": "Booking Summary",
      Type: "Type",
      "Booking...": "Booking...",
      "Book Consultation": "Book Consultation",
      Cancel: "Cancel",
      "Failed to load booking references.":
        "Failed to load booking references.",
      "Please select doctor and date first.":
        "Please select doctor and date first.",
      "Failed to load available slots.": "Failed to load available slots.",
      "Please select a patient.": "Please select a patient.",
      "Please select a doctor.": "Please select a doctor.",
      "Please select appointment date.": "Please select appointment date.",
      "Please select appointment time.": "Please select appointment time.",
      "Failed to book consultation.": "Failed to book consultation.",
      "Select patient": "Select patient",
      "Select doctor": "Select doctor",

      // ====================  Appointment Calendar  ====================
      "Appointment Calendar": "Appointment Calendar",
      "Daily clinic schedule by date and doctor":
        "Daily clinic schedule by date and doctor",
      "Book Appointment": "Book Appointment",
      Refresh: "Refresh",
      "Calendar Filters": "Calendar Filters",
      Date: "Date",
      Doctor: "Doctor",
      "All Doctors": "All Doctors",
      Navigation: "Navigation",
      "Previous Day": "Previous Day",
      Prev: "Prev",
      Today: "Today",
      "Next Day": "Next Day",
      Next: "Next",
      "Selected Day": "Selected Day",
      "Daily Schedule": "Daily Schedule",
      appointments: "appointments",
      "No appointments scheduled for this selection.":
        "No appointments scheduled for this selection.",
      "No appointments": "No appointments",
      "Unknown Patient": "Unknown Patient",
      "Clinical Notes": "Clinical Notes",
      Diagnosis: "Diagnosis",
      "Next Step": "Next Step",
      "View Patient": "View Patient",
      Patient: "Patient",
      "View Treatment Plan": "View Treatment Plan",
      Plan: "Plan",
      "View Invoice": "View Invoice",
      Invoice: "Invoice",
      "View Activity": "View Activity",
      Activity: "Activity",
      "Failed to load appointment calendar.":
        "Failed to load appointment calendar.",
      "In Progress": "In Progress",

      // ====================  Appointment Activity  ====================
      "Appointment Activity": "Appointment Activity",
      "Timeline of changes and actions for appointment":
        "Timeline of changes and actions for appointment",
      "Back to Appointments": "Back to Appointments",
      "Patient Profile": "Patient Profile",
      "Treatment Plan": "Treatment Plan",
      Invoice: "Invoice",
      Refresh: "Refresh",
      "Appointment ID": "Appointment ID",
      Status: "Status",
      Type: "Type",
      Events: "Events",
      "Appointment Details": "Appointment Details",
      "Appointment details not found.": "Appointment details not found.",
      Patient: "Patient",
      Doctor: "Doctor",
      Date: "Date",
      Time: "Time",
      "Created At": "Created At",
      "Updated At": "Updated At",
      "Clinical Notes": "Clinical Notes",
      Diagnosis: "Diagnosis",
      "Next Step": "Next Step",
      Notes: "Notes",
      "Complete Appointment": "Complete Appointment",
      Scheduled: "Scheduled",
      "Completion Result": "Completion Result",
      "Invoice Total": "Invoice Total",
      "Invoice Status": "Invoice Status",
      "Completed Sessions": "Completed Sessions",
      "Planned Sessions": "Planned Sessions",
      "Remaining Sessions": "Remaining Sessions",
      "Item Status": "Item Status",
      "Doctor Name": "Doctor Name",
      "Optional doctor name override": "Optional doctor name override",
      "General Notes": "General Notes",
      "Optional notes": "Optional notes",
      "Enter clinical notes...": "Enter clinical notes...",
      "Enter diagnosis...": "Enter diagnosis...",
      "Enter next step...": "Enter next step...",
      "Completing...": "Completing...",
      Reset: "Reset",
      "Clinical notes saved successfully.":
        "Clinical notes saved successfully.",
      "Failed to save clinical notes.": "Failed to save clinical notes.",
      "Failed to complete appointment.": "Failed to complete appointment.",
      "Appointment completed successfully.":
        "Appointment completed successfully.",
      "Completed Appointment": "Completed Appointment",
      "Save Clinical Notes": "Save Clinical Notes",
      "Saving...": "Saving...",
      "Latest Activity": "Latest Activity",
      "Last recorded action for this appointment.":
        "Last recorded action for this appointment.",
      "Activity Log": "Activity Log",
      events: "events",
      "No activity found for this appointment.":
        "No activity found for this appointment.",
      "Log ID": "Log ID",
      "Company ID": "Company ID",
      "Subject ID": "Subject ID",
      "Subject Type": "Subject Type",
      "Appointment Type": "Appointment Type",
      "Old Status": "Old Status",
      "New Status": "New Status",
      "Old Date": "Old Date",
      "New Date": "New Date",
      "Old Time": "Old Time",
      "New Time": "New Time",
      "Doctor ID": "Doctor ID",
      "Plan Item ID": "Plan Item ID",
      "Procedure ID": "Procedure ID",
      Procedure: "Procedure",
      Total: "Total",
      Plan: "Plan",
      "Show raw properties": "Show raw properties",
      User: "User",
      Booked: "Booked",
      Rebooked: "Rebooked",
      Rescheduled: "Rescheduled",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      Completed: "Completed",
      "Procedure Started": "Procedure Started",
      "Session Completed": "Session Completed",
      Updated: "Updated",
      "Failed to load appointment details.":
        "Failed to load appointment details.",
      Consultation: "Consultation",
      Treatment: "Treatment",
      "In Progress": "In Progress",

      // ==================== Dental Records   ====================
      "Dental Records": "Dental Records",
      "Review patient chart records, procedures, teeth, and statuses":
        "Review patient chart records, procedures, teeth, and statuses",
      "Create Dental Record": "Create Dental Record",
      Refresh: "Refresh",
      "Search Records": "Search Records",
      Search: "Search",
      "Total Records": "Total Records",
      "Dental Records List": "Dental Records List",
      records: "records",
      "No dental records found.": "No dental records found.",
      Patient: "Patient",
      Procedure: "Procedure",
      Tooth: "Tooth",
      Surface: "Surface",
      Status: "Status",
      Notes: "Notes",
      Actions: "Actions",
      "View Patient": "View Patient",
      "View Timeline": "View Timeline",
      Timeline: "Timeline",
      "Convert to Treatment Plan": "Convert to Treatment Plan",
      Convert: "Convert",
      "Select Treatment Plan": "Select Treatment Plan",
      "Select plan": "Select plan",
      "No treatment plans found for this patient.":
        "No treatment plans found for this patient.",
      "Confirm Convert": "Confirm Convert",
      "Converting...": "Converting...",
      Cancel: "Cancel",
      "Failed to load dental records.": "Failed to load dental records.",
      "Please select a treatment plan first.":
        "Please select a treatment plan first.",
      "Failed to convert dental record.": "Failed to convert dental record.",
      Completed: "Completed",
      Cancelled: "Cancelled",
      Planned: "Planned",
      "In Progress": "In Progress",

      // ==================== Create Dental Record   ====================
      "Create Dental Record": "Create Dental Record",
      "Add a clinical dental record for a patient before treatment planning":
        "Add a clinical dental record for a patient before treatment planning",
      "Back to Dental Records": "Back to Dental Records",
      "This record is linked to appointment":
        "This record is linked to appointment",
      "Next Step": "Next Step",
      "You can now create a treatment plan directly for this patient.":
        "You can now create a treatment plan directly for this patient.",
      "Create Treatment Plan": "Create Treatment Plan",
      "Go to Dental Records": "Go to Dental Records",
      "Dental Record Details": "Dental Record Details",
      Patient: "Patient",
      Doctor: "Doctor",
      Procedure: "Procedure",
      "Tooth Number": "Tooth Number",
      Surface: "Surface",
      Notes: "Notes",
      "Record Summary": "Record Summary",
      "Linked Appointment": "Linked Appointment",
      Tooth: "Tooth",
      "e.g., 16, 24, 36": "e.g., 16, 24, 36",
      "occlusal, mesial, distal, buccal, lingual":
        "occlusal, mesial, distal, buccal, lingual",
      "Clinical findings, diagnosis, and observations...":
        "Clinical findings, diagnosis, and observations...",
      "Select patient": "Select patient",
      "Select doctor": "Select doctor",
      "Select procedure": "Select procedure",
      "Saving...": "Saving...",
      "Create Dental Record": "Create Dental Record",
      Cancel: "Cancel",
      "Failed to load reference data.": "Failed to load reference data.",
      "Failed to create dental record.": "Failed to create dental record.",

      // ==================== Treatment Plans  ====================
      "Treatment Plans": "Treatment Plans",
      "View treatment plans, balances, progress, and linked patient data":
        "View treatment plans, balances, progress, and linked patient data",
      "Create Treatment Plan": "Create Treatment Plan",
      Refresh: "Refresh",
      "Search Plans": "Search Plans",
      Search: "Search",
      "Total Plans": "Total Plans",
      "Treatment Plans List": "Treatment Plans List",
      plans: "plans",
      "No treatment plans found.": "No treatment plans found.",
      Title: "Title",
      Patient: "Patient",
      "Total Cost": "Total Cost",
      "Total Paid": "Total Paid",
      "Net Paid": "Net Paid",
      Remaining: "Remaining",
      Status: "Status",
      Actions: "Actions",
      "View Plan": "View Plan",
      View: "View",
      "View Patient": "View Patient",
      "Failed to load treatment plans.": "Failed to load treatment plans.",
      Completed: "Completed",
      Cancelled: "Cancelled",

      // ==================== Treatment Plan Details  ====================
      "Treatment Plan Details": "Treatment Plan Details",
      "Review plan items, progress, invoices, and cash flow":
        "Review plan items, progress, invoices, and cash flow",
      "Back to Plans": "Back to Plans",
      "Patient Profile": "Patient Profile",
      Refresh: "Refresh",
      "Plan Information": "Plan Information",
      Title: "Title",
      Patient: "Patient",
      Email: "Email",
      Status: "Status",
      "Total Cost": "Total Cost",
      Created: "Created",
      Notes: "Notes",
      "Treatment Progress": "Treatment Progress",
      "{{completed}} / {{planned}} sessions completed":
        "{{completed}} / {{planned}} sessions completed",
      "Total Invoiced": "Total Invoiced",
      "Direct Paid": "Direct Paid",
      "Credit Applied": "Credit Applied",
      "Total Paid": "Total Paid",
      "Total Refunded": "Total Refunded",
      "Net Paid": "Net Paid",
      Remaining: "Remaining",
      "Cash In": "Cash In",
      "Net Cash": "Net Cash",
      "Customer Credit": "Customer Credit",
      "Add Plan Item": "Add Plan Item",
      Procedure: "Procedure",
      Tooth: "Tooth",
      Surface: "Surface",
      Price: "Price",
      Sessions: "Sessions",
      Add: "Add",
      "Add Item": "Add Item",
      "Adding...": "Adding...",
      "Optional notes...": "Optional notes...",
      "Select procedure": "Select procedure",
      "Select surface": "Select surface",
      Occlusal: "Occlusal",
      Incisal: "Incisal",
      Mesial: "Mesial",
      Distal: "Distal",
      Buccal: "Buccal",
      Facial: "Facial",
      Lingual: "Lingual",
      Palatal: "Palatal",
      General: "General",
      Optional: "Optional",
      "Plan Items": "Plan Items",
      items: "items",
      "No items found.": "No items found.",
      Procedure: "Procedure",
      Price: "Price",
      Remaining: "Remaining",
      Progress: "Progress",
      Actions: "Actions",
      "Next Session": "Next Session",
      "Start Procedure": "Start Procedure",
      Appointment: "Appointment",
      Delete: "Delete",
      "Open Appointment": "Open Appointment",
      "Start Next Session": "Start Next Session",
      "This will create a treatment appointment for this plan item. When that appointment is completed, one session will be billed and the completed sessions count will be increased.":
        "This will create a treatment appointment for this plan item. When that appointment is completed, one session will be billed and the completed sessions count will be increased.",
      Doctor: "Doctor",
      Date: "Date",
      "Available Slots": "Available Slots",
      "Load Slots": "Load Slots",
      "Loading Slots...": "Loading Slots...",
      Time: "Time",
      "Select slot": "Select slot",
      Unavailable: "Unavailable",
      "Confirm Start": "Confirm Start",
      "Starting...": "Starting...",
      Close: "Close",
      "Linked Invoices": "Linked Invoices",
      invoices: "invoices",
      "No invoices linked to this plan.": "No invoices linked to this plan.",
      Number: "Number",
      "Cash Summary": "Cash Summary",
      "Invoice Refunds": "Invoice Refunds",
      "Credit Refunds": "Credit Refunds",
      "Credit Issued": "Credit Issued",
      "Credit Used": "Credit Used",
      "Net Credit": "Net Credit",
      "Item added successfully.": "Item added successfully.",
      "Failed to add item.": "Failed to add item.",
      "Delete this item?": "Delete this item?",
      "Item deleted successfully.": "Item deleted successfully.",
      "Failed to delete item.": "Failed to delete item.",
      "Please select doctor and date first.":
        "Please select doctor and date first.",
      "Failed to load available slots.": "Failed to load available slots.",
      "Procedure started successfully.": "Procedure started successfully.",
      "Failed to start procedure.": "Failed to start procedure.",
      "Failed to load treatment plan details.":
        "Failed to load treatment plan details.",
      Retry: "Retry",
      Completed: "Completed",
      "In Progress": "In Progress",
      Cancelled: "Cancelled",
      "Not Started": "Not Started",
      Planned: "Planned",
      "Partially Paid": "Partially Paid",
      Unpaid: "Unpaid",
      Paid: "Paid",
      "e.g., 16, 24, 36": "e.g., 16, 24, 36",

      // ==================== Create Treatment Plan  ====================
      "Create Treatment Plan": "Create Treatment Plan",
      "Create a new treatment plan for a patient":
        "Create a new treatment plan for a patient",
      "Back to Plans": "Back to Plans",
      "Treatment Plan Details": "Treatment Plan Details",
      Patient: "Patient",
      Title: "Title",
      Notes: "Notes",
      "Plan Cost": "Plan Cost",
      "Total cost will be calculated automatically after adding plan items.":
        "Total cost will be calculated automatically after adding plan items.",
      "Selected Patient": "Selected Patient",
      "Select patient": "Select patient",
      "e.g. Ahmed Dental Plan": "e.g. Ahmed Dental Plan",
      "Optional notes...": "Optional notes...",
      "Saving...": "Saving...",
      "Create Treatment Plan": "Create Treatment Plan",
      Cancel: "Cancel",
      "Failed to load patients.": "Failed to load patients.",
      "Treatment plan created successfully.":
        "Treatment plan created successfully.",
      "Failed to create treatment plan.": "Failed to create treatment plan.",

      // ==================== patients  ====================
      Patients: "Patients",
      "Manage patients, open profile, timeline, and statement":
        "Manage patients, open profile, timeline, and statement",
      "New Patient": "New Patient",
      Refresh: "Refresh",
      "Search Patients": "Search Patients",
      Search: "Search",
      "Total Patients": "Total Patients",
      "Patients List": "Patients List",
      patients: "patients",
      "No patients found.": "No patients found.",
      Code: "Code",
      Name: "Name",
      Email: "Email",
      Phone: "Phone",
      Status: "Status",
      Actions: "Actions",
      "View Profile": "View Profile",
      Profile: "Profile",
      "Edit Patient": "Edit Patient",
      Edit: "Edit",
      "View Timeline": "View Timeline",
      Timeline: "Timeline",
      "View Statement": "View Statement",
      Statement: "Statement",
      "Search by code, name, email, phone, or status...":
        "Search by code, name, email, phone, or status...",
      Active: "Active",
      Inactive: "Inactive",
      "Failed to load patients.": "Failed to load patients.",

      // ==================== patient profile  ====================
      "Failed to load patient profile": "Failed to load patient profile",
      "Dental record updated successfully.":
        "Dental record updated successfully.",
      "Dental record added successfully.": "Dental record added successfully.",
      "Failed to save dental record.": "Failed to save dental record.",
      "Delete this dental record?": "Delete this dental record?",
      "Dental record deleted successfully.":
        "Dental record deleted successfully.",
      "Failed to delete dental record.": "Failed to delete dental record.",
      "Record converted to treatment plan item successfully.":
        "Record converted to treatment plan item successfully.",
      "Failed to convert record.": "Failed to convert record.",
      "Convert to Treatment Plan": "Convert to Treatment Plan",
      "Open Treatment Plan": "Open Treatment Plan",
      "Open Appointment": "Open Appointment",
      "Not converted yet": "Not converted yet",
      "Plan #{id} • Waiting to start procedure":
        "Plan #{id} • Waiting to start procedure",
      "Plan #{planId} • Appointment #{appointmentId}":
        "Plan #{planId} • Appointment #{appointmentId}",
      "No patient data": "No patient data",
      Code: "Code",
      Timeline: "Timeline",
      Statement: "Statement",
      Refresh: "Refresh",
      Email: "Email",
      Phone: "Phone",
      Created: "Created",
      Appointments: "Appointments",
      "Dental Records": "Dental Records",
      "Treatment Plans": "Treatment Plans",
      Invoices: "Invoices",
      "Invoices Total": "Invoices Total",
      "Direct Paid": "Direct Paid",
      "Credit Applied": "Credit Applied",
      "Net Paid": "Net Paid",
      Remaining: "Remaining",
      "Customer Credit Balance": "Customer Credit Balance",
      Date: "Date",
      Time: "Time",
      Doctor: "Doctor",
      Type: "Type",
      Consultation: "Consultation",
      Treatment: "Treatment",
      "Dental Chart": "Dental Chart",
      "Each tooth shows surfaces: O/I, M, D, B/F, L/P":
        "Each tooth shows surfaces: O/I, M, D, B/F, L/P",
      "Clear Selection": "Clear Selection",
      "Upper Jaw": "Upper Jaw",
      "Lower Jaw": "Lower Jaw",
      Completed: "Completed",
      "In Progress": "In Progress",
      Planned: "Planned",
      "No Data": "No Data",
      Tooth: "Tooth",
      Details: "Details",
      "Edit Record": "Edit Record",
      "Add Record": "Add Record",
      "Cancel Edit": "Cancel Edit",
      Surface: "Surface",
      Procedure: "Procedure",
      Notes: "Notes",
      "Optional notes...": "Optional notes...",
      "Update Record": "Update Record",
      "Add Record": "Add Record",
      "Existing Records": "Existing Records",
      "No records for this tooth.": "No records for this tooth.",
      "Select surface": "Select surface",
      Occlusal: "Occlusal",
      Incisal: "Incisal",
      Mesial: "Mesial",
      Distal: "Distal",
      Buccal: "Buccal",
      Facial: "Facial",
      Lingual: "Lingual",
      Palatal: "Palatal",
      General: "General",
      "Select procedure": "Select procedure",
      Edit: "Edit",
      Delete: "Delete",
      "Deleting...": "Deleting...",
      "Convert to Treatment Plan": "Convert to Treatment Plan",
      "Treatment Plan": "Treatment Plan",
      "Select treatment plan": "Select treatment plan",
      Plan: "Plan",
      Price: "Price",
      "Optional price override": "Optional price override",
      Confirm: "Confirm",
      "Converting...": "Converting...",
      Cancel: "Cancel",
      Title: "Title",
      Total: "Total",
      Number: "Number",
      Active: "Active",
      Inactive: "Inactive",
      Scheduled: "Scheduled",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      "Partially Paid": "Partially Paid",
      Unpaid: "Unpaid",
      Paid: "Paid",
      Retry: "Retry",
      "Saving...": "Saving...",
      "Loading...": "Loading...",

      // ==================== PatientStatementPage ====================
      "Failed to load {{entity}} statement":
        "Failed to load {{entity}} statement",
      "Loading {{entity}} statement...": "Loading {{entity}} statement...",
      "Failed to load statement data": "Failed to load statement data",
      "Go Back": "Go Back",
      Statement: "Statement",
      "All Time": "All Time",
      "Last 30 Days": "Last 30 Days",
      "Last 90 Days": "Last 90 Days",
      From: "From",
      To: "To",
      Apply: "Apply",
      "Opening Balance": "Opening Balance",
      "Closing Balance": "Closing Balance",
      "Total Entries": "Total Entries",
      "No entries in this period": "No entries in this period",
      Debit: "Debit",
      Credit: "Credit",
      Balance: "Balance",
      "Account summary and transaction details":
        "Account summary and transaction details",
      "Print Statement": "Print Statement",
      "Quick Filters": "Quick Filters",
      "Custom Date Range": "Custom Date Range",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply Filter": "Apply Filter",
      "Statement Period": "Statement Period",
      to: "to",
      "Statement Entries": "Statement Entries",
      Description: "Description",

      // ==================== PatientTimelinePage ====================
      "Failed to load patient timeline.": "Failed to load patient timeline.",
      "No patient timeline data available.":
        "No patient timeline data available.",
      "Patient Timeline": "Patient Timeline",
      "Full history: appointments, dental records, treatment flow, invoices and payments":
        "Full history: appointments, dental records, treatment flow, invoices and payments",
      Profile: "Profile",
      Statement: "Statement",
      Refresh: "Refresh",
      Name: "Name",
      Code: "Code",
      Email: "Email",
      Phone: "Phone",
      "Timeline Events": "Timeline Events",
      events: "events",
      "No events found.": "No events found.",
      Doctor: "Doctor",
      Type: "Type",
      Date: "Date",
      Time: "Time",
      Status: "Status",
      Diagnosis: "Diagnosis",
      "Next Step": "Next Step",
      "Clinical Notes": "Clinical Notes",
      Notes: "Notes",
      "Treatment Plan": "Treatment Plan",
      Invoice: "Invoice",
      "Appointment Activity": "Appointment Activity",
      Procedure: "Procedure",
      Tooth: "Tooth",
      Surface: "Surface",
      Flow: "Flow",
      "Not converted": "Not converted",
      "Open Plan": "Open Plan",
      "Open Appointment": "Open Appointment",
      "Invoice Number": "Invoice Number",
      Total: "Total",
      "Issued At": "Issued At",
      "Appointment ID": "Appointment ID",
      "Treatment Plan ID": "Treatment Plan ID",
      "Open Invoice": "Open Invoice",
      "Invoice ID": "Invoice ID",
      Amount: "Amount",
      "Applied Amount": "Applied Amount",
      "Credit Amount": "Credit Amount",
      Method: "Method",
      "Payment ID": "Payment ID",
      "Refund Amount": "Refund Amount",
      "Applies To": "Applies To",
      "No details available.": "No details available.",
      Appointment: "Appointment",
      "Dental Record": "Dental Record",
      Invoice: "Invoice",
      Payment: "Payment",
      Refund: "Refund",
      Event: "Event",
      Consultation: "Consultation",
      Treatment: "Treatment",
      "Appointment #{id}": "Appointment #{id}",
      "Plan #{id}": "Plan #{id}",
      Retry: "Retry",
      "Loading...": "Loading...",

      // ==================== Create Patient ====================
      "Edit Patient": "Edit Patient",
      "Create Patient": "Create Patient",
      "Update patient basic information": "Update patient basic information",
      "Create a new patient profile": "Create a new patient profile",
      Patients: "Patients",
      Profile: "Profile",
      "Edit Patient Information": "Edit Patient Information",
      "Patient Information": "Patient Information",
      "Full Name": "Full Name",
      "Enter patient full name": "Enter patient full name",
      "Email Address": "Email Address",
      "patient@example.com": "patient@example.com",
      "Phone Number": "Phone Number",
      "+1234567890": "+1234567890",
      Gender: "Gender",
      "Select gender": "Select gender",
      Male: "Male",
      Female: "Female",
      "Date of Birth": "Date of Birth",
      Address: "Address",
      "Street, city, postal code": "Street, city, postal code",
      "Additional notes about the patient...":
        "Additional notes about the patient...",
      "Update Patient": "Update Patient",
      "Failed to load patient.": "Failed to load patient.",
      "Failed to save patient.": "Failed to save patient.",

      // ==================== Doctors ====================
      Doctors: "Doctors",
      "Manage doctors, working hours, and availability":
        "Manage doctors, working hours, and availability",
      "New Doctor": "New Doctor",
      Refresh: "Refresh",
      "Search Doctors": "Search Doctors",
      Search: "Search",
      "Total Doctors": "Total Doctors",
      "Doctors List": "Doctors List",
      doctors: "doctors",
      "No doctors found.": "No doctors found.",
      Doctor: "Doctor",
      Specialty: "Specialty",
      "Working Hours": "Working Hours",
      "Slot Minutes": "Slot Minutes",
      Status: "Status",
      Actions: "Actions",
      "Manage Availability": "Manage Availability",
      Availability: "Availability",
      "Edit Doctor": "Edit Doctor",
      Edit: "Edit",
      "Book Appointment": "Book Appointment",
      Book: "Book",
      "Name, email, phone, specialty...": "Name, email, phone, specialty...",
      Active: "Active",
      Inactive: "Inactive",
      min: "min",
      "Failed to load doctors.": "Failed to load doctors.",

      // ==================== Create Doctor ====================
      "Edit Doctor": "Edit Doctor",
      "Create Doctor": "Create Doctor",
      "Manage doctor profile, hours, and booking slot settings":
        "Manage doctor profile, hours, and booking slot settings",
      "Back to Doctors": "Back to Doctors",
      "Doctor Information": "Doctor Information",
      "New Doctor": "New Doctor",
      "Full Name": "Full Name",
      "Dr. John Doe": "Dr. John Doe",
      Specialty: "Specialty",
      "Dentist / Orthodontist / Surgeon...":
        "Dentist / Orthodontist / Surgeon...",
      "Email Address": "Email Address",
      "doctor@clinic.com": "doctor@clinic.com",
      "Phone Number": "Phone Number",
      "+1234567890": "+1234567890",
      "Work Start": "Work Start",
      "Work End": "Work End",
      "Slot Duration": "Slot Duration",
      minutes: "minutes",
      "Active doctor": "Active doctor",
      "Active doctors can be booked for appointments":
        "Active doctors can be booked for appointments",
      "Update Doctor": "Update Doctor",
      "Create Doctor": "Create Doctor",
      "Failed to load doctor.": "Failed to load doctor.",
      "Failed to save doctor.": "Failed to save doctor.",

      // ==================== Doctor Availability ====================
      "Doctor Availability": "Doctor Availability",
      "Check available slots for this doctor":
        "Check available slots for this doctor",
      "Back to Doctors": "Back to Doctors",
      "Book Appointment": "Book Appointment",
      "Doctor Information": "Doctor Information",
      "Doctor Name": "Doctor Name",
      Email: "Email",
      Phone: "Phone",
      Specialty: "Specialty",
      "Working Hours": "Working Hours",
      "Slot Duration": "Slot Duration",
      minutes: "minutes",
      "Check Availability": "Check Availability",
      "Select Date": "Select Date",
      "Checking...": "Checking...",
      "Load Availability": "Load Availability",
      "Available Slots": "Available Slots",
      "No slots available for this date": "No slots available for this date",
      "Select a date to check availability":
        "Select a date to check availability",
      Booked: "Booked",
      "Failed to load doctor details.": "Failed to load doctor details.",
      "Please select a date first.": "Please select a date first.",
      "Failed to load doctor availability.":
        "Failed to load doctor availability.",

      // ==================== Invoices ====================
      Invoices: "Invoices",
      "Review invoice balances, payment status, and customer billing":
        "Review invoice balances, payment status, and customer billing",
      Refresh: "Refresh",
      "Search Invoices": "Search Invoices",
      Search: "Search",
      "Total Invoices": "Total Invoices",
      "Invoices List": "Invoices List",
      invoices: "invoices",
      "No invoices found.": "No invoices found.",
      Invoice: "Invoice",
      Customer: "Customer",
      Total: "Total",
      Paid: "Paid",
      Remaining: "Remaining",
      Status: "Status",
      Issued: "Issued",
      Actions: "Actions",
      "View Invoice": "View Invoice",
      View: "View",
      "View Patient": "View Patient",
      Patient: "Patient",
      "View Treatment Plan": "View Treatment Plan",
      Plan: "Plan",
      "Invoice number, customer, email, status...":
        "Invoice number, customer, email, status...",
      ID: "ID",
      "Partially Paid": "Partially Paid",
      Unpaid: "Unpaid",
      Cancelled: "Cancelled",
      "Failed to load invoices.": "Failed to load invoices.",

      // ==================== Invoice Details ====================
      "Invoice Details": "Invoice Details",
      "Review invoice, payments, refunds, and accounting impact":
        "Review invoice, payments, refunds, and accounting impact",
      "Back to Invoices": "Back to Invoices",
      "Patient Profile": "Patient Profile",
      Refresh: "Refresh",
      "Invoice Information": "Invoice Information",
      "Invoice Number": "Invoice Number",
      Status: "Status",
      "Customer ID": "Customer ID",
      "Appointment ID": "Appointment ID",
      "Treatment Plan ID": "Treatment Plan ID",
      "Issued At": "Issued At",
      "Invoice Total": "Invoice Total",
      "Direct Paid": "Direct Paid",
      "Credit Applied": "Credit Applied",
      Refunded: "Refunded",
      "Net Paid": "Net Paid",
      Remaining: "Remaining",
      "Invoice Credit": "Invoice Credit",
      "Customer Credit Balance": "Customer Credit Balance",
      "Cash Received": "Cash Received",
      "Receive Payment": "Receive Payment",
      Amount: "Amount",
      Method: "Method",
      cash: "cash",
      card: "card",
      bank: "bank",
      "Processing...": "Processing...",
      "Receive Payment": "Receive Payment",
      "Any available customer credit is applied automatically when the invoice is created. Any extra payment above remaining becomes new customer credit.":
        "Any available customer credit is applied automatically when the invoice is created. Any extra payment above remaining becomes new customer credit.",
      "Invoice Items": "Invoice Items",
      "No invoice items found.": "No invoice items found.",
      Product: "Product",
      Qty: "Qty",
      "Unit Price": "Unit Price",
      Total: "Total",
      Payments: "Payments",
      "No payments recorded yet.": "No payments recorded yet.",
      ID: "ID",
      Applied: "Applied",
      Credit: "Credit",
      "Paid At": "Paid At",
      "Refund Payments": "Refund Payments",
      "No payments available for refund.": "No payments available for refund.",
      Payment: "Payment",
      "Paid at": "Paid at",
      "Invoice Refundable": "Invoice Refundable",
      "Credit Refundable": "Credit Refundable",
      "Total Refundable": "Total Refundable",
      "Refund Amount": "Refund Amount",
      Refund: "Refund",
      "Previous Refunds": "Previous Refunds",
      Type: "Type",
      "Refunded At": "Refunded At",
      "All Refunds": "All Refunds",
      "No refunds found.": "No refunds found.",
      "Payment ID": "Payment ID",
      "Customer Credit Summary": "Customer Credit Summary",
      "Credit Issued Total": "Credit Issued Total",
      "Credit Used Total": "Credit Used Total",
      "Current Credit Balance": "Current Credit Balance",
      "Journal Entries": "Journal Entries",
      "No journal entries found.": "No journal entries found.",
      Entry: "Entry",
      Account: "Account",
      Debit: "Debit",
      Credit: "Credit",
      "Failed to load invoice.": "Failed to load invoice.",
      Retry: "Retry",
      "Invoice not found.": "Invoice not found.",
      Back: "Back",
      "Payment recorded successfully.": "Payment recorded successfully.",
      "Failed to record payment.": "Failed to record payment.",
      "Enter a valid refund amount.": "Enter a valid refund amount.",
      "Refund recorded successfully.": "Refund recorded successfully.",
      "Failed to record refund.": "Failed to record refund.",
      "Partially Paid": "Partially Paid",
      Unpaid: "Unpaid",
      Cancelled: "Cancelled",
      Paid: "Paid",

      // ==================== Analytics Dashboard ====================
      "Analytics Dashboard": "Analytics Dashboard",
      "Visual overview of revenue, appointments, doctors, and collections":
        "Visual overview of revenue, appointments, doctors, and collections",
      "Back to Reports": "Back to Reports",
      Refresh: "Refresh",
      "Date Range Filter": "Date Range Filter",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply Filters": "Apply Filters",
      "Total Appointments": "Total Appointments",
      "Filtered range": "Filtered range",
      "Completed Appointments": "Completed Appointments",
      "Appointments done": "Appointments done",
      "Total Invoiced": "Total Invoiced",
      "Total billed": "Total billed",
      "Total Collected": "Total Collected",
      "Net paid": "Net paid",
      "Revenue Trend": "Revenue Trend",
      Invoiced: "Invoiced",
      Paid: "Paid",
      "No revenue data in this range.": "No revenue data in this range.",
      "Appointment Status": "Appointment Status",
      "No appointment data in this range.":
        "No appointment data in this range.",
      "Doctor Load": "Doctor Load",
      "No doctor data available.": "No doctor data available.",
      "Payment Snapshot": "Payment Snapshot",
      Refunded: "Refunded",
      Remaining: "Remaining",
      "Failed to load analytics.": "Failed to load analytics.",
      "Total Appointments": "Total Appointments",
      Completed: "Completed",
      Total: "Total",
      "In Progress": "In Progress",

      // ==================== Appointments Report ====================
      "Appointments Report": "Appointments Report",
      "Operational report for scheduling, completion, cancellation, and no-show trends":
        "Operational report for scheduling, completion, cancellation, and no-show trends",
      "Back to Reports": "Back to Reports",
      Print: "Print",
      "Export CSV": "Export CSV",
      Refresh: "Refresh",
      Filters: "Filters",
      "From Date": "From Date",
      "To Date": "To Date",
      Doctor: "Doctor",
      "All Doctors": "All Doctors",
      Status: "Status",
      "All Statuses": "All Statuses",
      Scheduled: "Scheduled",
      Completed: "Completed",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      "In Progress": "In Progress",
      "Apply Filters": "Apply Filters",
      "Total Appointments": "Total Appointments",
      "Report Summary": "Report Summary",
      "This report is currently built from the appointments listing response and is ready to be switched later to a dedicated reporting API.":
        "This report is currently built from the appointments listing response and is ready to be switched later to a dedicated reporting API.",
      "Appointment Rows": "Appointment Rows",
      appointments: "appointments",
      "No appointments found for this report.":
        "No appointments found for this report.",
      Patient: "Patient",
      Date: "Date",
      Time: "Time",
      Notes: "Notes",
      Actions: "Actions",
      "View Patient": "View Patient",
      Patient: "Patient",
      "View Activity": "View Activity",
      Activity: "Activity",
      "Failed to load appointments report.":
        "Failed to load appointments report.",
      Doctor: "Doctor",

      // ==================== Doctor Performance Report  ====================
      "Doctor Performance Report": "Doctor Performance Report",
      "Compare doctors by appointments, completion rate, and attendance":
        "Compare doctors by appointments, completion rate, and attendance",
      "Back to Reports": "Back to Reports",
      Print: "Print",
      "Export CSV": "Export CSV",
      Refresh: "Refresh",
      Filters: "Filters",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply Filters": "Apply Filters",
      "Total Doctors": "Total Doctors",
      "Total Appointments": "Total Appointments",
      "Avg Completion Rate": "Avg Completion Rate",
      "Report Period": "Report Period",
      "Doctor Statistics": "Doctor Statistics",
      doctors: "doctors",
      "No data available.": "No data available.",
      Doctor: "Doctor",
      Specialty: "Specialty",
      Total: "Total",
      Completed: "Completed",
      Scheduled: "Scheduled",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      "Completion Rate": "Completion Rate",
      "Failed to load doctor performance report.":
        "Failed to load doctor performance report.",

      // ==================== Clinic Reports  ====================
      "Clinic Reports": "Clinic Reports",
      "Reporting hub for finance, appointments, doctors, and patient activity":
        "Reporting hub for finance, appointments, doctors, and patient activity",
      "Back to Dashboard": "Back to Dashboard",
      "Global Filters": "Global Filters",
      "From Date": "From Date",
      "To Date": "To Date",
      "Doctor ID": "Doctor ID",
      Optional: "Optional",
      "These filters are UI-ready and can be wired to report APIs next.":
        "These filters are UI-ready and can be wired to report APIs next.",
      Report: "Report",
      "Recommended First Reports": "Recommended First Reports",
      "Revenue Report": "Revenue Report",
      revenue_report_desc:
        "Track revenue, paid amounts, and outstanding balances.",
      revenue_hint_text:
        "Most important for management because it connects invoices, payments, refunds, and remaining balances.",
      "Appointments Report": "Appointments Report",
      appointments_report_desc:
        "Review scheduled, completed, cancelled, and no-show visits.",
      appointments_hint_text:
        "Critical for operations because it shows booking load, completion rate, cancellation, and no-show patterns.",
      "Doctor Performance": "Doctor Performance",
      doctor_performance_desc:
        "Compare doctors by appointment volume and completed visits.",
      doctor_performance_hint_text:
        "Useful for comparing doctors and planning schedules, staffing, and productivity.",
      "Analytics Dashboard": "Analytics Dashboard",
      analytics_dashboard_desc:
        "Visual charts for revenue, appointments, doctor load, and collections.",
      "Payments Report": "Payments Report",
      payments_report_desc: "Analyze payments, refunds, and payment methods.",
      "Treatment Plans Report": "Treatment Plans Report",
      treatment_plans_report_desc:
        "Review plan totals, invoicing, and collection progress.",
      "Patients Report": "Patients Report",
      patients_report_desc:
        "See active patients, new registrations, and patient activity.",

      // ==================== Revenue Report ====================
      "Revenue Report": "Revenue Report",
      "Revenue analysis based on invoices, payments, refunds, and balances":
        "Revenue analysis based on invoices, payments, refunds, and balances",
      "Back to Reports": "Back to Reports",
      Print: "Print",
      "Export CSV": "Export CSV",
      Refresh: "Refresh",
      Filters: "Filters",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply Filters": "Apply Filters",
      "Total Invoiced": "Total Invoiced",
      "Gross Paid": "Gross Paid",
      Refunded: "Refunded",
      "Net Paid": "Net Paid",
      Remaining: "Remaining",
      "Report Summary": "Report Summary",
      Range: "Range",
      "This report is currently derived from the invoices listing response. It is ready to be switched later to a dedicated revenue-report API without changing the UI structure.":
        "This report is currently derived from the invoices listing response. It is ready to be switched later to a dedicated revenue-report API without changing the UI structure.",
      "Revenue Rows": "Revenue Rows",
      invoices: "invoices",
      "No revenue rows found.": "No revenue rows found.",
      Invoice: "Invoice",
      Customer: "Customer",
      Invoiced: "Invoiced",
      "Gross Paid": "Gross Paid",
      "Net Paid": "Net Paid",
      Status: "Status",
      Issued: "Issued",
      Paid: "Paid",
      Unpaid: "Unpaid",
      Cancelled: "Cancelled",
      "Partially Paid": "Partially Paid",
      "Failed to load revenue report.": "Failed to load revenue report.",

      // ==================== Clinic Settings  ====================
      "Clinic Settings": "Clinic Settings",
      "Manage clinic profile, invoice settings, and defaults":
        "Manage clinic profile, invoice settings, and defaults",
      Refresh: "Refresh",
      "Settings Form": "Settings Form",
      "Clinic Name": "Clinic Name",
      "My Clinic": "My Clinic",
      Phone: "Phone",
      Email: "Email",
      Currency: "Currency",
      Timezone: "Timezone",
      Language: "Language",
      "Invoice Prefix": "Invoice Prefix",
      "Invoice Start Number": "Invoice Start Number",
      "Save Settings": "Save Settings",
      Reset: "Reset",
      "Current Summary": "Current Summary",
      "Failed to load clinic settings.": "Failed to load clinic settings.",
      "Clinic settings updated successfully.":
        "Clinic settings updated successfully.",
      "Failed to update clinic settings.": "Failed to update clinic settings.",
      English: "English",
      Arabic: "Arabic",
      "Saving...": "Saving...",

      // ==================== Procedures  ====================
      Procedures: "Procedures",
      "Manage clinic procedures, default prices, and active status":
        "Manage clinic procedures, default prices, and active status",
      "Add Procedure": "Add Procedure",
      Refresh: "Refresh",
      Filters: "Filters",
      Search: "Search",
      "ID, procedure name, default price...":
        "ID, procedure name, default price...",
      Status: "Status",
      "All Statuses": "All Statuses",
      Active: "Active",
      Inactive: "Inactive",
      "Total Loaded": "Total Loaded",
      Filtered: "Filtered",
      "Clear Filters": "Clear Filters",
      "Procedures List": "Procedures List",
      procedures: "procedures",
      "No procedures found.": "No procedures found.",
      ID: "ID",
      Procedure: "Procedure",
      "Default Price": "Default Price",
      Created: "Created",
      Actions: "Actions",
      "Edit Procedure": "Edit Procedure",
      Edit: "Edit",
      Deactivate: "Deactivate",
      Activate: "Activate",
      "Saving...": "Saving...",
      "Failed to load procedures.": "Failed to load procedures.",
      'Activate procedure "{{name}}"?': 'Activate procedure "{{name}}"?',
      'Deactivate procedure "{{name}}"?': 'Deactivate procedure "{{name}}"?',
      "Procedure activated successfully.": "Procedure activated successfully.",
      "Procedure deactivated successfully.":
        "Procedure deactivated successfully.",
      "Failed to update procedure.": "Failed to update procedure.",

      // ==================== Edit Procedure  ====================
      "Edit Procedure": "Edit Procedure",
      "Add Procedure": "Add Procedure",
      "Manage procedure name, default price, and active status":
        "Manage procedure name, default price, and active status",
      "Back to Procedures": "Back to Procedures",
      Refresh: "Refresh",
      "Procedure Details": "Procedure Details",
      "New Procedure": "New Procedure",
      "Procedure Name": "Procedure Name",
      "e.g. Root Canal": "e.g. Root Canal",
      "Default Price": "Default Price",
      Status: "Status",
      Active: "Active",
      Inactive: "Inactive",
      Notes: "Notes",
      "Default Price is used when adding this procedure to a treatment plan. Existing treatment plan items keep their saved price and will not be changed automatically.":
        "Default Price is used when adding this procedure to a treatment plan. Existing treatment plan items keep their saved price and will not be changed automatically.",
      "Save Changes": "Save Changes",
      "Create Procedure": "Create Procedure",
      Cancel: "Cancel",
      "Failed to load procedure.": "Failed to load procedure.",
      "Procedure updated successfully.": "Procedure updated successfully.",
      "Procedure created successfully.": "Procedure created successfully.",
      "Failed to save procedure.": "Failed to save procedure.",
      "Saving...": "Saving...",
      "Creating...": "Creating...",
      "Supplier Statement": "Supplier Statement",
      "Loading statement...": "Loading statement...",
      "Back to Suppliers": "Back to Suppliers",
      "Date Range Filter": "Date Range Filter",
      "From Date": "From Date",
      "To Date": "To Date",
      "Apply Filters": "Apply Filters",
      Reset: "Reset",
      "Opening Balance": "Opening Balance",
      "Closing Balance": "Closing Balance",
      "Total Entries": "Total Entries",
      Period: "Period",
      All: "All",
      Today: "Today",
      "Statement Entries": "Statement Entries",
      entries: "entries",
      "No entries in this period": "No entries in this period",
      "Purchase Order": "Purchase Order",
      Payment: "Payment",
      Refund: "Refund",
      PO: "PO",
      Debit: "Debit",
      Credit: "Credit",
      Balance: "Balance",
      "Failed to load supplier statement": "Failed to load supplier statement",

      "Create Purchase Order": "Create Purchase Order",
      "Fill in the details to create a new purchase order":
        "Fill in the details to create a new purchase order",
      "Supplier Information": "Supplier Information",
      "Select Supplier": "Select Supplier",
      "Choose a supplier...": "Choose a supplier...",
      "Supplier selected": "Supplier selected",
      "Order Items": "Order Items",
      "Add Item": "Add Item",
      Product: "Product",
      Quantity: "Quantity",
      "Unit Cost": "Unit Cost",
      "Line Total": "Line Total",
      "Remove item": "Remove item",
      "Order Summary": "Order Summary",
      Supplier: "Supplier",
      "Total Items": "Total Items",
      "Grand Total": "Grand Total",
      "Not selected": "Not selected",
      "Choose supplier...": "Choose supplier...",
      "Select product...": "Select product...",
      Add: "Add",
      Item: "Item",
      Cancel: "Cancel",
      "Creating...": "Creating...",
      "Failed to load suppliers or products":
        "Failed to load suppliers or products",
      "Please select supplier": "Please select supplier",
      "Add at least one item with valid quantity and cost":
        "Add at least one item with valid quantity and cost",
      "Purchase order created": "Purchase order created",
      "Failed to create purchase order": "Failed to create purchase order",

      "Purchase Order": "Purchase Order",
      PO: "PO",
      Back: "Back",
      "Total Amount": "Total Amount",
      Paid: "Paid",
      Remaining: "Remaining",
      Received: "Received",
      Yes: "Yes",
      No: "No",
      "Receive Items": "Receive Items",
      "Add to stock": "Add to stock",
      "Make Payment": "Make Payment",
      Amount: "Amount",
      "Payment Method": "Payment Method",
      Cash: "Cash",
      Bank: "Bank",
      "Bank Transfer": "Bank Transfer",
      "Credit Card": "Credit Card",
      Card: "Card",
      "Pay Now": "Pay Now",
      "Processing...": "Processing...",
      "Order Items": "Order Items",
      Product: "Product",
      Quantity: "Quantity",
      "Unit Cost": "Unit Cost",
      "Line Total": "Line Total",
      Actions: "Actions",
      Returns: "Returns",
      Log: "Log",
      "Payment History": "Payment History",
      "Payment ID": "Payment ID",
      Method: "Method",
      Date: "Date",
      "No payments recorded yet": "No payments recorded yet",
      Supplier: "Supplier",
      "N/A": "N/A",
      Items: "Items",
      Payments: "Payments",
      "Enter amount": "Enter amount",
      "Receive this purchase order and add stock?":
        "Receive this purchase order and add stock?",
      "Received successfully": "Received successfully",
      "Receive failed": "Receive failed",
      "Enter valid amount": "Enter valid amount",
      "Payment recorded": "Payment recorded",
      "Payment failed": "Payment failed",
      "Failed to load purchase order": "Failed to load purchase order",
      "Purchase order not found": "Purchase order not found",
      "Go Back": "Go Back",
      Pending: "Pending",
      Confirmed: "Confirmed",
      Cancelled: "Cancelled",
      Delivered: "Delivered",
      Total: "Total",

      "Purchase Order Returns": "Purchase Order Returns",
      "Return items from purchase order": "Return items from purchase order",
      "Back to Order": "Back to Order",
      Product: "Product",
      Received: "Received",
      Returned: "Returned",
      "Available for Return": "Available for Return",
      "Return Quantity": "Return Quantity",
      Action: "Action",
      Return: "Return",
      "Return Item": "Return Item",
      Qty: "Qty",
      "Enter a valid quantity": "Enter a valid quantity",
      "Quantity exceeds the available return quantity":
        "Quantity exceeds the available return quantity",
      "Return recorded successfully": "Return recorded successfully",
      "Failed to process return": "Failed to process return",
      "Failed to load returnable items": "Failed to load returnable items",
      "No items available for return": "No items available for return",
      "Go Back": "Go Back",
      "Confirm Return": "Confirm Return",
      Available: "Available",
      Cancel: "Cancel",
      "Confirm Return": "Confirm Return",
      "Exceeds available quantity": "Exceeds available quantity",
      "No quantity available for return": "No quantity available for return",

      "Purchase Order Returns Log": "Purchase Order Returns Log",
      "Return history for purchase order": "Return history for purchase order",
      "Back to Order": "Back to Order",
      "Total Returns": "Total Returns",
      "Total Items Returned": "Total Items Returned",
      Product: "Product",
      "Returned Quantity": "Returned Quantity",
      "Date & Time": "Date & Time",
      "Return ID": "Return ID",
      Showing: "Showing",
      "return record": "return record",
      "Returns Log": "Returns Log",
      "No Returns Found": "No Returns Found",
      "This purchase order has no return records":
        "This purchase order has no return records",
      "Go Back": "Go Back",
      "Items Returned": "Items Returned",
      "No return records found": "No return records found",
      "N/A": "N/A",
      "Failed to load returns history": "Failed to load returns history",

      "Purchase Orders": "Purchase Orders",
      "Manage and track all purchase orders":
        "Manage and track all purchase orders",
      "New Purchase Order": "New Purchase Order",
      "Search by ID, supplier or status...":
        "Search by ID, supplier or status...",
      All: "All",
      Pending: "Pending",
      Confirmed: "Confirmed",
      Delivered: "Delivered",
      Cancelled: "Cancelled",
      "PO #": "PO #",
      Supplier: "Supplier",
      Total: "Total",
      Paid: "Paid",
      Remaining: "Remaining",
      Status: "Status",
      Actions: "Actions",
      "View details": "View details",
      "Edit order": "Edit order",
      Showing: "Showing",
      of: "of",
      orders: "orders",
      "Create new order": "Create new order",
      "Search orders...": "Search orders...",
      "No purchase orders found": "No purchase orders found",
      "Create New Order": "Create New Order",
      "Failed to fetch purchase orders": "Failed to fetch purchase orders",
      PO: "PO",
      "N/A": "N/A",

      // أضف ضمن كائن en:
      "Create New Order": "Create New Order",
      "Fill in the details to create a new order":
        "Fill in the details to create a new order",
      "Order Summary": "Order Summary",
      Items: "Items",
      Total: "Total",
      "Customer Details": "Customer Details",
      "Select Customer": "Select Customer",
      "Select a customer...": "Select a customer...",
      "Customer selected": "Customer selected",
      "Find Products": "Find Products",
      "Search products by name or ID...": "Search products by name or ID...",
      "Order Items": "Order Items",
      "Add New Item": "Add New Item",
      Product: "Product",
      "Unit Price": "Unit Price",
      Quantity: "Quantity",
      Subtotal: "Subtotal",
      Actions: "Actions",
      "Select product...": "Select product...",
      "Remove item": "Remove item",
      "Reset Form": "Reset Form",
      "Processing...": "Processing...",
      "Create Order": "Create Order",
      "Customer Information": "Customer Information",
      "Choose a customer": "Choose a customer",
      "Add Item": "Add Item",
      "Search products...": "Search products...",
      Item: "Item",
      "Select product": "Select product",
      "Number of items": "Number of items",
      Customer: "Customer",
      "Not selected": "Not selected",
      "Total Amount": "Total Amount",
      "Creating Order...": "Creating Order...",
      "Please select a customer": "Please select a customer",
      "Please select a product for all items":
        "Please select a product for all items",
      "Order created successfully": "Order created successfully",
      "Failed to create order": "Failed to create order",
      "N/A": "N/A",

      // أضف ضمن كائن en:
      "Order Details": "Order Details",
      Order: "Order",
      "Loading order details...": "Loading order details...",
      "Order not found": "Order not found",
      "Go Back": "Go Back",
      "Failed to load order": "Failed to load order",
      "Confirm this order and create invoice?":
        "Confirm this order and create invoice?",
      "Confirm failed": "Confirm failed",
      "Cancel this order and restore stock?":
        "Cancel this order and restore stock?",
      "Cancel failed": "Cancel failed",
      Print: "Print",
      "View Invoice": "View Invoice",
      Customer: "Customer",
      Date: "Date",
      "Total Amount": "Total Amount",
      "Customer Information": "Customer Information",
      Name: "Name",
      Email: "Email",
      Phone: "Phone",
      "Order Items": "Order Items",
      Product: "Product",
      Quantity: "Quantity",
      "Unit Price": "Unit Price",
      Total: "Total",
      "Order Actions": "Order Actions",
      "Confirm Order": "Confirm Order",
      "Cancel Order": "Cancel Order",
      "Order Confirmed": "Order Confirmed",
      "Order Cancelled": "Order Cancelled",
      "Confirm order and create invoice": "Confirm order and create invoice",
      "Cannot confirm order": "Cannot confirm order",
      "Cancel order and restore stock": "Cancel order and restore stock",
      "Cannot cancel order": "Cannot cancel order",
      "Invoice #{id} has been created": "Invoice #{id} has been created",
      "Stock has been restored": "Stock has been restored",
      "Confirm is disabled because": "Confirm is disabled because",
      "Order is not in pending status": "Order is not in pending status",
      "Order has no items": "Order has no items",
      "Invoice already exists (#{id})": "Invoice already exists (#{id})",
      "Order can be confirmed only when it's pending, has items, and no invoice exists.":
        "Order can be confirmed only when it's pending, has items, and no invoice exists.",
      Pending: "Pending",
      Confirmed: "Confirmed",
      Cancelled: "Cancelled",
      "Invoice Details": "Invoice Details",
      Invoice: "Invoice",
      "Invoice Status": "Invoice Status",
      "N/A": "N/A",

      // أضف ضمن كائن en:
      "Orders Management": "Orders Management",
      "Manage and track all customer orders":
        "Manage and track all customer orders",
      "New Order": "New Order",
      Orders: "Orders",
      All: "All",
      ID: "ID",
      Customer: "Customer",
      Total: "Total",
      Date: "Date",
      Actions: "Actions",
      "Confirm order": "Confirm order",
      "Cancel order": "Cancel order",
      "View details": "View details",
      "Edit order": "Edit order",
      "View order #{id}": "View order #{id}",
      "Confirm this order?": "Confirm this order?",
      "Cancel this order?": "Cancel this order?",
      Confirm: "Confirm",
      Cancel: "Cancel",
      Details: "Details",
      "No orders found": "No orders found",
      "No {status} orders found": "No {status} orders found",
      "Create New Order": "Create New Order",
      Showing: "Showing",
      of: "of",
      orders: "orders",
      "No Customer": "No Customer",
      "Failed to fetch orders": "Failed to fetch orders",
      "Confirm failed": "Confirm failed",
      "Cancel failed": "Cancel failed",
      "Loading orders...": "Loading orders...",
      Confirmed: "Confirmed",
      Pending: "Pending",
      Cancelled: "Cancelled",

      // أضف ضمن كائن en:
      "Dentist portrait": "Dentist portrait",
      "Female dentist": "Female dentist",
      "Dental examination": "Dental examination",
      "Expert Dental Care": "Expert Dental Care",
      "Professional dental services for your perfect smile":
        "Professional dental services for your perfect smile",
      "Modern Dental Clinic": "Modern Dental Clinic",
      "State-of-the-art equipment and comfortable environment":
        "State-of-the-art equipment and comfortable environment",
      "Comprehensive Check-ups": "Comprehensive Check-ups",
      "Regular dental examinations for optimal oral health":
        "Regular dental examinations for optimal oral health",
      smiles: "smiles",
      teeth: "teeth",
      lives: "lives",
      Better: "Better",
      "Welcome to our dental clinic! We provide comprehensive dental care with state-of-the-art technology and a gentle, caring approach. Your smile is our priority.":
        "Welcome to our dental clinic! We provide comprehensive dental care with state-of-the-art technology and a gentle, caring approach. Your smile is our priority.",
      "Our Services": "Our Services",
      "Book Appointment": "Book Appointment",
      "Our Dental Services": "Our Dental Services",
      "Comprehensive dental care for the whole family":
        "Comprehensive dental care for the whole family",
      "General Dentistry": "General Dentistry",
      "Regular check-ups, cleanings, and preventive care":
        "Regular check-ups, cleanings, and preventive care",
      "Cosmetic Dentistry": "Cosmetic Dentistry",
      "Teeth whitening, veneers, and smile makeovers":
        "Teeth whitening, veneers, and smile makeovers",
      "Pediatric Dentistry": "Pediatric Dentistry",
      "Gentle dental care for children": "Gentle dental care for children",
      "Root Canal Treatment": "Root Canal Treatment",
      "Pain-free root canal procedures": "Pain-free root canal procedures",

      // أضف ضمن كائن en:
      Home: "Home",
      About: "About",
      Timeline: "Timeline",
      Testimonials: "Testimonials",
      Booking: "Booking",
      Contact: "Contact",
      Login: "Login",
      Register: "Register",
      Logout: "Logout",
      Profile: "Profile",
      "My Appointments": "My Appointments",
      Account: "Account",
      "Dental Care": "Dental Care",
      "Smile Specialist": "Smile Specialist",
      "Toggle navigation": "Toggle navigation",
      العربية: "العربية",
      English: "English",

      // أضف ضمن كائن en:
      "Opening Hours": "Opening Hours",
      Sunday: "Sunday",
      Closed: "Closed",
      "Monday - Friday": "Monday - Friday",
      Saturday: "Saturday",
      "Our Clinic": "Our Clinic",
      "123 Dental Street, San Diego, CA 92123":
        "123 Dental Street, San Diego, CA 92123",
      "Follow Us": "Follow Us",
      Facebook: "Facebook",
      Twitter: "Twitter",
      Instagram: "Instagram",
      YouTube: "YouTube",
      "Quick Links": "Quick Links",
      "About Us": "About Us",
      "Book Appointment": "Book Appointment",
      Testimonials: "Testimonials",
      "Contact Us": "Contact Us",
      "Dental Care Clinic": "Dental Care Clinic",
      "All rights reserved.": "All rights reserved.",
      "Design by": "Design by",

      // أضف ضمن كائن en:
      "About Our Dental Clinic": "About Our Dental Clinic",
      "Your trusted partner in dental health and beautiful smiles":
        "Your trusted partner in dental health and beautiful smiles",
      "Our Mission": "Our Mission",
      "To provide exceptional dental care in a comfortable, caring environment while empowering patients with knowledge about their oral health.":
        "To provide exceptional dental care in a comfortable, caring environment while empowering patients with knowledge about their oral health.",
      "Our Vision": "Our Vision",
      "To be the leading dental clinic recognized for excellence in patient care, innovation, and creating confident smiles.":
        "To be the leading dental clinic recognized for excellence in patient care, innovation, and creating confident smiles.",
      "Our Values": "Our Values",
      "Integrity, compassion, excellence, and innovation guide everything we do.":
        "Integrity, compassion, excellence, and innovation guide everything we do.",
      "Meet Our Expert Dentists": "Meet Our Expert Dentists",
      "Our team of experienced professionals is dedicated to your smile":
        "Our team of experienced professionals is dedicated to your smile",
      Years: "Years",
      "Book Appointment": "Book Appointment",
      "Our Core Values": "Our Core Values",
      "The principles that guide our practice every day":
        "The principles that guide our practice every day",
      "Compassionate Care": "Compassionate Care",
      "We treat every patient with kindness, empathy, and understanding.":
        "We treat every patient with kindness, empathy, and understanding.",
      Excellence: "Excellence",
      "We strive for the highest quality in everything we do.":
        "We strive for the highest quality in everything we do.",
      "Patient-Centered": "Patient-Centered",
      "Your comfort and satisfaction are our top priorities.":
        "Your comfort and satisfaction are our top priorities.",
      Innovation: "Innovation",
      "We embrace the latest technology and techniques in dentistry.":
        "We embrace the latest technology and techniques in dentistry.",
      "Years of Experience": "Years of Experience",
      "Happy Patients": "Happy Patients",
      "Dental Procedures": "Dental Procedures",
      "Emergency Care": "Emergency Care",
      "Over 15 Years of Excellence in Dental Care":
        "Over 15 Years of Excellence in Dental Care",
      "Since 2008, we've been committed to providing the highest quality dental care to our community. Our continuous investment in education, technology, and patient comfort ensures you receive the best possible treatment.":
        "Since 2008, we've been committed to providing the highest quality dental care to our community. Our continuous investment in education, technology, and patient comfort ensures you receive the best possible treatment.",
      "Schedule Your Visit": "Schedule Your Visit",
      "Ready for a Healthier Smile?": "Ready for a Healthier Smile?",
      "Book your appointment today and let us help you achieve the smile you've always wanted.":
        "Book your appointment today and let us help you achieve the smile you've always wanted.",
      "Contact Us": "Contact Us",
      "Dr. Sarah Johnson": "Dr. Sarah Johnson",
      "General & Cosmetic Dentistry": "General & Cosmetic Dentistry",
      "Dr. Sarah is dedicated to providing gentle, comprehensive dental care with a focus on preventive treatments and patient education.":
        "Dr. Sarah is dedicated to providing gentle, comprehensive dental care with a focus on preventive treatments and patient education.",
      "Dr. Michael Chen": "Dr. Michael Chen",
      "Orthodontics & Pediatric Dentistry":
        "Orthodontics & Pediatric Dentistry",
      "Dr. Michael specializes in orthodontic treatments and children's dentistry, creating beautiful smiles for the whole family.":
        "Dr. Michael specializes in orthodontic treatments and children's dentistry, creating beautiful smiles for the whole family.",
      "Dr. Emily Rodriguez": "Dr. Emily Rodriguez",
      "Oral Surgery & Implantology": "Oral Surgery & Implantology",
      "Dr. Emily is an expert in dental implants and surgical procedures, ensuring comfortable and successful treatments.":
        "Dr. Emily is an expert in dental implants and surgical procedures, ensuring comfortable and successful treatments.",

      // أضف ضمن كائن en:
      "Book Your Dental Appointment": "Book Your Dental Appointment",
      "Schedule your visit with our expert dentists. We're here to help you achieve a healthy, beautiful smile.":
        "Schedule your visit with our expert dentists. We're here to help you achieve a healthy, beautiful smile.",
      "Appointment Request": "Appointment Request",
      "Fill out the form below and we'll confirm your appointment shortly.":
        "Fill out the form below and we'll confirm your appointment shortly.",
      "Appointment Request Sent!": "Appointment Request Sent!",
      "Thank you for choosing our dental clinic. We'll contact you shortly to confirm your appointment.":
        "Thank you for choosing our dental clinic. We'll contact you shortly to confirm your appointment.",
      "Back to Home": "Back to Home",
      "Full Name": "Full Name",
      "Enter your full name": "Enter your full name",
      "Email Address": "Email Address",
      "your@email.com": "your@email.com",
      "Phone Number": "Phone Number",
      "+1 234 567 8900": "+1 234 567 8900",
      "Service Required": "Service Required",
      "Select a service": "Select a service",
      "General Dentistry (Check-up, Cleaning)":
        "General Dentistry (Check-up, Cleaning)",
      "Cosmetic Dentistry (Whitening, Veneers)":
        "Cosmetic Dentistry (Whitening, Veneers)",
      "Orthodontic Treatment (Braces, Aligners)":
        "Orthodontic Treatment (Braces, Aligners)",
      "Root Canal Treatment": "Root Canal Treatment",
      "Dental Implants": "Dental Implants",
      "Pediatric Dentistry": "Pediatric Dentistry",
      "Emergency Dental Care": "Emergency Dental Care",
      "Preferred Doctor": "Preferred Doctor",
      "Dr. Sarah Johnson - General & Cosmetic":
        "Dr. Sarah Johnson - General & Cosmetic",
      "Dr. Michael Chen - Orthodontics": "Dr. Michael Chen - Orthodontics",
      "Dr. Emily Rodriguez - Oral Surgery":
        "Dr. Emily Rodriguez - Oral Surgery",
      "Any Available Doctor": "Any Available Doctor",
      "Preferred Date": "Preferred Date",
      "Preferred Time": "Preferred Time",
      "Select a time slot": "Select a time slot",
      "Additional Notes": "Additional Notes",
      "Any special requests or concerns?": "Any special requests or concerns?",
      "Scheduling...": "Scheduling...",
      "Book Appointment": "Book Appointment",
      Reset: "Reset",
      "Before Your Visit": "Before Your Visit",
      "Bring your insurance card and ID": "Bring your insurance card and ID",
      "Arrive 15 minutes before your appointment":
        "Arrive 15 minutes before your appointment",
      "Complete any required forms": "Complete any required forms",
      "List any medications you're taking":
        "List any medications you're taking",
      "Working Hours": "Working Hours",
      "Monday - Friday": "Monday - Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      Closed: "Closed",
      Emergency: "Emergency",
      "Contact Us": "Contact Us",
      "123 Dental Street, San Diego, CA 92123":
        "123 Dental Street, San Diego, CA 92123",

      // أضف ضمن كائن en:
      "What Our Patients Say": "What Our Patients Say",
      "Real stories from real patients about their experience at our dental clinic":
        "Real stories from real patients about their experience at our dental clinic",
      "Happy Patients": "Happy Patients",
      "Average Rating": "Average Rating",
      "Would Recommend": "Would Recommend",
      "Smiles Created": "Smiles Created",
      "Patient Testimonials": "Patient Testimonials",
      "Don't just take our word for it - hear from our amazing patients":
        "Don't just take our word for it - hear from our amazing patients",
      "Regular Patient": "Regular Patient",
      "Recovered Patient": "Recovered Patient",
      "New Patient": "New Patient",
      "Happy Patient": "Happy Patient",
      "Orthodontic Patient": "Orthodontic Patient",
      "Pediatric Patient's Mom": "Pediatric Patient's Mom",
      "Best Dental Care Experience": "Best Dental Care Experience",
      "I've been coming to this clinic for over 3 years and I couldn't be happier. The staff is incredibly friendly, and Dr. Sarah made my root canal procedure completely painless. Highly recommended!":
        "I've been coming to this clinic for over 3 years and I couldn't be happier. The staff is incredibly friendly, and Dr. Sarah made my root canal procedure completely painless. Highly recommended!",
      "Root Canal Treatment": "Root Canal Treatment",
      "Amazing Smile Transformation": "Amazing Smile Transformation",
      "After years of being embarrassed about my teeth, I finally decided to get veneers. Dr. Chen did an incredible job! My smile looks completely natural and I feel confident again. Thank you!":
        "After years of being embarrassed about my teeth, I finally decided to get veneers. Dr. Chen did an incredible job! My smile looks completely natural and I feel confident again. Thank you!",
      "Cosmetic Veneers": "Cosmetic Veneers",
      "Welcoming and Professional": "Welcoming and Professional",
      "As a new patient, I was nervous about my first visit. The team made me feel welcome from the moment I walked in. The facility is spotless, and Dr. Rodriguez explained everything clearly. I'm so glad I chose this clinic!":
        "As a new patient, I was nervous about my first visit. The team made me feel welcome from the moment I walked in. The facility is spotless, and Dr. Rodriguez explained everything clearly. I'm so glad I chose this clinic!",
      "Dental Cleaning & Check-up": "Dental Cleaning & Check-up",
      "Excellent Emergency Care": "Excellent Emergency Care",
      "I had a dental emergency on a Sunday and they saw me within an hour. The care was exceptional and the pain relief was immediate. Truly grateful for their emergency service!":
        "I had a dental emergency on a Sunday and they saw me within an hour. The care was exceptional and the pain relief was immediate. Truly grateful for their emergency service!",
      "Emergency Dental Care": "Emergency Dental Care",
      "Perfect Braces Results": "Perfect Braces Results",
      "My daughter just finished her braces treatment with Dr. Chen, and the results are amazing! The team was always patient and supportive throughout the entire process. We couldn't be happier with her smile!":
        "My daughter just finished her braces treatment with Dr. Chen, and the results are amazing! The team was always patient and supportive throughout the entire process. We couldn't be happier with her smile!",
      "Orthodontic Treatment": "Orthodontic Treatment",
      "Great with Kids!": "Great with Kids!",
      "My 5-year-old was terrified of the dentist, but Dr. Sarah made the experience fun and stress-free. Now my daughter actually looks forward to her dental visits! Thank you for being so patient with children.":
        "My 5-year-old was terrified of the dentist, but Dr. Sarah made the experience fun and stress-free. Now my daughter actually looks forward to her dental visits! Thank you for being so patient with children.",
      "Pediatric Dentistry": "Pediatric Dentistry",
      "Share Your Experience": "Share Your Experience",
      "Had a great experience with us? We'd love to hear about it!":
        "Had a great experience with us? We'd love to hear about it!",
      "Write a Review": "Write a Review",

      // أضف ضمن كائن en:
      "Our Journey": "Our Journey",
      "A timeline of our growth, milestones, and commitment to excellence in dental care":
        "A timeline of our growth, milestones, and commitment to excellence in dental care",
      "Year Established": "Year Established",
      "Years Combined Experience": "Years Combined Experience",
      "Happy Patients": "Happy Patients",
      "Awards & Recognitions": "Awards & Recognitions",
      "Our Timeline": "Our Timeline",
      "Milestones that shaped our dental clinic into what it is today":
        "Milestones that shaped our dental clinic into what it is today",
      "Key Achievements": "Key Achievements",
      "Looking Ahead": "Looking Ahead",
      "We're committed to continuous improvement and innovation in dental care. Our future plans include:":
        "We're committed to continuous improvement and innovation in dental care. Our future plans include:",
      "AI-Powered Diagnostics": "AI-Powered Diagnostics",
      "Implementing artificial intelligence for early detection of dental issues":
        "Implementing artificial intelligence for early detection of dental issues",
      "Tele-dentistry Services": "Tele-dentistry Services",
      "Virtual consultations and remote monitoring for patient convenience":
        "Virtual consultations and remote monitoring for patient convenience",
      "Dental Education Center": "Dental Education Center",
      "Community outreach and educational programs for oral health awareness":
        "Community outreach and educational programs for oral health awareness",
      "State-of-the-Art Dental Equipment": "State-of-the-Art Dental Equipment",
      "We invested in the latest digital imaging technology, including 3D CBCT scanners and intraoral cameras, allowing for more precise diagnoses and treatment planning.":
        "We invested in the latest digital imaging technology, including 3D CBCT scanners and intraoral cameras, allowing for more precise diagnoses and treatment planning.",
      "3D CBCT Scanner installed": "3D CBCT Scanner installed",
      "Intraoral cameras for all operatories":
        "Intraoral cameras for all operatories",
      "Digital smile design software": "Digital smile design software",
      "New Pediatric Wing Opening": "New Pediatric Wing Opening",
      "We opened a dedicated pediatric dentistry wing designed specifically for children, featuring a kid-friendly environment, entertainment systems, and specialized pediatric dentists.":
        "We opened a dedicated pediatric dentistry wing designed specifically for children, featuring a kid-friendly environment, entertainment systems, and specialized pediatric dentists.",
      "Child-friendly treatment rooms": "Child-friendly treatment rooms",
      "Sedation dentistry services": "Sedation dentistry services",
      "School outreach program launched": "School outreach program launched",
      "Expanded Orthodontic Services": "Expanded Orthodontic Services",
      "Dr. Michael Chen joined our team, bringing expertise in traditional braces and modern clear aligners. We now offer comprehensive orthodontic treatments for all ages.":
        "Dr. Michael Chen joined our team, bringing expertise in traditional braces and modern clear aligners. We now offer comprehensive orthodontic treatments for all ages.",
      "Clear aligner treatments available":
        "Clear aligner treatments available",
      "Early intervention orthodontics": "Early intervention orthodontics",
      "Retainer services": "Retainer services",
      "Emergency Dental Care 24/7": "Emergency Dental Care 24/7",
      "Launched our 24/7 emergency dental service to provide immediate care for dental emergencies, including severe toothaches, broken teeth, and dental trauma.":
        "Launched our 24/7 emergency dental service to provide immediate care for dental emergencies, including severe toothaches, broken teeth, and dental trauma.",
      "24/7 on-call dentists": "24/7 on-call dentists",
      "Emergency treatment within 1 hour": "Emergency treatment within 1 hour",
      "Pain management protocols": "Pain management protocols",
      "Dental Implant Center Established": "Dental Implant Center Established",
      "We established a dedicated dental implant center, bringing together specialists in oral surgery and restorative dentistry to provide comprehensive implant solutions.":
        "We established a dedicated dental implant center, bringing together specialists in oral surgery and restorative dentistry to provide comprehensive implant solutions.",
      "Same-day implant placement": "Same-day implant placement",
      "All-on-4 implant solutions": "All-on-4 implant solutions",
      "Implant-supported dentures": "Implant-supported dentures",
      "Clinic Founded": "Clinic Founded",
      "Our dental clinic opened its doors with a mission to provide exceptional, patient-centered dental care using the latest technology and techniques.":
        "Our dental clinic opened its doors with a mission to provide exceptional, patient-centered dental care using the latest technology and techniques.",
      "2 treatment rooms": "2 treatment rooms",
      "3 experienced dentists": "3 experienced dentists",
      "Comprehensive dental services": "Comprehensive dental services",

      // أضف ضمن كائن en:
      "Welcome Back": "Welcome Back",
      "Please login to your account": "Please login to your account",
      "Email Address": "Email Address",
      "Enter your email": "Enter your email",
      Password: "Password",
      "Enter your password": "Enter your password",
      "Remember me": "Remember me",
      "Forgot Password?": "Forgot Password?",
      "Login failed. Please check your email and password.":
        "Login failed. Please check your email and password.",
      "Logging in...": "Logging in...",
      "Don't have an account?": "Don't have an account?",
      "Sign up": "Sign up",
      "Hide password": "Hide password",
      "Show password": "Show password",
      "Expert Dentists": "Expert Dentists",
      "Modern Equipment": "Modern Equipment",
      "Pain-Free Treatments": "Pain-Free Treatments",

      // أضف ضمن كائن en:
      "Join Our Dental Family": "Join Our Dental Family",
      "Create an account to book appointments, view your dental records, and receive personalized care.":
        "Create an account to book appointments, view your dental records, and receive personalized care.",
      "Easy Appointment Booking": "Easy Appointment Booking",
      "Access Dental Records": "Access Dental Records",
      "Treatment Reminders": "Treatment Reminders",
      "Secure & Private": "Secure & Private",
      "Create Account": "Create Account",
      "Sign up to get started with your dental care journey":
        "Sign up to get started with your dental care journey",
      "Full Name": "Full Name",
      "Enter your full name": "Enter your full name",
      "Email Address": "Email Address",
      "Enter your email": "Enter your email",
      Password: "Password",
      "Create a password": "Create a password",
      "Confirm Password": "Confirm Password",
      "Confirm your password": "Confirm your password",
      "Password must be at least 6 characters":
        "Password must be at least 6 characters",
      "Passwords do not match": "Passwords do not match",
      "Registration successful! 🎉": "Registration successful! 🎉",
      "Registration failed": "Registration failed",
      "Creating account...": "Creating account...",
      "Already have an account?": "Already have an account?",
      "Sign in": "Sign in",
      "By creating an account, you agree to our":
        "By creating an account, you agree to our",
      "Terms of Service": "Terms of Service",
      and: "and",
      "Privacy Policy": "Privacy Policy",
      "Hide password": "Hide password",
      "Show password": "Show password",

      Notifications: "Notifications",
      "No new notifications": "No new notifications",
      "Alert acknowledged": "Alert acknowledged",
      "Failed to acknowledge alert": "Failed to acknowledge alert",
      "New alert received": "New alert received",

      // Notification priorities
      high: "High",
      medium: "Medium",
      low: "Low",

      // Notification messages
      "High failed reminders": "High failed reminders",
      "Reminders stuck in processing": "Reminders stuck in processing",
      "There are {{count}} failed reminders that need review":
        "There are {{count}} failed reminders that need review",
      "There are {{count}} reminders stuck for more than 10 minutes":
        "There are {{count}} reminders stuck for more than 10 minutes",

      Notifications: "Notifications",
      "Stay updated with important system alerts and reminders":
        "Stay updated with important system alerts and reminders",
      "Filter Notifications": "Filter Notifications",
      "Notifications List": "Notifications List",
      notifications: "notifications",
      "No notifications found.": "No notifications found.",
      Unread: "Unread",
      "High Priority": "High Priority",
      "Loading notifications...": "Loading notifications...",
      Priority: "Priority",
      Count: "Count",
      Code: "Code",
      Acknowledge: "Acknowledge",
      Normal: "Normal",

      "See All Notifications": "See All Notifications",

      Today: "Today",
      Yesterday: "Yesterday",
      "days ago": "days ago",
      ago: "ago",
      "No high priority notifications": "No high priority notifications",
      "No unread notifications!": "🎉 No unread notifications!",
      "No more notifications": "No more notifications",

      // أضف ضمن كائن en:
      Radiology: "Radiology",
      "Radiology Images": "Radiology Images",
      "X-Ray": "X-Ray",
      Panorama: "Panorama",
      CBCT: "CBCT",
      Cephalometric: "Cephalometric",
      Other: "Other",
      "Click or drag file to upload": "Click or drag file to upload",
      "Upload Radiology": "Upload Radiology",
      "Uploading...": "Uploading...",
      "e.g., Pre-op X-Ray": "e.g., Pre-op X-Ray",
      "File Type": "File Type",
      "Captured At": "Captured At",
      "Additional notes about this image...":
        "Additional notes about this image...",
      "No radiology images found": "No radiology images found",
      "Upload X-rays, Panorama, or CBCT images for this patient":
        "Upload X-rays, Panorama, or CBCT images for this patient",
      "Loading images...": "Loading images...",
      "Are you sure you want to delete this image?":
        "Are you sure you want to delete this image?",
      "Image Gallery": "Image Gallery",
      "Upload New": "Upload New",

      "Analytics Overview": "Analytics Overview",
      "Real-time insights at a glance": "Real-time insights at a glance",
      "Revenue Overview": "Revenue Overview",
      Today: "Today",
      Month: "Month",
      Total: "Total",
      Completed: "Completed",
      Cancelled: "Cancelled",
      "No data available": "No data available",
      appointments: "appointments",

      critical: "Critical",
      attention: "Attention",
      info: "Info",
      "View Details": "View Details",
      "Acknowledge All": "Acknowledge All",
      Acknowledge: "Acknowledge",

      day: "Day",
      week: "Week",
      month: "Month",
      Revenue: "Revenue",
      Appointments: "Appointments",
      Completed: "Completed",
      Cancelled: "Cancelled",
      "No Show": "No Show",
      "Unpaid Invoices": "Unpaid Invoices",
      "Paid Invoices": "Paid Invoices",
      "New Patients": "New Patients",
      "vs previous": "vs previous",
      "Reset View": "Reset View",

      "Smart Summary": "Smart Summary",
      summary_revenue_up:
        "Revenue increased significantly compared to last period",
      summary_revenue_down: "Revenue dropped compared to last period",
      summary_appointments_up: "Appointments are growing rapidly",
      summary_no_show_high: "No-show count is high today",
      summary_unpaid_high: "You have a high number of unpaid invoices",
      summary_cancelled_up: "Cancellation rate is high today",

      "Current Period": "Current Period",
      "Previous Period": "Previous Period",
      "Anomaly Detected": "Anomaly Detected",
      "Revenue Overview": "Revenue Overview",
      "Appointments Overview": "Appointments Overview",
      "Total Appointments": "Total Appointments",
      Completed: "Completed",
      Cancelled: "Cancelled",
      Current: "Current",
      Previous: "Previous",
      Change: "Change",
      Total: "Total",
      "vs previous": "vs previous",
      day: "Day",
      week: "Week",
      month: "Month",

      "Compare with previous period": "Compare with previous period",

      Global: "Global",
      "All Companies": "All Companies",
      Active: "Active",
      Trial: "Trial",
      Suspended: "Suspended",

      "SaaS Management Dashboard": "SaaS Management Dashboard",
      "Monitor and manage all clinics from one place":
        "Monitor and manage all clinics from one place",
      "Total Companies": "Total Companies",
      "Active Companies": "Active Companies",
      "Trial Companies": "Trial Companies",
      MRR: "MRR",
      "Total Revenue": "Total Revenue",
      "Suspended Companies": "Suspended Companies",
      "vs last period": "vs last period",
      "vs last month": "vs last month",
      "of total": "of total",
      "Monthly Recurring Revenue (MRR)": "Monthly Recurring Revenue (MRR)",
      "Companies Growth": "Companies Growth",
      New: "New",
      Churned: "Churned",
      "New Companies": "New Companies",
      "Churned Companies": "Churned Companies",
      "Companies by Status": "Companies by Status",
      "Top Performing Clinics": "Top Performing Clinics",
      appts: "appts",
      "Quick Actions": "Quick Actions",
      "Manage your platform efficiently": "Manage your platform efficiently",
      "Add New Company": "Add New Company",
      "Manage Companies": "Manage Companies",
      "Manage Plans": "Manage Plans",
      "SaaS Reports": "SaaS Reports",
      "Recent Companies": "Recent Companies",
      "View All": "View All",
      Company: "Company",
      Status: "Status",
      Created: "Created",
      "Trial Ends": "Trial Ends",
      "Recent Activities": "Recent Activities",
      "No recent companies": "No recent companies",
      "No recent activities": "No recent activities",
      "No data available": "No data available",
      Active: "Active",
      Trial: "Trial",
      Suspended: "Suspended",
      Cancelled: "Cancelled",
      Month: "Month",
      Net: "Net",
      "Loading SaaS Dashboard...": "Loading SaaS Dashboard...",
      "Something went wrong": "Something went wrong",
      "Try Again": "Try Again",
      "Good Morning": "Good Morning",
      "Good Afternoon": "Good Afternoon",
      "Good Evening": "Good Evening",
      day: "Day",
      week: "Week",
      month: "Month",
      year: "Year",
      company_created: "New company registered",
      company_activated: "Company activated",
      company_suspended: "Company suspended",
      subscription_created: "New subscription created",
      payment_received: "Payment received",
      trial_started: "Trial started",
      trial_expired: "Trial expired",

      Companies: "Companies",
      "Manage all clinics on your platform":
        "Manage all clinics on your platform",
      "Add New Company": "Add New Company",
      "Search by name or slug...": "Search by name or slug...",
      "All Status": "All Status",
      Active: "Active",
      Trial: "Trial",
      Suspended: "Suspended",
      Cancelled: "Cancelled",
      Refresh: "Refresh",
      Company: "Company",
      Slug: "Slug",
      Status: "Status",
      Created: "Created",
      "Trial Ends": "Trial Ends",
      Users: "Users",
      Actions: "Actions",
      "No companies found": "No companies found",
      View: "View",
      Edit: "Edit",
      Suspend: "Suspend",
      Activate: "Activate",
      Delete: "Delete",
      "Page {{current}} of {{total}}": "Page {{current}} of {{total}}",
      "Loading companies...": "Loading companies...",
      "Something went wrong": "Something went wrong",
      "Try Again": "Try Again",
      "Company suspended successfully": "Company suspended successfully",
      "Company activated successfully": "Company activated successfully",
      "Company deleted successfully": "Company deleted successfully",
      "Are you sure you want to suspend {{name}}?":
        "Are you sure you want to suspend {{name}}?",
      "Are you sure you want to activate {{name}}?":
        "Are you sure you want to activate {{name}}?",
      "Are you sure you want to delete {{name}}? This action cannot be undone.":
        "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "{{days}} days left": "{{days}} days left",
      Expired: "Expired",

      "Edit Company": "Edit Company",
      "Add New Company": "Add New Company",
      "Update company information": "Update company information",
      "Create a new clinic on your platform":
        "Create a new clinic on your platform",
      "Basic Information": "Basic Information",
      "Company Name": "Company Name",
      "Enter company name": "Enter company name",
      Slug: "Slug",
      Check: "Check",
      "Slug is available": "Slug is available",
      "Slug is already taken": "Slug is already taken",
      "Company Email": "Company Email",
      "Company Phone": "Company Phone",
      Address: "Address",
      "Enter company address": "Enter company address",
      "Contact Person": "Contact Person",
      "Primary contact name": "Primary contact name",
      "Status Information": "Status Information",
      Status: "Status",
      Trial: "Trial",
      Active: "Active",
      Suspended: "Suspended",
      Cancelled: "Cancelled",
      "Trial Ends At": "Trial Ends At",
      "Admin Account": "Admin Account",
      "Create the first admin user for this company":
        "Create the first admin user for this company",
      "Admin Name": "Admin Name",
      "Enter admin full name": "Enter admin full name",
      "Admin Email": "Admin Email",
      "Admin Password": "Admin Password",
      "Minimum 8 characters": "Minimum 8 characters",
      "Company name is required": "Company name is required",
      "Slug is required": "Slug is required",
      "Admin name is required": "Admin name is required",
      "Admin email is required": "Admin email is required",
      "Admin password is required": "Admin password is required",
      Cancel: "Cancel",
      "Saving...": "Saving...",
      "Update Company": "Update Company",
      "Create Company": "Create Company",
      "Loading company data...": "Loading company data...",
      "Company created successfully": "Company created successfully",
      "Company updated successfully": "Company updated successfully",
      "Failed to create company": "Failed to create company",
      "Failed to update company": "Failed to update company",

      "Company Details": "Company Details",
      "Loading company details...": "Loading company details...",
      "Company suspended successfully": "Company suspended successfully",
      "Company activated successfully": "Company activated successfully",
      "Company deleted successfully": "Company deleted successfully",
      "Are you sure you want to suspend this company?":
        "Are you sure you want to suspend this company?",
      "Are you sure you want to activate this company?":
        "Are you sure you want to activate this company?",
      "Are you sure you want to delete this company? This action cannot be undone.":
        "Are you sure you want to delete this company? This action cannot be undone.",
      "Total Users": "Total Users",
      "Total Patients": "Total Patients",
      "Total Appointments": "Total Appointments",
      "Total Revenue": "Total Revenue",
      MRR: "MRR",
      "Outstanding Invoices": "Outstanding Invoices",
      "Company Information": "Company Information",
      Email: "Email",
      Phone: "Phone",
      Address: "Address",
      "Contact Person": "Contact Person",
      Created: "Created",
      "Trial Ends": "Trial Ends",
      Overview: "Overview",
      Users: "Users",
      Subscriptions: "Subscriptions",
      "Activity Logs": "Activity Logs",
      "Recent Performance": "Recent Performance",
      "Appointments This Month": "Appointments This Month",
      "Revenue This Month": "Revenue This Month",
      "New Patients This Month": "New Patients This Month",
      "No users found": "No users found",
      Name: "Name",
      Role: "Role",
      Active: "Active",
      Inactive: "Inactive",
      "No subscriptions found": "No subscriptions found",
      Plan: "Plan",
      Amount: "Amount",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "No activity logs found": "No activity logs found",
      created: "Created",
      updated: "Updated",
      deleted: "Deleted",
      suspended: "Suspended",
      activated: "Activated",

      "Plans & Pricing": "Plans & Pricing",
      "Manage subscription plans for your platform":
        "Manage subscription plans for your platform",
      "Add New Plan": "Add New Plan",
      "Loading plans...": "Loading plans...",
      "Plan created successfully": "Plan created successfully",
      "Plan updated successfully": "Plan updated successfully",
      "Plan deleted successfully": "Plan deleted successfully",
      "Plan status updated": "Plan status updated",
      "Failed to create plan": "Failed to create plan",
      "Failed to update plan": "Failed to update plan",
      "Are you sure you want to delete {{name}}?":
        "Are you sure you want to delete {{name}}?",
      Inactive: "Inactive",
      month: "month",
      year: "year",
      "Up to {{count}} users": "Up to {{count}} users",
      "Unlimited users": "Unlimited users",
      "Up to {{count}} patients": "Up to {{count}} patients",
      "Up to {{count}} appointments/month":
        "Up to {{count}} appointments/month",
      Edit: "Edit",
      Disable: "Disable",
      Enable: "Enable",
      "Edit Plan": "Edit Plan",
      "Plan Name (English)": "Plan Name (English)",
      "Plan Name (Arabic)": "Plan Name (Arabic)",
      "Description (English)": "Description (English)",
      "Description (Arabic)": "Description (Arabic)",
      "Monthly Price (EGP)": "Monthly Price (EGP)",
      "Yearly Price (EGP)": "Yearly Price (EGP)",
      "Max Users": "Max Users",
      "Max Patients": "Max Patients",
      "Max Appointments per Month": "Max Appointments per Month",
      Unlimited: "Unlimited",
      "Features (comma separated)": "Features (comma separated)",
      "Active (available for new subscriptions)":
        "Active (available for new subscriptions)",
      "Create Plan": "Create Plan",
      "Update Plan": "Update Plan",

      Subscriptions: "Subscriptions",
      "Manage all company subscriptions": "Manage all company subscriptions",
      "Add Subscription": "Add Subscription",
      "Loading subscriptions...": "Loading subscriptions...",
      "Search by company or plan...": "Search by company or plan...",
      "All Status": "All Status",
      Pending: "Pending",
      Expired: "Expired",
      Company: "Company",
      Plan: "Plan",
      Amount: "Amount",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Payment Method": "Payment Method",
      "Transaction ID": "Transaction ID",
      "No subscriptions found": "No subscriptions found",
      Renew: "Renew",
      Cancel: "Cancel",
      "Subscription created successfully": "Subscription created successfully",
      "Subscription updated successfully": "Subscription updated successfully",
      "Subscription cancelled successfully":
        "Subscription cancelled successfully",
      "Subscription renewed successfully": "Subscription renewed successfully",
      "Failed to create subscription": "Failed to create subscription",
      "Failed to update subscription": "Failed to update subscription",
      "Are you sure you want to cancel this subscription?":
        "Are you sure you want to cancel this subscription?",
      "Are you sure you want to renew this subscription?":
        "Are you sure you want to renew this subscription?",
      "Edit Subscription": "Edit Subscription",
      "Select Company": "Select Company",
      "Select Plan": "Select Plan",
      "Amount (EGP)": "Amount (EGP)",
      "Cash, Card, Transfer...": "Cash, Card, Transfer...",
      Optional: "Optional",
      Notes: "Notes",
      "Additional notes...": "Additional notes...",
      "Create Subscription": "Create Subscription",
      "Update Subscription": "Update Subscription",

      "SaaS Reports": "SaaS Reports",
      "Analytics and insights for your platform":
        "Analytics and insights for your platform",
      Export: "Export",
      Overview: "Overview",
      Revenue: "Revenue",
      Growth: "Growth",
      Churn: "Churn",
      "Top Companies": "Top Companies",
      "Total Companies": "Total Companies",
      "Active Companies": "Active Companies",
      "Avg Revenue/Company": "Avg Revenue/Company",
      "Churn Rate": "Churn Rate",
      "Revenue Trend": "Revenue Trend",
      "Companies Growth": "Companies Growth",
      New: "New",
      Churned: "Churned",
      Net: "Net",
      "Plans Distribution": "Plans Distribution",
      "Companies by Status": "Companies by Status",
      "Total Revenue": "Total Revenue",
      ARR: "ARR",
      "Avg Transaction": "Avg Transaction",
      "Revenue Breakdown": "Revenue Breakdown",
      Subscriptions: "Subscriptions",
      "Net Growth": "Net Growth",
      "New Companies": "New Companies",
      "Churned Companies": "Churned Companies",
      "Monthly Growth": "Monthly Growth",
      "Retention Rate": "Retention Rate",
      "Avg Lifetime (months)": "Avg Lifetime (months)",
      "Churn Trend": "Churn Trend",
      "Top Performing Companies": "Top Performing Companies",
      "Recent Activity": "Recent Activity",
      "Loading reports...": "Loading reports...",
      "No data available": "No data available",

      "Platform Settings": "Platform Settings",
      "Configure your SaaS platform settings":
        "Configure your SaaS platform settings",
      General: "General",
      Branding: "Branding",
      Email: "Email",
      Notifications: "Notifications",
      Maintenance: "Maintenance",
      Security: "Security",
      API: "API",
      "General Settings": "General Settings",
      "Platform Name": "Platform Name",
      "Platform Email": "Platform Email",
      "Platform Phone": "Platform Phone",
      "Platform Address": "Platform Address",
      "Enter platform address": "Enter platform address",
      "Default Language": "Default Language",
      "Default Timezone": "Default Timezone",
      "Default Currency": "Default Currency",
      "Date Format": "Date Format",
      "Time Format": "Time Format",
      "Branding Settings": "Branding Settings",
      Logo: "Logo",
      Favicon: "Favicon",
      "Primary Color": "Primary Color",
      "Secondary Color": "Secondary Color",
      "Accent Color": "Accent Color",
      "Email Settings": "Email Settings",
      Mailer: "Mailer",
      "SMTP Host": "SMTP Host",
      "SMTP Port": "SMTP Port",
      "SMTP Username": "SMTP Username",
      "SMTP Password": "SMTP Password",
      Encryption: "Encryption",
      "From Address": "From Address",
      "From Name": "From Name",
      "Notification Settings": "Notification Settings",
      "Enable Email Notifications": "Enable Email Notifications",
      "Enable SMS Notifications": "Enable SMS Notifications",
      "Enable Push Notifications": "Enable Push Notifications",
      "Admin Notifications": "Admin Notifications",
      "New Company Registration": "New Company Registration",
      "New Subscription Created": "New Subscription Created",
      "Payment Received": "Payment Received",
      "Trial Ending Soon": "Trial Ending Soon",
      "Maintenance Settings": "Maintenance Settings",
      "Enable Maintenance Mode": "Enable Maintenance Mode",
      "Maintenance Message": "Maintenance Message",
      "We'll be back soon!": "We'll be back soon!",
      "Allowed IP Addresses": "Allowed IP Addresses",
      "One IP per line": "One IP per line",
      "These IPs can access the site during maintenance":
        "These IPs can access the site during maintenance",
      "Security Settings": "Security Settings",
      "Max Login Attempts": "Max Login Attempts",
      "Lockout Duration (minutes)": "Lockout Duration (minutes)",
      "Session Lifetime (minutes)": "Session Lifetime (minutes)",
      "Password Expiry (days)": "Password Expiry (days)",
      "Require Two-Factor Authentication for Admins":
        "Require Two-Factor Authentication for Admins",
      "API Settings": "API Settings",
      "Enable Public API": "Enable Public API",
      "Rate Limit (requests per minute)": "Rate Limit (requests per minute)",
      "Webhook URL": "Webhook URL",
      "Webhook Secret": "Webhook Secret",
      "Save Changes": "Save Changes",
      "Settings saved successfully": "Settings saved successfully",
      "Failed to save settings": "Failed to save settings",
      "Loading settings...": "Loading settings...",

      "Activity Logs": "Activity Logs",
      "Monitor all activities across your platform":
        "Monitor all activities across your platform",
      Refresh: "Refresh",
      "Loading activity logs...": "Loading activity logs...",
      "Search by action, user, or subject...":
        "Search by action, user, or subject...",
      "All Actions": "All Actions",
      "Company Created": "Company Created",
      "Company Updated": "Company Updated",
      "Company Deleted": "Company Deleted",
      "Company Activated": "Company Activated",
      "Company Suspended": "Company Suspended",
      "User Created": "User Created",
      "User Updated": "User Updated",
      "User Deleted": "User Deleted",
      "Product Created": "Product Created",
      "Product Updated": "Product Updated",
      "Product Deleted": "Product Deleted",
      "Invoice Created": "Invoice Created",
      "Invoice Updated": "Invoice Updated",
      "Payment Created": "Payment Created",
      "Appointment Created": "Appointment Created",
      "Appointment Updated": "Appointment Updated",
      "No activity logs found": "No activity logs found",
      "View Details": "View Details",
      "Page {{current}} of {{total}}": "Page {{current}} of {{total}}",
      "Something went wrong": "Something went wrong",
      "Try Again": "Try Again",

      "Billing & Subscription": "Billing & Subscription",
      "Manage your subscription and payment methods":
        "Manage your subscription and payment methods",
      "Current Plan": "Current Plan",
      "No Active Plan": "No Active Plan",
      Started: "Started",
      "Renews on": "Renews on",
      "days left": "days left",
      "Change Plan": "Change Plan",
      "Cancel Subscription": "Cancel Subscription",
      "You don't have an active subscription":
        "You don't have an active subscription",
      "Choose a Plan": "Choose a Plan",
      "Payment Methods": "Payment Methods",
      "Add Payment Method": "Add Payment Method",
      Default: "Default",
      Expires: "Expires",
      "Billing History": "Billing History",
      Invoice: "Invoice",
      Date: "Date",
      Amount: "Amount",
      "No billing history": "No billing history",
      "Choose Your Plan": "Choose Your Plan",
      Monthly: "Monthly",
      Yearly: "Yearly",
      "Save 20%": "Save 20%",
      mo: "mo",
      yr: "yr",
      Current: "Current",
      "Processing...": "Processing...",
      Subscribe: "Subscribe",
      "Loading billing information...": "Loading billing information...",
      "Subscription updated successfully": "Subscription updated successfully",
      "Failed to update subscription": "Failed to update subscription",
      "Subscription cancelled successfully":
        "Subscription cancelled successfully",
      "Failed to cancel subscription": "Failed to cancel subscription",
      "Payment method added successfully": "Payment method added successfully",
      "Payment method removed": "Payment method removed",
      "Are you sure you want to cancel your subscription?":
        "Are you sure you want to cancel your subscription?",

      "Cardholder Name": "Cardholder Name",
      "John Doe": "John Doe",
      "Card Number": "Card Number",
      "Expiry Month": "Expiry Month",
      "Expiry Year": "Expiry Year",
      CVC: "CVC",
      "Set as default payment method": "Set as default payment method",
      "Add Card": "Add Card",
      "Processing...": "Processing...",
      "Payment method added successfully": "Payment method added successfully",
      "Failed to add payment method": "Failed to add payment method",
      Cancel: "Cancel",

      "Active Subscriptions": "Active Subscriptions",
      "Churn Rate": "Churn Rate",
      "Avg Revenue/Company": "Avg Revenue/Company",
      "this month": "this month",
      "Recent Transactions": "Recent Transactions",
      Invoice: "Invoice",
      Company: "Company",
      Amount: "Amount",
      Date: "Date",
      "No recent transactions": "No recent transactions",
      "subscription.created": "Subscription Created",
      "subscription.cancelled": "Subscription Cancelled",
      "subscription.changed": "Subscription Changed",
      "payment.received": "Payment Received",

      "All Branches": "All Branches",
      Branches: "Branches",

      "Full Name": "Full Name",
      "Email Address": "Email Address",
      "Create Employee": "Create Employee",
      "Edit Employee": "Edit Employee",
      "Failed to load employee.": "Failed to load employee.",

      "Print Invoice": "Print Invoice",
      INVOICE: "INVOICE",
      "Dental Clinic": "Dental Clinic",
      "Phone:": "Phone:",
      "Email:": "Email:",
      "Patient:": "Patient:",
      "Date:": "Date:",
      "Status:": "Status:",
      Item: "Item",
      "Unit Price": "Unit Price",
      Subtotal: "Subtotal",
      Discount: "Discount",
      "Thank you for your trust!": "Thank you for your trust!",
      "This invoice was generated electronically.":
        "This invoice was generated electronically.",
      "Invoice not found": "Invoice not found",
      "No items found": "No items found",
      "Go Back": "Go Back",
      Print: "Print",
      "Print Purchase Order": "Print Purchase Order",
      "PURCHASE ORDER": "PURCHASE ORDER",
      "Supplier:": "Supplier:",
      Supply: "Supply",
      "Unit Cost": "Unit Cost",
      "Total Paid": "Total Paid",
      Remaining: "Remaining",
      "Thank you for your business!": "Thank you for your business!",
      "This purchase order was generated electronically.":
        "This purchase order was generated electronically.",
      "Purchase order not found": "Purchase order not found",
      "Supplier Statement": "Supplier Statement",
      "Supplier Statement:": "Supplier Statement:",
      "Account movements and balance": "Account movements and balance",
      From: "From",
      To: "To",
      Clear: "Clear",
      "Opening Balance": "Opening Balance",
      "Closing Balance": "Closing Balance",
      Supplier: "Supplier",
      "Account Movements": "Account Movements",
      entries: "entries",
      Description: "Description",
      Type: "Type",
      Debit: "Debit",
      Credit: "Credit",
      Balance: "Balance",
      "No entries found.": "No entries found.",
      "Failed to load supplier statement.":
        "Failed to load supplier statement.",
      Supplies: "Supplies",
      "Manage clinic supplies and stock": "Manage clinic supplies and stock",
      "Add Supply": "Add Supply",
      "Supplies List": "Supplies List",
      supplies: "supplies",
      "No supplies found.": "No supplies found.",
      Name: "Name",
      SKU: "SKU",
      "In Stock": "In Stock",
      "Edit Supply": "Edit Supply",
      "Delete Supply": "Delete Supply",
      'Are you sure you want to delete "{{name}}"?':
        'Are you sure you want to delete "{{name}}"?',
      "Supply deleted successfully.": "Supply deleted successfully.",
      "Failed to delete supply.": "Failed to delete supply.",
      "Failed to load supplies.": "Failed to load supplies.",
      "Manage supply details, cost, and stock":
        "Manage supply details, cost, and stock",
      "Back to Supplies": "Back to Supplies",
      "Supply Details": "Supply Details",
      "New Supply": "New Supply",
      "Stock Quantity": "Stock Quantity",
      Category: "Category",
      "-- Select Category --": "-- Select Category --",
      "-- Select Supplier --": "-- Select Supplier --",
      "Save Changes": "Save Changes",
      "Create Supply": "Create Supply",
      "Saving...": "Saving...",
      "Creating...": "Creating...",
      Cancel: "Cancel",
      "Supply updated successfully.": "Supply updated successfully.",
      "Supply created successfully.": "Supply created successfully.",
      "Failed to save supply.": "Failed to save supply.",
      "ID, name, SKU, unit cost...": "ID, name, SKU, unit cost...",
      "Create Purchase Order": "Create Purchase Order",
      "View Purchase Orders": "View Purchase Orders",
      Retry: "Retry",
      Back: "Back",
      "Loading...": "Loading...",

      "Purchase Total": "Purchase Total",
      "Orders Count": "Orders Count",
      "Paid to Suppliers": "Paid to Suppliers",
      "Remaining to Pay": "Remaining to Pay",
      Purchases: "Purchases",
      "Monitor your procurement and supplier payments":
        "Monitor your procurement and supplier payments",
      "Recent Purchase Orders": "Recent Purchase Orders",
      "No recent purchase orders.": "No recent purchase orders.",
      "PO #": "PO #",
      Paid: "Paid",
      "Low Stock Supplies": "Low Stock Supplies",
      "Inventory Value": "Inventory Value",
      Inventory: "Inventory",
      "Stock levels and inventory valuation":
        "Stock levels and inventory valuation",
      "Purchase Returns": "Purchase Returns",
      "Net Purchases": "Net Purchases",

      "Financial Overview": "Financial Overview",
      "Key financial health indicators": "Key financial health indicators",
      "Net Profit": "Net Profit",
      "Outstanding Receivables": "Outstanding Receivables",
      "Outstanding Payables": "Outstanding Payables",
      "Purchase Balance": "Purchase Balance",

      "Max Branches": "Max Branches",
      "Up to {{count}} branches": "Up to {{count}} branches",
      "You have reached the maximum number of branches allowed by your plan.":
        "You have reached the maximum number of branches allowed by your plan.",

      Branches: "Branches",
      "Manage clinic branches": "Manage clinic branches",
      "Add Branch": "Add Branch",
      "Branches List": "Branches List",
      branches: "branches",
      "No branches found.": "No branches found.",
      "Edit Branch": "Edit Branch",
      "Delete Branch": "Delete Branch",
      'Are you sure you want to delete branch "{{name}}"?':
        'Are you sure you want to delete branch "{{name}}"?',
      "Branch deleted successfully.": "Branch deleted successfully.",
      "Failed to delete branch.": "Failed to delete branch.",
      "Failed to load branches.": "Failed to load branches.",
      "New Branch": "New Branch",
      "Branch Details": "Branch Details",
      Slug: "Slug",
      "Save Changes": "Save Changes",
      "Create Branch": "Create Branch",
      "Branch updated successfully.": "Branch updated successfully.",
      "Branch created successfully.": "Branch created successfully.",
      "You have reached the maximum number of branches allowed by your plan.":
        "You have reached the maximum number of branches allowed by your plan.",
      "Up to {{count}} branches": "Up to {{count}} branches",
      "Max Branches": "Max Branches",
      "Subscribe Now": "Subscribe Now",

      "Print Invoice": "Print Invoice",
      "Subscription Invoice": "Subscription Invoice",
      Description: "Description",
      "Tax (14%)": "Tax (14%)",
      "Thank you for your subscription!": "Thank you for your subscription!",
      "This invoice was generated electronically.":
        "This invoice was generated electronically.",
      "Failed to load invoice.": "Failed to load invoice.",
      "Invoice not found": "Invoice not found",
      "Paid At": "Paid At",
    },
  },
  ar: {
    translation: {
      // AdminNavbar
      "ERP System": "نظام تخطيط الموارد",
      "Clinic Admin Panel": "لوحة تحكم العيادة",
      Logout: "تسجيل خروج",
      "Super Admin": "مدير عام",
      Admin: "مدير",

      // ErpNav
      "ERP Navigation": "قائمة النظام",
      Dashboard: "الرئيسية",
      "Start Visit": "بدء زيارة",
      Doctors: "الأطباء",
      Procedures: "الإجراءات",
      Patients: "المرضى",
      Appointments: "المواعيد",
      "Treatment Plans": "خطط العلاج",
      "Dental Records": "السجلات السنية",
      Invoices: "الفواتير",
      Orders: "الطلبات",
      "Purchase Orders": "أوامر الشراء",
      Reports: "التقارير",
      "Clinic Settings": "إعدادات العيادة",
      // ErpDashboardHome - Header & Messages
      "Failed to load ERP dashboard.": "فشل تحميل لوحة التحكم",
      Retry: "إعادة المحاولة",
      "No dashboard data available.": "لا توجد بيانات متاحة",
      "ERP Dashboard": "لوحة تحكم النظام",
      "Clinic operations, billing, and payment overview":
        "نظرة عامة على عمليات العيادة والفواتير والمدفوعات",
      Refresh: "تحديث",
      // ErpDashboardHome - KPIs
      Appointments: "المواعيد",
      "Scheduled Today": "المجدولة اليوم",
      "Completed Today": "المكتملة اليوم",
      "Cancelled / No Show": "ملغية / عدم حضور",
      "Unpaid Invoices": "فواتير غير مدفوعة",
      "Partially Paid": "مدفوعة جزئياً",
      "Today Revenue": "إيرادات اليوم",
      "Month Revenue": "إيرادات الشهر",
      "Customer Credit Balance": "رصيد العملاء الدائن",
      "Paid Invoices": "فواتير مدفوعة",
      // ErpDashboardHome - Tables
      "Recent Appointments": "المواعيد الأخيرة",
      "Recent Invoices": "الفواتير الأخيرة",
      "Recent Payments": "المدفوعات الأخيرة",
      "View All": "عرض الكل",
      Patient: "المريض",
      Doctor: "الطبيب",
      Date: "التاريخ",
      Status: "الحالة",
      Number: "الرقم",
      Total: "الإجمالي",
      Issued: "تاريخ الإصدار",
      Invoice: "الفاتورة",
      Applied: "المبلغ",
      Method: "طريقة الدفع",
      "Paid At": "تاريخ الدفع",
      "No recent appointments.": "لا توجد مواعيد حديثة",
      "No recent invoices.": "لا توجد فواتير حديثة",
      "No recent payments.": "لا توجد مدفوعات حديثة",
      // ErpDashboardHome - Status Badges
      Paid: "مدفوع",
      Completed: "مكتمل",
      Unpaid: "غير مدفوع",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      "Partially Paid": "مدفوع جزئياً",
      Scheduled: "مجدول",
      "In Progress": "قيد التنفيذ",
      Pending: "قيد الانتظار",
      // ErpDashboardHome - Reminders KPIs
      "Reminders Pending": "تذكيرات قيد الانتظار",
      "Reminders Failed": "تذكيرات فاشلة",
      "Reminders Sent": "تذكيرات مرسلة",
      "Reminders Processing": "تذكيرات قيد المعالجة",
      "Reminders Skipped": "تذكيرات تم تخطيها",
      "Reminders Stuck": "تذكيرات عالقة",
      "Reminders Success Rate": "نسبة نجاح التذكيرات",
      // ErpDashboardHome - Failed Reminders Table
      "Failed Reminders": "التذكيرات الفاشلة",
      Appointment: "الموعد",
      Retries: "محاولات إعادة",
      "Last Attempt": "آخر محاولة",
      "No failed reminders.": "لا توجد تذكيرات فاشلة",
      // ErpDashboardHome - Additional Table Headers
      "Doctor Name": "اسم الطبيب",
      "Appointment Date": "تاريخ الموعد",
      "Reminder Stage": "مرحلة التذكير",
      // Alerts Section
      "High failed reminders": "تذكيرات فاشلة كثيرة",
      "Reminders stuck in processing": "تذكيرات عالقة قيد المعالجة",
      "High failed reminders_desc":
        "هناك {{count}} تذكيرات فاشلة تحتاج إلى مراجعة",
      "Reminders stuck in processing_desc":
        "هناك {{count}} تذكيرات عالقة منذ أكثر من 10 دقائق",
      // Common
      "Loading...": "جاري التحميل...",

      // Activity Logs
      "Activity Logs": "سجل النشاطات",
      "No activity yet.": "لا توجد نشاطات بعد",
      "New appointment created": "تم إنشاء موعد جديد",
      "Appointment updated": "تم تحديث موعد",
      "Appointment deleted": "تم حذف موعد",
      "New invoice created": "تم إنشاء فاتورة جديدة",
      "Invoice paid": "تم دفع الفاتورة",
      "New payment recorded": "تم تسجيل دفعة جديدة",
      "Customer updated": "تم تحديث بيانات مريض",

      // Alert buttons
      Dismiss: "تجاهل",
      Acknowledge: "تأكيد",

      // وفي كائن ar:
      "Good Morning": "صباح الخير",
      "Good Afternoon": "مساء الخير",
      "Good Evening": "مساء الخير",
      "Welcome to ERP Dashboard": "مرحباً بك في لوحة تحكم النظام",
      "Here's what's happening with your clinic today":
        "إليك ما يحدث في عيادتك اليوم",
      "Loading dashboard...": "جاري تحميل لوحة التحكم...",
      "Something went wrong": "حدث خطأ ما",
      "Try Again": "حاول مرة أخرى",
      "No Data Available": "لا توجد بيانات متاحة",
      "Total Revenue": "إجمالي الإيرادات",
      "Total Patients": "إجمالي المرضى",
      "Pending Reminders": "تذكيرات معلقة",
      "Key Performance Indicators": "مؤشرات الأداء الرئيسية",
      "Monitor your clinic's performance at a glance":
        "راقب أداء عيادتك بنظرة سريعة",
      "Recent Activity": "النشاط الأخير",
      "Latest updates from your clinic": "آخر التحديثات من عيادتك",
      "Failed Reminders": "تذكيرات فاشلة",
      "No failed reminders.": "لا توجد تذكيرات فاشلة",
      Retries: "محاولات إعادة",
      "Last Attempt": "آخر محاولة",

      // ====================  Start Visit  ====================

      "Start Visit": "بدء زيارة",
      "Start the patient journey by selecting the patient and visit path":
        "ابدأ رحلة المريض باختيار المريض ومسار الزيارة",
      "New Patient": "مريض جديد",
      "New Treatment Plan": "خطة علاج جديدة",
      "Visit Starter": " بدء الزيارة",
      Patient: "المريض",
      "Select patient": "اختر المريض",
      "Visit Type": "نوع الزيارة",
      "Existing Treatment Plan": "خطة علاج موجودة",
      "Select treatment plan": "اختر خطة العلاج",
      "Select patient first": "اختر المريض أولاً",
      "This patient has no treatment plans yet.":
        "هذا المريض ليس لديه خطط علاج حتى الآن. قم بإنشاء سجل أسنان أو خطة علاج أولاً.",
      "Selected Patient": "المريض المختار",
      "Selected Plan": "الخطة المختارة",
      Status: "الحالة",
      "Total Cost": "التكلفة الإجمالية",
      "Continuing...": "جاري المتابعة...",
      "Book Consultation": "حجز استشارة",
      "Open Treatment Plan": "فتح خطة العلاج",
      "Open Patient Profile": "فتح ملف المريض",
      Cancel: "إلغاء",
      "Workflow Preview": "معاينة سير العمل",
      "Consultation Flow": "مسار الاستشارة",
      "Treatment From Plan Flow": "مسار العلاج من الخطة",
      "Emergency Treatment Flow": "مسار العلاج الطارئ",
      "Failed to load reference data.": "فشل تحميل البيانات المرجعية.",
      "Please select a patient first.": "الرجاء اختيار مريض أولاً.",
      "Please select a treatment plan first.": "الرجاء اختيار خطة علاج أولاً.",
      "Invalid visit type selected.": "نوع الزيارة المحدد غير صالح.",
      Close: "إغلاق",

      // وصف الكروت
      Consultation: "استشارة",
      "Treatment From Plan": "علاج من الخطة",
      "Emergency Treatment": "علاج طارئ",
      consultation_desc:
        "حجز موعد استشارة، تحصيل رسوم الاستشارة، ثم متابعة الفحص والتشخيص.",
      treatment_plan_desc:
        "استخدام خطة علاج موجودة، فتح الخطة، ثم بدء الإجراء المطلوب والمتابعة إلى الفاتورة.",
      emergency_desc:
        "فتح ملف المريض والرسم البياني للأسنان أولاً، إضافة السجل السني العاجل، ثم تحويله إلى مسار علاج إذا لزم الأمر.",
      consultation_next: "الانتقال إلى حجز الاستشارة",
      treatment_plan_next: "الانتقال إلى تفاصيل خطة العلاج",
      emergency_next: "الانتقال إلى ملف المريض والرسم البياني للأسنان",

      // Workflow steps
      "Book consultation appointment": "حجز موعد استشارة",
      "Consultation invoice is created": "إنشاء فاتورة الاستشارة",
      "Doctor examines patient": "فحص الطبيب للمريض",
      "Complete appointment": "إكمال الموعد",
      "Go to invoice/payment page": "الانتقال إلى صفحة الفاتورة/الدفع",
      "Create dental record if treatment is needed":
        "إنشاء سجل أسنان إذا كان العلاج مطلوباً",
      "Open existing treatment plan": "فتح خطة العلاج الموجودة",
      "Select the required plan item": "اختيار عنصر الخطة المطلوب",
      "Start procedure": "بدء الإجراء",
      "Create treatment appointment": "إنشاء موعد علاج",
      "Create invoice and continue to payment":
        "إنشاء فاتورة والمتابعة إلى الدفع",
      "Open patient profile": "فتح ملف المريض",
      "Add dental record from dental chart": "إضافة سجل أسنان من الرسم البياني",
      "Convert to treatment plan item if needed":
        "تحويل إلى عنصر خطة علاج إذا لزم الأمر",
      "Start procedure and book slot": "بدء الإجراء وحجز موعد",
      "Complete appointment and continue to payment":
        "إكمال الموعد والمتابعة إلى الدفع",
      "Dental Record and Treatment Plan remain part of the treatment workflow. Billing should happen only after a valid consultation or a valid treatment appointment completion.":
        "يبقى السجل السني وخطة العلاج جزءاً من سير عمل العلاج. يجب أن تتم الفوترة فقط بعد استشارة صالحة أو إكمال موعد علاج صالح.",

      //Appointments
      Appointments: "المواعيد",
      "Daily schedule, doctor bookings, and patient appointments":
        "الجدول اليومي، حجوزات الأطباء، ومواعيد المرضى",
      Calendar: "التقويم",
      "Book Appointment": "حجز موعد",
      Refresh: "تحديث",
      "Search & Filters": "البحث والتصفية",
      Search: "بحث",
      Date: "التاريخ",
      Status: "الحالة",
      "All Statuses": "جميع الحالات",
      Scheduled: "مجدول",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      Loaded: "المحمّل",
      Shown: "الظاهر",
      "Clear Filters": "مسح التصفية",
      "Appointments List": "قائمة المواعيد",
      "No appointments found.": "لا توجد مواعيد",
      ID: "الرقم",
      Patient: "المريض",
      Doctor: "الطبيب",
      Time: "الوقت",
      Type: "النوع",
      Reminder: "تذكير",
      "Next Reminder": "التذكير التالي",
      "Last Reminder": "آخر تذكير",
      "Follow-up": "متابعة",
      Invoice: "الفاتورة",
      "Treatment Plan": "خطة العلاج",
      Notes: "ملاحظات",
      Actions: "إجراءات",
      Consultation: "استشارة",
      Treatment: "علاج",
      Sent: "مرسل",
      Pending: "قيد الانتظار",
      "Not Needed": "غير مطلوب",
      Processing: "قيد المعالجة",
      Retrying: "إعادة المحاولة",
      Stopped: "متوقف",
      Skipped: "تم تخطيه",
      Retries: "محاولات",
      Next: "التالي",
      "View Patient": "عرض المريض",
      "View Activity": "عرض النشاط",
      "View Invoice": "عرض الفاتورة",
      "View Treatment Plan": "عرض خطة العلاج",
      Cancel: "إلغاء",
      "Mark as No Show": "تحديد كعدم حضور",
      "Send Reminder": "إرسال تذكير",
      Complete: "إكمال",
      Reschedule: "إعادة جدولة",
      "Reschedule Appointment": "إعادة جدولة الموعد",
      "Select doctor": "اختر الطبيب",
      Confirm: "تأكيد",
      "Saving...": "جاري الحفظ...",
      Close: "إغلاق",
      "Failed to load appointments.": "فشل تحميل المواعيد",
      "Action failed.": "فشل الإجراء",
      "Cancel this appointment?": "إلغاء هذا الموعد؟",
      "Appointment cancelled successfully.": "تم إلغاء الموعد بنجاح",
      "Mark this appointment as no-show?": "تحديد هذا الموعد كعدم حضور؟",
      "Appointment marked as no-show.": "تم تحديد الموعد كعدم حضور",
      "Send reminder for this appointment?": "إرسال تذكير لهذا الموعد؟",
      "Reminder sent successfully.": "تم إرسال التذكير بنجاح",
      "Failed to send reminder.": "فشل إرسال التذكير",
      "Complete this {{type}} appointment?": "إكمال موعد {{type}}؟",
      "Appointment completed successfully.": "تم إكمال الموعد بنجاح",
      "Failed to complete appointment.": "فشل إكمال الموعد",
      "Appointment rescheduled successfully.": "تمت إعادة جدولة الموعد بنجاح",
      "Failed to reschedule appointment.": "فشل إعادة جدولة الموعد",

      // ====================  Book Appointment  ====================

      "Book Consultation Appointment": "حجز موعد استشارة",
      "Create a consultation appointment and continue the patient journey":
        "إنشاء موعد استشارة ومتابعة رحلة المريض",
      "Back to Appointments": "العودة إلى المواعيد",
      "Appointment Details": "تفاصيل الموعد",
      Patient: "المريض",
      Doctor: "الطبيب",
      "Appointment Type": "نوع الموعد",
      Consultation: "استشارة",
      Date: "التاريخ",
      "Available Slots": "المواعيد المتاحة",
      "Loading Slots...": "جاري تحميل المواعيد...",
      "Reload Slots": "إعادة تحميل المواعيد",
      Time: "الوقت",
      "Select slot": "اختر الموعد",
      Unavailable: "غير متاح",
      "No slots available for this date": "لا توجد مواعيد متاحة لهذا التاريخ",
      Notes: "ملاحظات",
      "Optional notes...": "ملاحظات اختيارية...",
      "Booking Summary": "ملخص الحجز",
      Type: "النوع",
      "Booking...": "جاري الحجز...",
      "Book Consultation": "حجز استشارة",
      Cancel: "إلغاء",
      "Failed to load booking references.": "فشل تحميل بيانات الحجز",
      "Please select doctor and date first.":
        "الرجاء اختيار الطبيب والتاريخ أولاً",
      "Failed to load available slots.": "فشل تحميل المواعيد المتاحة",
      "Please select a patient.": "الرجاء اختيار مريض",
      "Please select a doctor.": "الرجاء اختيار طبيب",
      "Please select appointment date.": "الرجاء اختيار تاريخ الموعد",
      "Please select appointment time.": "الرجاء اختيار وقت الموعد",
      "Failed to book consultation.": "فشل حجز الاستشارة",
      "Select patient": "اختر المريض",
      "Select doctor": "اختر الطبيب",

      // ====================  Appointment Calendar  ====================

      "Appointment Calendar": "تقويم المواعيد",
      "Daily clinic schedule by date and doctor":
        "جدول العيادة اليومي حسب التاريخ والطبيب",
      "Book Appointment": "حجز موعد",
      Refresh: "تحديث",
      "Calendar Filters": "فلاتر التقويم",
      Date: "التاريخ",
      Doctor: "الطبيب",
      "All Doctors": "جميع الأطباء",
      Navigation: "التنقل",
      "Previous Day": "اليوم السابق",
      Prev: "السابق",
      Today: "اليوم",
      "Next Day": "اليوم التالي",
      Next: "التالي",
      "Selected Day": "اليوم المحدد",
      "Daily Schedule": "الجدول اليومي",
      appointments: "موعد",
      "No appointments scheduled for this selection.":
        "لا توجد مواعيد مجدولة لهذا الاختيار.",
      "No appointments": "لا توجد مواعيد",
      "Unknown Patient": "مريض غير معروف",
      "Clinical Notes": "ملاحظات إكلينيكية",
      Diagnosis: "التشخيص",
      "Next Step": "الخطوة التالية",
      "View Patient": "عرض المريض",
      Patient: "المريض",
      "View Treatment Plan": "عرض خطة العلاج",
      Plan: "الخطة",
      "View Invoice": "عرض الفاتورة",
      Invoice: "الفاتورة",
      "View Activity": "عرض النشاط",
      Activity: "النشاط",
      "Failed to load appointment calendar.": "فشل تحميل تقويم المواعيد",
      "In Progress": "قيد التنفيذ",

      // ====================  Appointment Activity  ====================

      "Appointment Activity": "نشاط الموعد",
      "Timeline of changes and actions for appointment":
        "الجدول الزمني للتغييرات والإجراءات للموعد",
      "Back to Appointments": "العودة إلى المواعيد",
      "Patient Profile": "ملف المريض",
      "Treatment Plan": "خطة العلاج",
      Invoice: "الفاتورة",
      Refresh: "تحديث",
      "Appointment ID": "رقم الموعد",
      Status: "الحالة",
      Type: "النوع",
      Events: "الأحداث",
      "Appointment Details": "تفاصيل الموعد",
      "Appointment details not found.": "تفاصيل الموعد غير موجودة",
      Patient: "المريض",
      Doctor: "الطبيب",
      Date: "التاريخ",
      Time: "الوقت",
      "Created At": "تاريخ الإنشاء",
      "Updated At": "تاريخ التحديث",
      "Clinical Notes": "ملاحظات إكلينيكية",
      Diagnosis: "التشخيص",
      "Next Step": "الخطوة التالية",
      Notes: "ملاحظات",
      "Complete Appointment": "إكمال الموعد",
      Scheduled: "مجدول",
      "Completion Result": "نتيجة الإكمال",
      "Invoice Total": "إجمالي الفاتورة",
      "Invoice Status": "حالة الفاتورة",
      "Completed Sessions": "الجلسات المكتملة",
      "Planned Sessions": "الجلسات المخطط لها",
      "Remaining Sessions": "الجلسات المتبقية",
      "Item Status": "حالة العنصر",
      "Doctor Name": "اسم الطبيب",
      "Optional doctor name override": "تجاوز اسم الطبيب (اختياري)",
      "General Notes": "ملاحظات عامة",
      "Optional notes": "ملاحظات اختيارية",
      "Enter clinical notes...": "أدخل الملاحظات الإكلينيكية...",
      "Enter diagnosis...": "أدخل التشخيص...",
      "Enter next step...": "أدخل الخطوة التالية...",
      "Completing...": "جاري الإكمال...",
      Reset: "إعادة تعيين",
      "Clinical notes saved successfully.":
        "تم حفظ الملاحظات الإكلينيكية بنجاح",
      "Failed to save clinical notes.": "فشل حفظ الملاحظات الإكلينيكية",
      "Failed to complete appointment.": "فشل إكمال الموعد",
      "Appointment completed successfully.": "تم إكمال الموعد بنجاح",
      "Completed Appointment": "موعد مكتمل",
      "Save Clinical Notes": "حفظ الملاحظات الإكلينيكية",
      "Saving...": "جاري الحفظ...",
      "Latest Activity": "آخر نشاط",
      "Last recorded action for this appointment.":
        "آخر إجراء مسجل لهذا الموعد",
      "Activity Log": "سجل النشاط",
      events: "حدث",
      "No activity found for this appointment.": "لا يوجد نشاط لهذا الموعد",
      "Log ID": "رقم السجل",
      "Company ID": "رقم الشركة",
      "Subject ID": "رقم الموضوع",
      "Subject Type": "نوع الموضوع",
      "Appointment Type": "نوع الموعد",
      "Old Status": "الحالة القديمة",
      "New Status": "الحالة الجديدة",
      "Old Date": "التاريخ القديم",
      "New Date": "التاريخ الجديد",
      "Old Time": "الوقت القديم",
      "New Time": "الوقت الجديد",
      "Doctor ID": "رقم الطبيب",
      "Plan Item ID": "رقم عنصر الخطة",
      "Procedure ID": "رقم الإجراء",
      Procedure: "الإجراء",
      Total: "الإجمالي",
      Plan: "الخطة",
      "Show raw properties": "عرض البيانات الخام",
      User: "المستخدم",
      Booked: "تم الحجز",
      Rebooked: "تم إعادة الحجز",
      Rescheduled: "تمت إعادة الجدولة",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      Completed: "مكتمل",
      "Procedure Started": "بدأ الإجراء",
      "Session Completed": "اكتملت الجلسة",
      Updated: "تم التحديث",
      "Failed to load appointment details.": "فشل تحميل تفاصيل الموعد",
      Consultation: "استشارة",
      Treatment: "علاج",
      "In Progress": "قيد التنفيذ",
      Active: "نشط",

      // ====================  Dental Records  ====================

      "Dental Records": "السجلات السنية",
      "Review patient chart records, procedures, teeth, and statuses":
        "مراجعة سجلات المرضى، الإجراءات، الأسنان، والحالات",
      "Create Dental Record": "إنشاء سجل سني",
      Refresh: "تحديث",
      "Search Records": "البحث في السجلات",
      Search: "بحث",
      "Total Records": "إجمالي السجلات",
      "Dental Records List": "قائمة السجلات السنية",
      records: "سجل",
      "No dental records found.": "لا توجد سجلات سنية",
      Patient: "المريض",
      Procedure: "الإجراء",
      Tooth: "السن",
      Surface: "السطح",
      Status: "الحالة",
      Notes: "ملاحظات",
      Actions: "إجراءات",
      "View Patient": "عرض المريض",
      "View Timeline": "عرض الجدول الزمني",
      Timeline: "الجدول الزمني",
      "Convert to Treatment Plan": "تحويل إلى خطة علاج",
      Convert: "تحويل",
      "Select Treatment Plan": "اختر خطة العلاج",
      "Select plan": "اختر خطة",
      "No treatment plans found for this patient.":
        "لا توجد خطط علاج لهذا المريض",
      "Confirm Convert": "تأكيد التحويل",
      "Converting...": "جاري التحويل...",
      Cancel: "إلغاء",
      "Failed to load dental records.": "فشل تحميل السجلات السنية",
      "Please select a treatment plan first.": "الرجاء اختيار خطة علاج أولاً",
      "Failed to convert dental record.": "فشل تحويل السجل السني",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      Planned: "مخطط",
      "In Progress": "قيد التنفيذ",

      // ====================  Create Dental Record  ====================

      "Create Dental Record": "إنشاء سجل سني",
      "Add a clinical dental record for a patient before treatment planning":
        "إضافة سجل سني سريري لمريض قبل تخطيط العلاج",
      "Back to Dental Records": "العودة إلى السجلات السنية",
      "This record is linked to appointment": "هذا السجل مرتبط بالموعد",
      "Next Step": "الخطوة التالية",
      "You can now create a treatment plan directly for this patient.":
        "يمكنك الآن إنشاء خطة علاج مباشرة لهذا المريض",
      "Create Treatment Plan": "إنشاء خطة علاج",
      "Go to Dental Records": "الذهاب إلى السجلات السنية",
      "Dental Record Details": "تفاصيل السجل السني",
      Patient: "المريض",
      Doctor: "الطبيب",
      Procedure: "الإجراء",
      "Tooth Number": "رقم السن",
      Surface: "السطح",
      Notes: "ملاحظات",
      "Record Summary": "ملخص السجل",
      "Linked Appointment": "الموعد المرتبط",
      Tooth: "السن",
      "e.g., 16, 24, 36": "مثال: 16، 24، 36",
      "occlusal, mesial, distal, buccal, lingual":
        "إطباقي، إنسي، وحشي، شدقي، لساني",
      "Clinical findings, diagnosis, and observations...":
        "النتائج السريرية، التشخيص، والملاحظات...",
      "Select patient": "اختر المريض",
      "Select doctor": "اختر الطبيب",
      "Select procedure": "اختر الإجراء",
      "Saving...": "جاري الحفظ...",
      "Create Dental Record": "إنشاء سجل سني",
      Cancel: "إلغاء",
      "Failed to load reference data.": "فشل تحميل البيانات المرجعية",
      "Failed to create dental record.": "فشل إنشاء السجل السني",

      // ====================  Treatment Plans  ====================

      "Treatment Plans": "خطط العلاج",
      "View treatment plans, balances, progress, and linked patient data":
        "عرض خطط العلاج، الأرصدة، التقدم، وبيانات المرضى المرتبطة",
      "Create Treatment Plan": "إنشاء خطة علاج",
      Refresh: "تحديث",
      "Search Plans": "البحث في الخطط",
      Search: "بحث",
      "Total Plans": "إجمالي الخطط",
      "Treatment Plans List": "قائمة خطط العلاج",
      plans: "خطة",
      "No treatment plans found.": "لا توجد خطط علاج",
      Title: "العنوان",
      Patient: "المريض",
      "Total Cost": "التكلفة الإجمالية",
      "Total Paid": "إجمالي المدفوع",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      Status: "الحالة",
      Actions: "إجراءات",
      "View Plan": "عرض الخطة",
      View: "عرض",
      "View Patient": "عرض المريض",
      "Failed to load treatment plans.": "فشل تحميل خطط العلاج",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      Active: "نشط",

      // ====================  Treatment Plan Details  ====================

      "Treatment Plan Details": "تفاصيل خطة العلاج",
      "Review plan items, progress, invoices, and cash flow":
        "مراجعة عناصر الخطة، التقدم، الفواتير، والتدفق النقدي",
      "Back to Plans": "العودة إلى الخطط",
      "Patient Profile": "ملف المريض",
      Refresh: "تحديث",
      "Plan Information": "معلومات الخطة",
      Title: "العنوان",
      Patient: "المريض",
      Email: "البريد الإلكتروني",
      Status: "الحالة",
      "Total Cost": "التكلفة الإجمالية",
      Created: "تاريخ الإنشاء",
      Notes: "ملاحظات",
      "Treatment Progress": "تقدم العلاج",
      "{{completed}} / {{planned}} sessions completed":
        "{{completed}} / {{planned}} جلسة مكتملة",
      "Total Invoiced": "إجمالي الفواتير",
      "Direct Paid": "مدفوع مباشر",
      "Credit Applied": "رصيد مستخدم",
      "Total Paid": "إجمالي المدفوع",
      "Total Refunded": "إجمالي المسترد",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      "Cash In": "نقدي وارد",
      "Net Cash": "صافي النقدي",
      "Customer Credit": "رصيد العميل",
      "Add Plan Item": "إضافة عنصر للخطة",
      Procedure: "الإجراء",
      Tooth: "السن",
      Surface: "السطح",
      Price: "السعر",
      Sessions: "الجلسات",
      Add: "إضافة",
      "Add Item": "إضافة عنصر",
      "Adding...": "جاري الإضافة...",
      "Optional notes...": "ملاحظات اختيارية...",
      "Select procedure": "اختر الإجراء",
      "Select surface": "اختر السطح",
      Occlusal: "إطباقي",
      Incisal: "قاطعي",
      Mesial: "إنسي",
      Distal: "وحشي",
      Buccal: "شدقي",
      Facial: "وجهي",
      Lingual: "لساني",
      Palatal: "حنكي",
      General: "عام",
      Optional: "اختياري",
      "Plan Items": "عناصر الخطة",
      items: "عنصر",
      "No items found.": "لا توجد عناصر",
      Price: "السعر",
      Progress: "التقدم",
      Actions: "إجراءات",
      "Next Session": "الجلسة التالية",
      "Start Procedure": "بدء الإجراء",
      Appointment: "موعد",
      Delete: "حذف",
      "Open Appointment": "فتح الموعد",
      "Start Next Session": "بدء الجلسة التالية",
      "This will create a treatment appointment for this plan item. When that appointment is completed, one session will be billed and the completed sessions count will be increased.":
        "سيؤدي هذا إلى إنشاء موعد علاج لهذا العنصر. عند إكمال هذا الموعد، سيتم فوترة جلسة واحدة وزيادة عدد الجلسات المكتملة.",
      Doctor: "الطبيب",
      Date: "التاريخ",
      "Available Slots": "المواعيد المتاحة",
      "Load Slots": "تحميل المواعيد",
      "Loading Slots...": "جاري تحميل المواعيد...",
      Time: "الوقت",
      "Select slot": "اختر الموعد",
      Unavailable: "غير متاح",
      "Confirm Start": "تأكيد البدء",
      "Starting...": "جاري البدء...",
      Close: "إغلاق",
      "Linked Invoices": "الفواتير المرتبطة",
      invoices: "فاتورة",
      "No invoices linked to this plan.": "لا توجد فواتير مرتبطة بهذه الخطة",
      Number: "الرقم",
      "Cash Summary": "ملخص النقدي",
      "Invoice Refunds": "استرداد الفواتير",
      "Credit Refunds": "استرداد الرصيد",
      "Credit Issued": "رصيد مُصدر",
      "Credit Used": "رصيد مستخدم",
      "Net Credit": "صافي الرصيد",
      "Item added successfully.": "تمت إضافة العنصر بنجاح",
      "Failed to add item.": "فشل إضافة العنصر",
      "Delete this item?": "حذف هذا العنصر؟",
      "Item deleted successfully.": "تم حذف العنصر بنجاح",
      "Failed to delete item.": "فشل حذف العنصر",
      "Please select doctor and date first.":
        "الرجاء اختيار الطبيب والتاريخ أولاً",
      "Failed to load available slots.": "فشل تحميل المواعيد المتاحة",
      "Procedure started successfully.": "بدأ الإجراء بنجاح",
      "Failed to start procedure.": "فشل بدء الإجراء",
      "Failed to load treatment plan details.": "فشل تحميل تفاصيل خطة العلاج",
      Retry: "إعادة المحاولة",
      Completed: "مكتمل",
      "In Progress": "قيد التنفيذ",
      Cancelled: "ملغي",
      "Not Started": "لم يبدأ",
      Active: "نشط",
      Planned: "مخطط",
      "Partially Paid": "مدفوع جزئياً",
      Unpaid: "غير مدفوع",
      Paid: "مدفوع",
      "e.g., 16, 24, 36": "مثال: 16، 24، 36",

      // ====================  Create Treatment Plan   ====================

      "Create Treatment Plan": "إنشاء خطة علاج",
      "Create a new treatment plan for a patient": "إنشاء خطة علاج جديدة لمريض",
      "Back to Plans": "العودة إلى الخطط",
      "Treatment Plan Details": "تفاصيل خطة العلاج",
      Patient: "المريض",
      Title: "العنوان",
      Notes: "ملاحظات",
      "Plan Cost": "تكلفة الخطة",
      "Total cost will be calculated automatically after adding plan items.":
        "سيتم حساب التكلفة الإجمالية تلقائياً بعد إضافة عناصر الخطة",
      "Selected Patient": "المريض المختار",
      "Select patient": "اختر المريض",
      "e.g. Ahmed Dental Plan": "مثال: خطة علاج أحمد",
      "Optional notes...": "ملاحظات اختيارية...",
      "Saving...": "جاري الحفظ...",
      "Create Treatment Plan": "إنشاء خطة علاج",
      Cancel: "إلغاء",
      "Failed to load patients.": "فشل تحميل المرضى",
      "Treatment plan created successfully.": "تم إنشاء خطة العلاج بنجاح",
      "Failed to create treatment plan.": "فشل إنشاء خطة العلاج",

      // ====================  Patients  ====================

      Patients: "المرضى",
      "Manage patients, open profile, timeline, and statement":
        "إدارة المرضى، فتح الملف الشخصي، الجدول الزمني، وكشف الحساب",
      "New Patient": "مريض جديد",
      Refresh: "تحديث",
      "Search Patients": "البحث عن مرضى",
      Search: "بحث",
      "Total Patients": "إجمالي المرضى",
      "Patients List": "قائمة المرضى",
      patients: "مريض",
      "No patients found.": "لا توجد مرضى",
      Code: "الكود",
      Name: "الاسم",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      Status: "الحالة",
      Actions: "إجراءات",
      "View Profile": "عرض الملف الشخصي",
      Profile: "الملف الشخصي",
      "Edit Patient": "تعديل المريض",
      Edit: "تعديل",
      "View Timeline": "عرض الجدول الزمني",
      Timeline: "الجدول الزمني",
      "View Statement": "عرض كشف الحساب",
      Statement: "كشف الحساب",
      "Search by code, name, email, phone, or status...":
        "البحث بالكود، الاسم، البريد الإلكتروني، الهاتف، أو الحالة...",
      Active: "نشط",
      Inactive: "غير نشط",
      "Failed to load patients.": "فشل تحميل المرضى",

      // ====================  patient profile  ====================

      "Failed to load patient profile": "فشل تحميل ملف المريض",
      "Dental record updated successfully.": "تم تحديث السجل السني بنجاح",
      "Dental record added successfully.": "تمت إضافة السجل السني بنجاح",
      "Failed to save dental record.": "فشل حفظ السجل السني",
      "Delete this dental record?": "حذف هذا السجل السني؟",
      "Dental record deleted successfully.": "تم حذف السجل السني بنجاح",
      "Failed to delete dental record.": "فشل حذف السجل السني",
      "Record converted to treatment plan item successfully.":
        "تم تحويل السجل إلى عنصر خطة علاج بنجاح",
      "Failed to convert record.": "فشل تحويل السجل",
      "Convert to Treatment Plan": "تحويل إلى خطة علاج",
      "Open Treatment Plan": "فتح خطة العلاج",
      "Open Appointment": "فتح الموعد",
      "Not converted yet": "لم يتم التحويل بعد",
      "Plan #{id} • Waiting to start procedure":
        "الخطة #{id} • في انتظار بدء الإجراء",
      "Plan #{planId} • Appointment #{appointmentId}":
        "الخطة #{planId} • الموعد #{appointmentId}",
      "No patient data": "لا توجد بيانات للمريض",
      Code: "الكود",
      Timeline: "الجدول الزمني",
      Statement: "كشف الحساب",
      Refresh: "تحديث",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      Created: "تاريخ الإنشاء",
      Appointments: "المواعيد",
      "Dental Records": "السجلات السنية",
      "Treatment Plans": "خطط العلاج",
      Invoices: "الفواتير",
      "Invoices Total": "إجمالي الفواتير",
      "Direct Paid": "مدفوع مباشر",
      "Credit Applied": "رصيد مستخدم",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      "Customer Credit Balance": "رصيد العميل الدائن",
      Date: "التاريخ",
      Time: "الوقت",
      Doctor: "الطبيب",
      Type: "النوع",
      Consultation: "استشارة",
      Treatment: "علاج",
      "Dental Chart": "الرسم البياني للأسنان",
      "Each tooth shows surfaces: O/I, M, D, B/F, L/P":
        "كل سن يعرض الأسطح: إطباقي/قاطعي، إنسي، وحشي، شدقي/وجهي، لساني/حنكي",
      "Clear Selection": "إلغاء التحديد",
      "Upper Jaw": "الفك العلوي",
      "Lower Jaw": "الفك السفلي",
      Completed: "مكتمل",
      "In Progress": "قيد التنفيذ",
      Planned: "مخطط",
      "No Data": "لا توجد بيانات",
      Tooth: "السن",
      Details: "التفاصيل",
      "Edit Record": "تعديل السجل",
      "Add Record": "إضافة سجل",
      "Cancel Edit": "إلغاء التعديل",
      Surface: "السطح",
      Procedure: "الإجراء",
      Notes: "ملاحظات",
      "Optional notes...": "ملاحظات اختيارية...",
      "Update Record": "تحديث السجل",
      "Existing Records": "السجلات الموجودة",
      "No records for this tooth.": "لا توجد سجلات لهذا السن",
      "Select surface": "اختر السطح",
      Occlusal: "إطباقي",
      Incisal: "قاطعي",
      Mesial: "إنسي",
      Distal: "وحشي",
      Buccal: "شدقي",
      Facial: "وجهي",
      Lingual: "لساني",
      Palatal: "حنكي",
      General: "عام",
      "Select procedure": "اختر الإجراء",
      Edit: "تعديل",
      Delete: "حذف",
      "Deleting...": "جاري الحذف...",
      "Treatment Plan": "خطة العلاج",
      "Select treatment plan": "اختر خطة العلاج",
      Plan: "الخطة",
      Price: "السعر",
      "Optional price override": "تجاوز السعر (اختياري)",
      Confirm: "تأكيد",
      "Converting...": "جاري التحويل...",
      Cancel: "إلغاء",
      Title: "العنوان",
      Total: "الإجمالي",
      Number: "الرقم",
      Active: "نشط",
      Inactive: "غير نشط",
      Scheduled: "مجدول",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      "Partially Paid": "مدفوع جزئياً",
      Unpaid: "غير مدفوع",
      Paid: "مدفوع",
      Retry: "إعادة المحاولة",
      "Saving...": "جاري الحفظ...",
      "Loading...": "جاري التحميل...",

      // ==================== PatientStatementPage ====================
      "Failed to load {{entity}} statement": "فشل تحميل كشف حساب {{entity}}",
      "Loading {{entity}} statement...": "جاري تحميل كشف حساب {{entity}}...",
      "Failed to load statement data": "فشل تحميل بيانات كشف الحساب",
      "Go Back": "العودة",
      Statement: "كشف الحساب",
      "All Time": "كل الوقت",
      "Last 30 Days": "آخر 30 يوم",
      "Last 90 Days": "آخر 90 يوم",
      From: "من",
      To: "إلى",
      Apply: "تطبيق",
      "Opening Balance": "الرصيد الافتتاحي",
      "Closing Balance": "الرصيد الختامي",
      "Total Entries": "إجمالي الإدخالات",
      "No entries in this period": "لا توجد إدخالات في هذه الفترة",
      Debit: "مدين",
      Credit: "دائن",
      Balance: "الرصيد",
      "Account summary and transaction details":
        "ملخص الحساب وتفاصيل المعاملات",
      "Print Statement": "طباعة كشف الحساب",
      "Quick Filters": "فلاتر سريعة",
      "Custom Date Range": "نطاق تاريخ مخصص",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Apply Filter": "تطبيق الفلتر",
      "Statement Period": "فترة كشف الحساب",
      to: "إلى",
      "Statement Entries": "إدخالات كشف الحساب",
      Description: "الوصف",

      // ====================  patient timeline  ====================

      "Failed to load patient timeline.": "فشل تحميل الجدول الزمني للمريض",
      "No patient timeline data available.":
        "لا توجد بيانات للجدول الزمني للمريض",
      "Patient Timeline": "الجدول الزمني للمريض",
      "Full history: appointments, dental records, treatment flow, invoices and payments":
        "السجل الكامل: المواعيد، السجلات السنية، سير العمل العلاجي، الفواتير والمدفوعات",
      Profile: "الملف الشخصي",
      Statement: "كشف الحساب",
      Refresh: "تحديث",
      Name: "الاسم",
      Code: "الكود",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      "Timeline Events": "أحداث الجدول الزمني",
      events: "حدث",
      "No events found.": "لا توجد أحداث",
      Doctor: "الطبيب",
      Type: "النوع",
      Date: "التاريخ",
      Time: "الوقت",
      Status: "الحالة",
      Diagnosis: "التشخيص",
      "Next Step": "الخطوة التالية",
      "Clinical Notes": "ملاحظات إكلينيكية",
      Notes: "ملاحظات",
      "Treatment Plan": "خطة العلاج",
      Invoice: "الفاتورة",
      "Appointment Activity": "نشاط الموعد",
      Procedure: "الإجراء",
      Tooth: "السن",
      Surface: "السطح",
      Flow: "سير العمل",
      "Not converted": "لم يتم التحويل",
      "Open Plan": "فتح الخطة",
      "Open Appointment": "فتح الموعد",
      "Invoice Number": "رقم الفاتورة",
      Total: "الإجمالي",
      "Issued At": "تاريخ الإصدار",
      "Appointment ID": "رقم الموعد",
      "Treatment Plan ID": "رقم خطة العلاج",
      "Open Invoice": "فتح الفاتورة",
      "Invoice ID": "رقم الفاتورة",
      Amount: "المبلغ",
      "Applied Amount": "المبلغ المطبق",
      "Credit Amount": "مبلغ الرصيد",
      Method: "طريقة الدفع",
      "Payment ID": "رقم الدفعة",
      "Refund Amount": "مبلغ الاسترداد",
      "Applies To": "ينطبق على",
      "No details available.": "لا توجد تفاصيل",
      Appointment: "موعد",
      "Dental Record": "سجل سني",
      Invoice: "فاتورة",
      Payment: "دفعة",
      Refund: "استرداد",
      Event: "حدث",
      Consultation: "استشارة",
      Treatment: "علاج",
      "Appointment #{id}": "موعد #{id}",
      "Plan #{id}": "خطة #{id}",
      Retry: "إعادة المحاولة",
      "Loading...": "جاري التحميل...",

      // ====================  Create Patient  ====================

      "Edit Patient": "تعديل مريض",
      "Create Patient": "إنشاء مريض",
      "Update patient basic information": "تحديث المعلومات الأساسية للمريض",
      "Create a new patient profile": "إنشاء ملف مريض جديد",
      Patients: "المرضى",
      Profile: "الملف الشخصي",
      "Edit Patient Information": "تعديل معلومات المريض",
      "Patient Information": "معلومات المريض",
      "Full Name": "الاسم الكامل",
      "Enter patient full name": "أدخل اسم المريض الكامل",
      "Email Address": "البريد الإلكتروني",
      "patient@example.com": "مريض@مثال.com",
      "Phone Number": "رقم الهاتف",
      "+1234567890": "+1234567890",
      Gender: "الجنس",
      "Select gender": "اختر الجنس",
      Male: "ذكر",
      Female: "أنثى",
      "Date of Birth": "تاريخ الميلاد",
      Address: "العنوان",
      "Street, city, postal code": "الشارع، المدينة، الرمز البريدي",
      "Additional notes about the patient...": "ملاحظات إضافية عن المريض...",
      "Update Patient": "تحديث المريض",
      "Failed to load patient.": "فشل تحميل بيانات المريض",
      "Failed to save patient.": "فشل حفظ بيانات المريض",

      // ====================  Doctors  ====================

      Doctors: "الأطباء",
      "Manage doctors, working hours, and availability":
        "إدارة الأطباء، ساعات العمل، والتوفر",
      "New Doctor": "طبيب جديد",
      Refresh: "تحديث",
      "Search Doctors": "البحث عن أطباء",
      Search: "بحث",
      "Total Doctors": "إجمالي الأطباء",
      "Doctors List": "قائمة الأطباء",
      doctors: "طبيب",
      "No doctors found.": "لا توجد أطباء",
      Doctor: "الطبيب",
      Specialty: "التخصص",
      "Working Hours": "ساعات العمل",
      "Slot Minutes": "مدة الموعد",
      Status: "الحالة",
      Actions: "إجراءات",
      "Manage Availability": "إدارة التوفر",
      Availability: "التوفر",
      "Edit Doctor": "تعديل الطبيب",
      Edit: "تعديل",
      "Book Appointment": "حجز موعد",
      Book: "حجز",
      "Name, email, phone, specialty...":
        "الاسم، البريد الإلكتروني، الهاتف، التخصص...",
      Active: "نشط",
      Inactive: "غير نشط",
      min: "دقيقة",
      "Failed to load doctors.": "فشل تحميل الأطباء",

      // ====================  Create Doctor  ====================

      "Edit Doctor": "تعديل طبيب",
      "Create Doctor": "إنشاء طبيب",
      "Manage doctor profile, hours, and booking slot settings":
        "إدارة ملف الطبيب، ساعات العمل، وإعدادات مواعيد الحجز",
      "Back to Doctors": "العودة إلى الأطباء",
      "Doctor Information": "معلومات الطبيب",
      "New Doctor": "طبيب جديد",
      "Full Name": "الاسم الكامل",
      "Dr. John Doe": "د. جون دو",
      Specialty: "التخصص",
      "Dentist / Orthodontist / Surgeon...": "طبيب أسنان / تقويم / جراح...",
      "Email Address": "البريد الإلكتروني",
      "doctor@clinic.com": "طبيب@عيادة.com",
      "Phone Number": "رقم الهاتف",
      "+1234567890": "+1234567890",
      "Work Start": "بداية العمل",
      "Work End": "نهاية العمل",
      "Slot Duration": "مدة الموعد",
      minutes: "دقائق",
      "Active doctor": "طبيب نشط",
      "Active doctors can be booked for appointments":
        "يمكن حجز مواعيد للأطباء النشطين",
      "Update Doctor": "تحديث الطبيب",
      "Create Doctor": "إنشاء طبيب",
      "Failed to load doctor.": "فشل تحميل بيانات الطبيب",
      "Failed to save doctor.": "فشل حفظ بيانات الطبيب",

      // ====================  Doctor Availability  ====================

      "Doctor Availability": "توفر الطبيب",
      "Check available slots for this doctor":
        "تحقق من المواعيد المتاحة لهذا الطبيب",
      "Back to Doctors": "العودة إلى الأطباء",
      "Book Appointment": "حجز موعد",
      "Doctor Information": "معلومات الطبيب",
      "Doctor Name": "اسم الطبيب",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      Specialty: "التخصص",
      "Working Hours": "ساعات العمل",
      "Slot Duration": "مدة الموعد",
      minutes: "دقائق",
      "Check Availability": "التحقق من التوفر",
      "Select Date": "اختر التاريخ",
      "Checking...": "جاري التحقق...",
      "Load Availability": "تحميل المواعيد المتاحة",
      "Available Slots": "المواعيد المتاحة",
      "No slots available for this date": "لا توجد مواعيد متاحة لهذا التاريخ",
      "Select a date to check availability": "اختر تاريخاً للتحقق من التوفر",
      Booked: "محجوز",
      "Failed to load doctor details.": "فشل تحميل تفاصيل الطبيب",
      "Please select a date first.": "الرجاء اختيار تاريخ أولاً",
      "Failed to load doctor availability.": "فشل تحميل مواعيد توفر الطبيب",

      // ====================  Invoices  ====================

      Invoices: "الفواتير",
      "Review invoice balances, payment status, and customer billing":
        "مراجعة أرصدة الفواتير، حالة الدفع، وفواتير العملاء",
      Refresh: "تحديث",
      "Search Invoices": "البحث في الفواتير",
      Search: "بحث",
      "Total Invoices": "إجمالي الفواتير",
      "Invoices List": "قائمة الفواتير",
      invoices: "فاتورة",
      "No invoices found.": "لا توجد فواتير",
      Invoice: "الفاتورة",
      Customer: "العميل",
      Total: "الإجمالي",
      Paid: "مدفوع",
      Remaining: "المتبقي",
      Status: "الحالة",
      Issued: "تاريخ الإصدار",
      Actions: "إجراءات",
      "View Invoice": "عرض الفاتورة",
      View: "عرض",
      "View Patient": "عرض المريض",
      Patient: "المريض",
      "View Treatment Plan": "عرض خطة العلاج",
      Plan: "الخطة",
      "Invoice number, customer, email, status...":
        "رقم الفاتورة، العميل، البريد الإلكتروني، الحالة...",
      ID: "الرقم",
      "Partially Paid": "مدفوع جزئياً",
      Unpaid: "غير مدفوع",
      Cancelled: "ملغي",
      "Failed to load invoices.": "فشل تحميل الفواتير",

      // ====================  Invoice Details ====================

      "Invoice Details": "تفاصيل الفاتورة",
      "Review invoice, payments, refunds, and accounting impact":
        "مراجعة الفاتورة، المدفوعات، المبالغ المستردة، والتأثير المحاسبي",
      "Back to Invoices": "العودة إلى الفواتير",
      "Patient Profile": "ملف المريض",
      Refresh: "تحديث",
      "Invoice Information": "معلومات الفاتورة",
      "Invoice Number": "رقم الفاتورة",
      Status: "الحالة",
      "Customer ID": "رقم العميل",
      "Appointment ID": "رقم الموعد",
      "Treatment Plan ID": "رقم خطة العلاج",
      "Issued At": "تاريخ الإصدار",
      "Invoice Total": "إجمالي الفاتورة",
      "Direct Paid": "مدفوع مباشر",
      "Credit Applied": "رصيد مستخدم",
      Refunded: "مسترد",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      "Invoice Credit": "رصيد الفاتورة",
      "Customer Credit Balance": "رصيد العميل الدائن",
      "Cash Received": "النقدية المستلمة",
      "Receive Payment": "استلام دفعة",
      Amount: "المبلغ",
      Method: "طريقة الدفع",
      cash: "نقدي",
      card: "بطاقة",
      bank: "تحويل بنكي",
      "Processing...": "جاري المعالجة...",
      "Any available customer credit is applied automatically when the invoice is created. Any extra payment above remaining becomes new customer credit.":
        "يتم تطبيق أي رصيد متاح للعميل تلقائياً عند إنشاء الفاتورة. أي دفعة زائدة عن المبلغ المتبقي تصبح رصيداً جديداً للعميل.",
      "Invoice Items": "عناصر الفاتورة",
      "No invoice items found.": "لا توجد عناصر في الفاتورة",
      Product: "المنتج",
      Qty: "الكمية",
      "Unit Price": "سعر الوحدة",
      Total: "الإجمالي",
      Payments: "المدفوعات",
      "No payments recorded yet.": "لا توجد مدفوعات مسجلة بعد",
      ID: "الرقم",
      Applied: "المطبق",
      Credit: "الرصيد",
      "Paid At": "تاريخ الدفع",
      "Refund Payments": "استرداد المدفوعات",
      "No payments available for refund.": "لا توجد مدفوعات متاحة للاسترداد",
      Payment: "دفعة",
      "Paid at": "تاريخ الدفع",
      "Invoice Refundable": "قابل للاسترداد من الفاتورة",
      "Credit Refundable": "قابل للاسترداد من الرصيد",
      "Total Refundable": "إجمالي القابل للاسترداد",
      "Refund Amount": "مبلغ الاسترداد",
      Refund: "استرداد",
      "Previous Refunds": "المبالغ المستردة السابقة",
      Type: "النوع",
      "Refunded At": "تاريخ الاسترداد",
      "All Refunds": "جميع المبالغ المستردة",
      "No refunds found.": "لا توجد مبالغ مستردة",
      "Payment ID": "رقم الدفعة",
      "Customer Credit Summary": "ملخص رصيد العميل",
      "Credit Issued Total": "إجمالي الرصيد المصدر",
      "Credit Used Total": "إجمالي الرصيد المستخدم",
      "Current Credit Balance": "الرصيد الحالي",
      "Journal Entries": "قيود اليومية",
      "No journal entries found.": "لا توجد قيود يومية",
      Entry: "قيد",
      Account: "الحساب",
      Debit: "مدين",
      Credit: "دائن",
      "Failed to load invoice.": "فشل تحميل الفاتورة",
      Retry: "إعادة المحاولة",
      "Invoice not found.": "الفاتورة غير موجودة",
      Back: "رجوع",
      "Payment recorded successfully.": "تم تسجيل الدفعة بنجاح",
      "Failed to record payment.": "فشل تسجيل الدفعة",
      "Enter a valid refund amount.": "أدخل مبلغ استرداد صالحاً",
      "Refund recorded successfully.": "تم تسجيل الاسترداد بنجاح",
      "Failed to record refund.": "فشل تسجيل الاسترداد",
      "Partially Paid": "مدفوع جزئياً",
      Unpaid: "غير مدفوع",
      Cancelled: "ملغي",
      Paid: "مدفوع",

      // ====================  Analytics Dashboard  ====================

      "Analytics Dashboard": "لوحة التحليل",
      "Visual overview of revenue, appointments, doctors, and collections":
        "نظرة عامة مرئية للإيرادات، المواعيد، الأطباء، والتحصيلات",
      "Back to Reports": "العودة إلى التقارير",
      Refresh: "تحديث",
      "Date Range Filter": "فلتر النطاق الزمني",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Apply Filters": "تطبيق الفلاتر",
      "Total Appointments": "إجمالي المواعيد",
      "Filtered range": "النطاق المحدد",
      "Completed Appointments": "المواعيد المكتملة",
      "Appointments done": "المواعيد المنفذة",
      "Total Invoiced": "إجمالي الفواتير",
      "Total billed": "إجمالي المفوتر",
      "Total Collected": "إجمالي المحصل",
      "Net paid": "صافي المدفوع",
      "Revenue Trend": "اتجاه الإيرادات",
      Invoiced: "مفوتر",
      Paid: "مدفوع",
      "No revenue data in this range.": "لا توجد بيانات إيرادات في هذا النطاق",
      "Appointment Status": "حالة المواعيد",
      "No appointment data in this range.":
        "لا توجد بيانات مواعيد في هذا النطاق",
      "Doctor Load": "حمل الأطباء",
      "No doctor data available.": "لا توجد بيانات للأطباء",
      "Payment Snapshot": "ملخص المدفوعات",
      Refunded: "مسترد",
      Remaining: "المتبقي",
      "Failed to load analytics.": "فشل تحميل بيانات التحليل",
      "Total Appointments": "إجمالي المواعيد",
      Completed: "مكتمل",
      Total: "الإجمالي",
      "In Progress": "قيد التنفيذ",

      // ====================  Appointments Report  ====================

      "Appointments Report": "تقرير المواعيد",
      "Operational report for scheduling, completion, cancellation, and no-show trends":
        "تقرير تشغيلي لاتجاهات الجدولة، الإكمال، الإلغاء، وعدم الحضور",
      "Back to Reports": "العودة إلى التقارير",
      Print: "طباعة",
      "Export CSV": "تصدير CSV",
      Refresh: "تحديث",
      Filters: "فلاتر",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      Doctor: "الطبيب",
      "All Doctors": "جميع الأطباء",
      Status: "الحالة",
      "All Statuses": "جميع الحالات",
      Scheduled: "مجدول",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      "In Progress": "قيد التنفيذ",
      "Apply Filters": "تطبيق الفلاتر",
      "Total Appointments": "إجمالي المواعيد",
      "Report Summary": "ملخص التقرير",
      "This report is currently built from the appointments listing response and is ready to be switched later to a dedicated reporting API.":
        "تم بناء هذا التقرير حالياً من استجابة قائمة المواعيد وهو جاهز للتحويل لاحقاً إلى واجهة برمجة تطبيقات مخصصة للتقارير",
      "Appointment Rows": "صفوف المواعيد",
      appointments: "موعد",
      "No appointments found for this report.": "لا توجد مواعيد لهذا التقرير",
      Patient: "المريض",
      Date: "التاريخ",
      Time: "الوقت",
      Notes: "ملاحظات",
      Actions: "إجراءات",
      "View Patient": "عرض المريض",
      Patient: "المريض",
      "View Activity": "عرض النشاط",
      Activity: "النشاط",
      "Failed to load appointments report.": "فشل تحميل تقرير المواعيد",
      Doctor: "الطبيب",

      // ====================  Doctor Performance Report  ====================

      "Doctor Performance Report": "تقرير أداء الأطباء",
      "Compare doctors by appointments, completion rate, and attendance":
        "مقارنة الأطباء حسب المواعيد، نسبة الإنجاز، والحضور",
      "Back to Reports": "العودة إلى التقارير",
      Print: "طباعة",
      "Export CSV": "تصدير CSV",
      Refresh: "تحديث",
      Filters: "فلاتر",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Apply Filters": "تطبيق الفلاتر",
      "Total Doctors": "إجمالي الأطباء",
      "Total Appointments": "إجمالي المواعيد",
      "Avg Completion Rate": "متوسط نسبة الإنجاز",
      "Report Period": "فترة التقرير",
      "Doctor Statistics": "إحصائيات الأطباء",
      doctors: "طبيب",
      "No data available.": "لا توجد بيانات متاحة",
      Doctor: "الطبيب",
      Specialty: "التخصص",
      Total: "الإجمالي",
      Completed: "مكتمل",
      Scheduled: "مجدول",
      Cancelled: "ملغي",
      "No Show": "عدم حضور",
      "Completion Rate": "نسبة الإنجاز",
      "Failed to load doctor performance report.":
        "فشل تحميل تقرير أداء الأطباء",

      // ====================  Clinic Reports  ====================

      "Clinic Reports": "تقارير العيادة",
      "Reporting hub for finance, appointments, doctors, and patient activity":
        "مركز التقارير للمالية، المواعيد، الأطباء، ونشاط المرضى",
      "Back to Dashboard": "العودة إلى لوحة التحكم",
      "Global Filters": "فلاتر عامة",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Doctor ID": "رقم الطبيب",
      Optional: "اختياري",
      "These filters are UI-ready and can be wired to report APIs next.":
        "هذه الفلاتر جاهزة للواجهة ويمكن ربطها بواجهات برمجة تطبيقات التقارير لاحقاً",
      Report: "تقرير",
      "Recommended First Reports": "التقارير الموصى بها أولاً",
      "Revenue Report": "تقرير الإيرادات",
      revenue_report_desc:
        "تتبع الإيرادات، المبالغ المدفوعة، والأرصدة المستحقة.",
      revenue_hint_text:
        "الأكثر أهمية للإدارة لأنه يربط الفواتير، المدفوعات، المبالغ المستردة، والأرصدة المتبقية.",
      "Appointments Report": "تقرير المواعيد",
      appointments_report_desc:
        "مراجعة المواعيد المجدولة، المكتملة، الملغاة، وعدم الحضور.",
      appointments_hint_text:
        "حيوي للعمليات لأنه يظهر حجم الحجوزات، نسبة الإكمال، الإلغاء، وأنماط عدم الحضور.",
      "Doctor Performance": "أداء الأطباء",
      doctor_performance_desc:
        "مقارنة الأطباء حسب حجم المواعيد والزيارات المكتملة.",
      doctor_performance_hint_text:
        "مفيد لمقارنة الأطباء وتخطيط الجداول، التوظيف، والإنتاجية.",
      "Analytics Dashboard": "لوحة التحليل",
      analytics_dashboard_desc:
        "رسوم بيانية للإيرادات، المواعيد، حمل الأطباء، والتحصيلات.",
      "Payments Report": "تقرير المدفوعات",
      payments_report_desc: "تحليل المدفوعات، المبالغ المستردة، وطرق الدفع.",
      "Treatment Plans Report": "تقرير خطط العلاج",
      treatment_plans_report_desc:
        "مراجعة إجماليات الخطط، الفوترة، وتقدم التحصيل.",
      "Patients Report": "تقرير المرضى",
      patients_report_desc:
        "عرض المرضى النشطين، التسجيلات الجديدة، ونشاط المرضى.",

      // ====================  Revenue Report  ====================

      "Revenue Report": "تقرير الإيرادات",
      "Revenue analysis based on invoices, payments, refunds, and balances":
        "تحليل الإيرادات بناءً على الفواتير، المدفوعات، المبالغ المستردة، والأرصدة",
      "Back to Reports": "العودة إلى التقارير",
      Print: "طباعة",
      "Export CSV": "تصدير CSV",
      Refresh: "تحديث",
      Filters: "فلاتر",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Apply Filters": "تطبيق الفلاتر",
      "Total Invoiced": "إجمالي المفوتر",
      "Gross Paid": "إجمالي المدفوع",
      Refunded: "المسترد",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      "Report Summary": "ملخص التقرير",
      Range: "النطاق",
      "This report is currently derived from the invoices listing response. It is ready to be switched later to a dedicated revenue-report API without changing the UI structure.":
        "تم اشتقاق هذا التقرير حالياً من استجابة قائمة الفواتير. وهو جاهز للتحويل لاحقاً إلى واجهة برمجة تطبيقات مخصصة لتقرير الإيرادات دون تغيير هيكل الواجهة.",
      "Revenue Rows": "صفوف الإيرادات",
      invoices: "فاتورة",
      "No revenue rows found.": "لا توجد صفوف إيرادات",
      Invoice: "الفاتورة",
      Customer: "العميل",
      Invoiced: "مفوتر",
      "Gross Paid": "إجمالي المدفوع",
      "Net Paid": "صافي المدفوع",
      Status: "الحالة",
      Issued: "تاريخ الإصدار",
      Paid: "مدفوع",
      Unpaid: "غير مدفوع",
      Cancelled: "ملغي",
      "Partially Paid": "مدفوع جزئياً",
      "Failed to load revenue report.": "فشل تحميل تقرير الإيرادات",

      // ====================  Clinic Settings  ====================

      "Clinic Settings": "إعدادات العيادة",
      "Manage clinic profile, invoice settings, and defaults":
        "إدارة ملف العيادة، إعدادات الفواتير، والإعدادات الافتراضية",
      Refresh: "تحديث",
      "Settings Form": "نموذج الإعدادات",
      "Clinic Name": "اسم العيادة",
      "My Clinic": "عيادتي",
      Phone: "الهاتف",
      Email: "البريد الإلكتروني",
      Currency: "العملة",
      Timezone: "المنطقة الزمنية",
      Language: "اللغة",
      "Invoice Prefix": "بادئة الفاتورة",
      "Invoice Start Number": "رقم بدء الفاتورة",
      "Save Settings": "حفظ الإعدادات",
      Reset: "إعادة تعيين",
      "Current Summary": "الملخص الحالي",
      "Failed to load clinic settings.": "فشل تحميل إعدادات العيادة",
      "Clinic settings updated successfully.": "تم تحديث إعدادات العيادة بنجاح",
      "Failed to update clinic settings.": "فشل تحديث إعدادات العيادة",
      English: "الإنجليزية",
      Arabic: "العربية",
      "Saving...": "جاري الحفظ...",

      // ====================  Procedures  ====================

      Procedures: "الإجراءات",
      "Manage clinic procedures, default prices, and active status":
        "إدارة إجراءات العيادة، الأسعار الافتراضية، والحالة النشطة",
      "Add Procedure": "إضافة إجراء",
      Refresh: "تحديث",
      Filters: "فلاتر",
      Search: "بحث",
      "ID, procedure name, default price...":
        "الرقم، اسم الإجراء، السعر الافتراضي...",
      Status: "الحالة",
      "All Statuses": "جميع الحالات",
      Active: "نشط",
      Inactive: "غير نشط",
      "Total Loaded": "إجمالي المحمل",
      Filtered: "المفلتر",
      "Clear Filters": "مسح الفلاتر",
      "Procedures List": "قائمة الإجراءات",
      procedures: "إجراء",
      "No procedures found.": "لا توجد إجراءات",
      ID: "الرقم",
      Procedure: "الإجراء",
      "Default Price": "السعر الافتراضي",
      Created: "تاريخ الإنشاء",
      Actions: "إجراءات",
      "Edit Procedure": "تعديل الإجراء",
      Edit: "تعديل",
      Deactivate: "إلغاء التنشيط",
      Activate: "تنشيط",
      "Saving...": "جاري الحفظ...",
      "Failed to load procedures.": "فشل تحميل الإجراءات",
      'Activate procedure "{{name}}"?': 'تنشيط الإجراء "{{name}}"؟',
      'Deactivate procedure "{{name}}"?': 'إلغاء تنشيط الإجراء "{{name}}"؟',
      "Procedure activated successfully.": "تم تنشيط الإجراء بنجاح",
      "Procedure deactivated successfully.": "تم إلغاء تنشيط الإجراء بنجاح",
      "Failed to update procedure.": "فشل تحديث الإجراء",

      // ====================  Create Procedure  ====================

      "Edit Procedure": "تعديل إجراء",
      "Add Procedure": "إضافة إجراء",
      "Manage procedure name, default price, and active status":
        "إدارة اسم الإجراء، السعر الافتراضي، والحالة النشطة",
      "Back to Procedures": "العودة إلى الإجراءات",
      Refresh: "تحديث",
      "Procedure Details": "تفاصيل الإجراء",
      "New Procedure": "إجراء جديد",
      "Procedure Name": "اسم الإجراء",
      "e.g. Root Canal": "مثال: علاج عصب",
      "Default Price": "السعر الافتراضي",
      Status: "الحالة",
      Active: "نشط",
      Inactive: "غير نشط",
      Notes: "ملاحظات",
      "Default Price is used when adding this procedure to a treatment plan. Existing treatment plan items keep their saved price and will not be changed automatically.":
        "يتم استخدام السعر الافتراضي عند إضافة هذا الإجراء إلى خطة العلاج. تحتفظ عناصر خطة العلاج الموجودة بسعرها المحفوظ ولن يتم تغييرها تلقائياً.",
      "Save Changes": "حفظ التغييرات",
      "Create Procedure": "إنشاء إجراء",
      Cancel: "إلغاء",
      "Failed to load procedure.": "فشل تحميل الإجراء",
      "Procedure updated successfully.": "تم تحديث الإجراء بنجاح",
      "Procedure created successfully.": "تم إنشاء الإجراء بنجاح",
      "Failed to save procedure.": "فشل حفظ الإجراء",
      "Saving...": "جاري الحفظ...",
      "Creating...": "جاري الإنشاء...",
      "Supplier Statement": "كشف حساب المورد",
      "Loading statement...": "جاري تحميل كشف الحساب...",
      "Back to Suppliers": "العودة إلى الموردين",
      "Date Range Filter": "فلتر النطاق الزمني",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Apply Filters": "تطبيق الفلاتر",
      Reset: "إعادة تعيين",
      "Opening Balance": "الرصيد الافتتاحي",
      "Closing Balance": "الرصيد الختامي",
      "Total Entries": "إجمالي الإدخالات",
      Period: "الفترة",
      All: "الكل",
      Today: "اليوم",
      "Statement Entries": "إدخالات كشف الحساب",
      entries: "إدخال",
      "No entries in this period": "لا توجد إدخالات في هذه الفترة",
      "Purchase Order": "أمر شراء",
      Payment: "دفعة",
      Refund: "استرداد",
      PO: "أمر شراء",
      Debit: "مدين",
      Credit: "دائن",
      Balance: "الرصيد",
      "Failed to load supplier statement": "فشل تحميل كشف حساب المورد",

      // وفي كائن ar:
      "Create Purchase Order": "إنشاء أمر شراء",
      "Fill in the details to create a new purchase order":
        "املأ التفاصيل لإنشاء أمر شراء جديد",
      "Supplier Information": "معلومات المورد",
      "Select Supplier": "اختر المورد",
      "Choose a supplier...": "اختر مورداً...",
      "Supplier selected": "تم اختيار المورد",
      "Order Items": "عناصر الطلب",
      "Add Item": "إضافة عنصر",
      Product: "المنتج",
      Quantity: "الكمية",
      "Unit Cost": "سعر الوحدة",
      "Line Total": "إجمالي السطر",
      "Remove item": "إزالة العنصر",
      "Order Summary": "ملخص الطلب",
      Supplier: "المورد",
      "Total Items": "إجمالي العناصر",
      "Grand Total": "الإجمالي الكلي",
      "Not selected": "غير مختار",
      "Choose supplier...": "اختر مورداً...",
      "Select product...": "اختر منتجاً...",
      Add: "إضافة",
      Item: "عنصر",
      Cancel: "إلغاء",
      "Creating...": "جاري الإنشاء...",
      "Failed to load suppliers or products": "فشل تحميل الموردين أو المنتجات",
      "Please select supplier": "الرجاء اختيار المورد",
      "Add at least one item with valid quantity and cost":
        "أضف عنصراً واحداً على الأقل بكمية وتكلفة صالحتين",
      "Purchase order created": "تم إنشاء أمر الشراء",
      "Failed to create purchase order": "فشل إنشاء أمر الشراء",

      // وفي كائن ar:
      "Purchase Order": "أمر شراء",
      PO: "أمر شراء",
      Back: "رجوع",
      "Total Amount": "الإجمالي الكلي",
      Paid: "مدفوع",
      Remaining: "المتبقي",
      Received: "تم الاستلام",
      Yes: "نعم",
      No: "لا",
      "Receive Items": "استلام العناصر",
      "Add to stock": "إضافة إلى المخزون",
      "Make Payment": "إجراء دفعة",
      Amount: "المبلغ",
      "Payment Method": "طريقة الدفع",
      Cash: "نقدي",
      Bank: "بنك",
      "Bank Transfer": "تحويل بنكي",
      "Credit Card": "بطاقة ائتمان",
      Card: "بطاقة",
      "Pay Now": "ادفع الآن",
      "Processing...": "جاري المعالجة...",
      "Order Items": "عناصر الطلب",
      Product: "المنتج",
      Quantity: "الكمية",
      "Unit Cost": "سعر الوحدة",
      "Line Total": "إجمالي السطر",
      Actions: "إجراءات",
      Returns: "مرتجعات",
      Log: "سجل",
      "Payment History": "سجل المدفوعات",
      "Payment ID": "رقم الدفعة",
      Method: "طريقة الدفع",
      Date: "التاريخ",
      "No payments recorded yet": "لا توجد مدفوعات مسجلة بعد",
      Supplier: "المورد",
      "N/A": "غير متوفر",
      Items: "العناصر",
      Payments: "المدفوعات",
      "Enter amount": "أدخل المبلغ",
      "Receive this purchase order and add stock?":
        "استلام أمر الشراء وإضافة إلى المخزون؟",
      "Received successfully": "تم الاستلام بنجاح",
      "Receive failed": "فشل الاستلام",
      "Enter valid amount": "أدخل مبلغاً صالحاً",
      "Payment recorded": "تم تسجيل الدفعة",
      "Payment failed": "فشل الدفع",
      "Failed to load purchase order": "فشل تحميل أمر الشراء",
      "Purchase order not found": "أمر الشراء غير موجود",
      "Go Back": "رجوع",
      Pending: "قيد الانتظار",
      Confirmed: "مؤكد",
      Cancelled: "ملغي",
      Delivered: "تم التوصيل",
      Total: "الإجمالي",

      // وفي كائن ar:
      "Purchase Order Returns": "مرتجعات أمر الشراء",
      "Return items from purchase order": "إرجاع عناصر من أمر الشراء",
      "Back to Order": "العودة إلى الطلب",
      Product: "المنتج",
      Received: "تم الاستلام",
      Returned: "تم الإرجاع",
      "Available for Return": "متاح للإرجاع",
      "Return Quantity": "كمية الإرجاع",
      Action: "إجراء",
      Return: "إرجاع",
      "Return Item": "إرجاع العنصر",
      Qty: "الكمية",
      "Enter a valid quantity": "أدخل كمية صالحة",
      "Quantity exceeds the available return quantity":
        "الكمية تتجاوز الكمية المتاحة للإرجاع",
      "Return recorded successfully": "تم تسجيل الإرجاع بنجاح",
      "Failed to process return": "فشل معالجة الإرجاع",
      "Failed to load returnable items": "فشل تحميل العناصر القابلة للإرجاع",
      "No items available for return": "لا توجد عناصر متاحة للإرجاع",
      "Go Back": "رجوع",
      "Confirm Return": "تأكيد الإرجاع",
      Available: "متاح",
      Cancel: "إلغاء",
      "Exceeds available quantity": "يتجاوز الكمية المتاحة",
      "No quantity available for return": "لا توجد كمية متاحة للإرجاع",

      // وفي كائن ar:
      "Purchase Order Returns Log": "سجل مرتجعات أمر الشراء",
      "Return history for purchase order": "سجل الإرجاع لأمر الشراء",
      "Back to Order": "العودة إلى الطلب",
      "Total Returns": "إجمالي المرتجعات",
      "Total Items Returned": "إجمالي العناصر المرتجعة",
      Product: "المنتج",
      "Returned Quantity": "كمية الإرجاع",
      "Date & Time": "التاريخ والوقت",
      "Return ID": "رقم الإرجاع",
      Showing: "عرض",
      "return record": "سجل إرجاع",
      "Returns Log": "سجل المرتجعات",
      "No Returns Found": "لا توجد مرتجعات",
      "This purchase order has no return records":
        "أمر الشراء هذا لا يحتوي على سجلات إرجاع",
      "Go Back": "رجوع",
      "Items Returned": "العناصر المرتجعة",
      "No return records found": "لا توجد سجلات إرجاع",
      "N/A": "غير متوفر",
      "Failed to load returns history": "فشل تحميل سجل المرتجعات",

      // وفي كائن ar:
      "Purchase Orders": "أوامر الشراء",
      "Manage and track all purchase orders": "إدارة وتتبع جميع أوامر الشراء",
      "New Purchase Order": "أمر شراء جديد",
      "Search by ID, supplier or status...":
        "البحث بالرقم، المورد أو الحالة...",
      All: "الكل",
      Pending: "قيد الانتظار",
      Confirmed: "مؤكد",
      Delivered: "تم التوصيل",
      Cancelled: "ملغي",
      "PO #": "رقم أمر الشراء",
      Supplier: "المورد",
      Total: "الإجمالي",
      Paid: "مدفوع",
      Remaining: "المتبقي",
      Status: "الحالة",
      Actions: "إجراءات",
      "View details": "عرض التفاصيل",
      "Edit order": "تعديل الطلب",
      Showing: "عرض",
      of: "من",
      orders: "طلب",
      "Create new order": "إنشاء طلب جديد",
      "Search orders...": "البحث في الطلبات...",
      "No purchase orders found": "لا توجد أوامر شراء",
      "Create New Order": "إنشاء أمر شراء جديد",
      "Failed to fetch purchase orders": "فشل تحميل أوامر الشراء",
      PO: "أمر شراء",
      "N/A": "غير متوفر",

      // وفي كائن ar:
      "Create New Order": "إنشاء طلب جديد",
      "Fill in the details to create a new order":
        "املأ التفاصيل لإنشاء طلب جديد",
      "Order Summary": "ملخص الطلب",
      Items: "العناصر",
      Total: "الإجمالي",
      "Customer Details": "تفاصيل العميل",
      "Select Customer": "اختر العميل",
      "Select a customer...": "اختر عميلاً...",
      "Customer selected": "تم اختيار العميل",
      "Find Products": "البحث عن منتجات",
      "Search products by name or ID...": "البحث عن منتجات بالاسم أو الرقم...",
      "Order Items": "عناصر الطلب",
      "Add New Item": "إضافة عنصر جديد",
      Product: "المنتج",
      "Unit Price": "سعر الوحدة",
      Quantity: "الكمية",
      Subtotal: "المجموع الفرعي",
      Actions: "إجراءات",
      "Select product...": "اختر منتجاً...",
      "Remove item": "إزالة العنصر",
      "Reset Form": "إعادة تعيين النموذج",
      "Processing...": "جاري المعالجة...",
      "Create Order": "إنشاء طلب",
      "Customer Information": "معلومات العميل",
      "Choose a customer": "اختر عميلاً",
      "Add Item": "إضافة عنصر",
      "Search products...": "البحث عن منتجات...",
      Item: "عنصر",
      "Select product": "اختر منتجاً",
      "Number of items": "عدد العناصر",
      Customer: "العميل",
      "Not selected": "غير مختار",
      "Total Amount": "الإجمالي الكلي",
      "Creating Order...": "جاري إنشاء الطلب...",
      "Please select a customer": "الرجاء اختيار عميل",
      "Please select a product for all items":
        "الرجاء اختيار منتج لجميع العناصر",
      "Order created successfully": "تم إنشاء الطلب بنجاح",
      "Failed to create order": "فشل إنشاء الطلب",
      "N/A": "غير متوفر",

      // وفي كائن ar:
      "Order Details": "تفاصيل الطلب",
      Order: "طلب",
      "Loading order details...": "جاري تحميل تفاصيل الطلب...",
      "Order not found": "الطلب غير موجود",
      "Go Back": "رجوع",
      "Failed to load order": "فشل تحميل الطلب",
      "Confirm this order and create invoice?":
        "تأكيد هذا الطلب وإنشاء فاتورة؟",
      "Confirm failed": "فشل التأكيد",
      "Cancel this order and restore stock?":
        "إلغاء هذا الطلب واستعادة المخزون؟",
      "Cancel failed": "فشل الإلغاء",
      Print: "طباعة",
      "View Invoice": "عرض الفاتورة",
      Customer: "العميل",
      Date: "التاريخ",
      "Total Amount": "الإجمالي الكلي",
      "Customer Information": "معلومات العميل",
      Name: "الاسم",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      "Order Items": "عناصر الطلب",
      Product: "المنتج",
      Quantity: "الكمية",
      "Unit Price": "سعر الوحدة",
      Total: "الإجمالي",
      "Order Actions": "إجراءات الطلب",
      "Confirm Order": "تأكيد الطلب",
      "Cancel Order": "إلغاء الطلب",
      "Order Confirmed": "تم تأكيد الطلب",
      "Order Cancelled": "تم إلغاء الطلب",
      "Confirm order and create invoice": "تأكيد الطلب وإنشاء فاتورة",
      "Cannot confirm order": "لا يمكن تأكيد الطلب",
      "Cancel order and restore stock": "إلغاء الطلب واستعادة المخزون",
      "Cannot cancel order": "لا يمكن إلغاء الطلب",
      "Invoice #{id} has been created": "تم إنشاء الفاتورة #{id}",
      "Stock has been restored": "تم استعادة المخزون",
      "Confirm is disabled because": "التأكيد معطل بسبب",
      "Order is not in pending status": "الطلب ليس في حالة قيد الانتظار",
      "Order has no items": "الطلب لا يحتوي على عناصر",
      "Invoice already exists (#{id})": "الفاتورة موجودة مسبقاً (#{id})",
      "Order can be confirmed only when it's pending, has items, and no invoice exists.":
        "يمكن تأكيد الطلب فقط عندما يكون قيد الانتظار، ويحتوي على عناصر، ولا توجد فاتورة موجودة.",
      Pending: "قيد الانتظار",
      Confirmed: "مؤكد",
      Cancelled: "ملغي",
      "Invoice Details": "تفاصيل الفاتورة",
      Invoice: "الفاتورة",
      "Invoice Status": "حالة الفاتورة",
      "N/A": "غير متوفر",

      // وفي كائن ar:
      "Orders Management": "إدارة الطلبات",
      "Manage and track all customer orders": "إدارة وتتبع جميع طلبات العملاء",
      "New Order": "طلب جديد",
      Orders: "الطلبات",
      All: "الكل",
      ID: "الرقم",
      Customer: "العميل",
      Total: "الإجمالي",
      Date: "التاريخ",
      Actions: "إجراءات",
      "Confirm order": "تأكيد الطلب",
      "Cancel order": "إلغاء الطلب",
      "View details": "عرض التفاصيل",
      "Edit order": "تعديل الطلب",
      "View order #{id}": "عرض الطلب #{id}",
      "Confirm this order?": "تأكيد هذا الطلب؟",
      "Cancel this order?": "إلغاء هذا الطلب؟",
      Confirm: "تأكيد",
      Cancel: "إلغاء",
      Details: "تفاصيل",
      "No orders found": "لا توجد طلبات",
      "No {status} orders found": "لا توجد طلبات {status}",
      "Create New Order": "إنشاء طلب جديد",
      Showing: "عرض",
      of: "من",
      orders: "طلب",
      "No Customer": "لا يوجد عميل",
      "Failed to fetch orders": "فشل تحميل الطلبات",
      "Confirm failed": "فشل التأكيد",
      "Cancel failed": "فشل الإلغاء",
      "Loading orders...": "جاري تحميل الطلبات...",
      Confirmed: "مؤكد",
      Pending: "قيد الانتظار",
      Cancelled: "ملغي",

      // وفي كائن ar:
      "Dentist portrait": "صورة طبيب أسنان",
      "Female dentist": "طبيبة أسنان",
      "Dental examination": "فحص أسنان",
      "Expert Dental Care": "رعاية أسنان متخصصة",
      "Professional dental services for your perfect smile":
        "خدمات أسنان احترافية لابتسامتك المثالية",
      "Modern Dental Clinic": "عيادة أسنان حديثة",
      "State-of-the-art equipment and comfortable environment":
        "أحدث المعدات وبيئة مريحة",
      "Comprehensive Check-ups": "فحوصات شاملة",
      "Regular dental examinations for optimal oral health":
        "فحوصات أسنان منتظمة لصحة فم مثالية",
      smiles: "الابتسامات",
      teeth: "الأسنان",
      lives: "الحياة",
      Better: "أفضل",
      "Welcome to our dental clinic! We provide comprehensive dental care with state-of-the-art technology and a gentle, caring approach. Your smile is our priority.":
        "مرحباً بكم في عيادة الأسنان! نقدم رعاية أسنان شاملة بأحدث التقنيات ونهج لطيف ورعاية. ابتسامتكم هي أولويتنا.",
      "Our Services": "خدماتنا",
      "Book Appointment": "احجز موعداً",
      "Our Dental Services": "خدمات الأسنان",
      "Comprehensive dental care for the whole family":
        "رعاية أسنان شاملة لجميع أفراد العائلة",
      "General Dentistry": "طب الأسنان العام",
      "Regular check-ups, cleanings, and preventive care":
        "فحوصات منتظمة، تنظيف، ورعاية وقائية",
      "Cosmetic Dentistry": "طب الأسنان التجميلي",
      "Teeth whitening, veneers, and smile makeovers":
        "تبييض الأسنان، القشور الخزفية، وتجميل الابتسامة",
      "Pediatric Dentistry": "طب أسنان الأطفال",
      "Gentle dental care for children": "رعاية أسنان لطيفة للأطفال",
      "Root Canal Treatment": "علاج العصب",
      "Pain-free root canal procedures": "إجراءات علاج عصب بدون ألم",

      // وفي كائن ar:
      Home: "الرئيسية",
      About: "عن العيادة",
      Timeline: "الجدول الزمني",
      Testimonials: "آراء المرضى",
      Booking: "حجز موعد",
      Contact: "اتصل بنا",
      Login: "تسجيل الدخول",
      Register: "إنشاء حساب",
      Logout: "تسجيل خروج",
      Profile: "الملف الشخصي",
      "My Appointments": "مواعيدي",
      Account: "الحساب",
      "Dental Care": "رعاية الأسنان",
      "Smile Specialist": "أخصائي الابتسامة",
      "Toggle navigation": "تبديل القائمة",
      العربية: "العربية",
      English: "English",

      // وفي كائن ar:
      "Opening Hours": "ساعات العمل",
      Sunday: "الأحد",
      Closed: "مغلق",
      "Monday - Friday": "الاثنين - الجمعة",
      Saturday: "السبت",
      "Our Clinic": "عيادتنا",
      "123 Dental Street, San Diego, CA 92123":
        "123 شارع الأسنان، سان دييغو، كاليفورنيا 92123",
      "Follow Us": "تابعونا",
      Facebook: "فيسبوك",
      Twitter: "تويتر",
      Instagram: "إنستغرام",
      YouTube: "يوتيوب",
      "Quick Links": "روابط سريعة",
      "About Us": "من نحن",
      "Book Appointment": "احجز موعداً",
      Testimonials: "آراء المرضى",
      "Contact Us": "اتصل بنا",
      "Dental Care Clinic": "عيادة رعاية الأسنان",
      "All rights reserved.": "جميع الحقوق محفوظة.",
      "Design by": "تصميم بواسطة",

      // وفي كائن ar:
      "About Our Dental Clinic": "عن عيادة الأسنان",
      "Your trusted partner in dental health and beautiful smiles":
        "شريكك الموثوق في صحة الأسنان والابتسامة الجميلة",
      "Our Mission": "مهمتنا",
      "To provide exceptional dental care in a comfortable, caring environment while empowering patients with knowledge about their oral health.":
        "تقديم رعاية أسنان استثنائية في بيئة مريحة ورعاية مع تمكين المرضى بالمعرفة حول صحتهم الفموية.",
      "Our Vision": "رؤيتنا",
      "To be the leading dental clinic recognized for excellence in patient care, innovation, and creating confident smiles.":
        "أن نكون العيادة الرائدة المعترف بها للتميز في رعاية المرضى والابتكار وخلق ابتسامات واثقة.",
      "Our Values": "قيمنا",
      "Integrity, compassion, excellence, and innovation guide everything we do.":
        "النزاهة والرحمة والتميز والابتكار توجه كل ما نقوم به.",
      "Meet Our Expert Dentists": "تعرف على أطباء الأسنان الخبراء",
      "Our team of experienced professionals is dedicated to your smile":
        "فريقنا من المهنيين ذوي الخبرة مكرس لابتسامتك",
      Years: "سنوات",
      "Book Appointment": "احجز موعداً",
      "Our Core Values": "قيمنا الأساسية",
      "The principles that guide our practice every day":
        "المبادئ التي توجه ممارستنا كل يوم",
      "Compassionate Care": "رعاية متعاطفة",
      "We treat every patient with kindness, empathy, and understanding.":
        "نعامل كل مريض بلطف وتعاطف وتفهم.",
      Excellence: "التميز",
      "We strive for the highest quality in everything we do.":
        "نسعى لأعلى جودة في كل ما نقوم به.",
      "Patient-Centered": "محورها المريض",
      "Your comfort and satisfaction are our top priorities.":
        "راحتك ورضاك هما أولوياتنا القصوى.",
      Innovation: "الابتكار",
      "We embrace the latest technology and techniques in dentistry.":
        "نتبنى أحدث التقنيات والأساليب في طب الأسنان.",
      "Years of Experience": "سنوات من الخبرة",
      "Happy Patients": "مرضى سعداء",
      "Dental Procedures": "إجراءات الأسنان",
      "Emergency Care": "رعاية طارئة",
      "Over 15 Years of Excellence in Dental Care":
        "أكثر من 15 عاماً من التميز في رعاية الأسنان",
      "Since 2008, we've been committed to providing the highest quality dental care to our community. Our continuous investment in education, technology, and patient comfort ensures you receive the best possible treatment.":
        "منذ عام 2008، نحن ملتزمون بتقديم أعلى مستويات الرعاية السنية لمجتمعنا. استثمارنا المستمر في التعليم والتكنولوجيا وراحة المرضى يضمن لك الحصول على أفضل علاج ممكن.",
      "Schedule Your Visit": "حدد موعد زيارتك",
      "Ready for a Healthier Smile?": "هل أنت مستعد لابتسامة أكثر صحة؟",
      "Book your appointment today and let us help you achieve the smile you've always wanted.":
        "احجز موعدك اليوم ودعنا نساعدك في تحقيق الابتسامة التي طالما أردتها.",
      "Contact Us": "اتصل بنا",
      "Dr. Sarah Johnson": "د. سارة جونسون",
      "General & Cosmetic Dentistry": "طب الأسنان العام والتجميلي",
      "Dr. Sarah is dedicated to providing gentle, comprehensive dental care with a focus on preventive treatments and patient education.":
        "الدكتورة سارة مكرسة لتقديم رعاية أسنان لطيفة وشاملة مع التركيز على العلاجات الوقائية وتثقيف المرضى.",
      "Dr. Michael Chen": "د. مايكل تشين",
      "Orthodontics & Pediatric Dentistry": "تقويم الأسنان وطب أسنان الأطفال",
      "Dr. Michael specializes in orthodontic treatments and children's dentistry, creating beautiful smiles for the whole family.":
        "الدكتور مايكل متخصص في علاجات تقويم الأسنان وطب أسنان الأطفال، مما يخلق ابتسامات جميلة لجميع أفراد الأسرة.",
      "Dr. Emily Rodriguez": "د. إيميلي رودريغيز",
      "Oral Surgery & Implantology": "جراحة الفم وزراعة الأسنان",
      "Dr. Emily is an expert in dental implants and surgical procedures, ensuring comfortable and successful treatments.":
        "الدكتورة إيميلي خبيرة في زراعة الأسنان والإجراءات الجراحية، مما يضمن علاجات مريحة وناجحة.",

      // وفي كائن ar:
      "Book Your Dental Appointment": "احجز موعدك لطب الأسنان",
      "Schedule your visit with our expert dentists. We're here to help you achieve a healthy, beautiful smile.":
        "حدد موعد زيارتك مع أطباء الأسنان الخبراء. نحن هنا لمساعدتك في تحقيق ابتسامة صحية وجميلة.",
      "Appointment Request": "طلب موعد",
      "Fill out the form below and we'll confirm your appointment shortly.":
        "املأ النموذج أدناه وسنقوم بتأكيد موعدك قريباً.",
      "Appointment Request Sent!": "تم إرسال طلب الموعد!",
      "Thank you for choosing our dental clinic. We'll contact you shortly to confirm your appointment.":
        "شكراً لاختيارك عيادتنا للأسنان. سوف نتصل بك قريباً لتأكيد موعدك.",
      "Back to Home": "العودة إلى الرئيسية",
      "Full Name": "الاسم الكامل",
      "Enter your full name": "أدخل اسمك الكامل",
      "Email Address": "البريد الإلكتروني",
      "your@email.com": "بريدك@example.com",
      "Phone Number": "رقم الهاتف",
      "+1 234 567 8900": "+1 234 567 8900",
      "Service Required": "الخدمة المطلوبة",
      "Select a service": "اختر خدمة",
      "General Dentistry (Check-up, Cleaning)": "طب الأسنان العام (فحص، تنظيف)",
      "Cosmetic Dentistry (Whitening, Veneers)":
        "طب الأسنان التجميلي (تبييض، قشور)",
      "Orthodontic Treatment (Braces, Aligners)":
        "علاج تقويم الأسنان (تقويم، شفاف)",
      "Root Canal Treatment": "علاج العصب",
      "Dental Implants": "زراعة الأسنان",
      "Pediatric Dentistry": "طب أسنان الأطفال",
      "Emergency Dental Care": "رعاية أسنان طارئة",
      "Preferred Doctor": "الطبيب المفضل",
      "Dr. Sarah Johnson - General & Cosmetic": "د. سارة جونسون - عام وتجميلي",
      "Dr. Michael Chen - Orthodontics": "د. مايكل تشين - تقويم أسنان",
      "Dr. Emily Rodriguez - Oral Surgery": "د. إيميلي رودريغيز - جراحة الفم",
      "Any Available Doctor": "أي طبيب متاح",
      "Preferred Date": "التاريخ المفضل",
      "Preferred Time": "الوقت المفضل",
      "Select a time slot": "اختر وقتاً",
      "Additional Notes": "ملاحظات إضافية",
      "Any special requests or concerns?": "أي طلبات خاصة أو مخاوف؟",
      "Scheduling...": "جاري الحجز...",
      "Book Appointment": "احجز موعداً",
      Reset: "إعادة تعيين",
      "Before Your Visit": "قبل زيارتك",
      "Bring your insurance card and ID": "أحضر بطاقة التأمين والهوية",
      "Arrive 15 minutes before your appointment": "احضر قبل موعدك بـ 15 دقيقة",
      "Complete any required forms": "أكمل أي نماذج مطلوبة",
      "List any medications you're taking": "أدرج أي أدوية تتناولها",
      "Working Hours": "ساعات العمل",
      "Monday - Friday": "الاثنين - الجمعة",
      Saturday: "السبت",
      Sunday: "الأحد",
      Closed: "مغلق",
      Emergency: "طوارئ",
      "Contact Us": "اتصل بنا",
      "123 Dental Street, San Diego, CA 92123":
        "123 شارع الأسنان، سان دييغو، كاليفورنيا 92123",

      // وفي كائن ar:
      "What Our Patients Say": "ماذا يقول مرضانا",
      "Real stories from real patients about their experience at our dental clinic":
        "قصص حقيقية من مرضى حقيقيين عن تجربتهم في عيادتنا للأسنان",
      "Happy Patients": "مرضى سعداء",
      "Average Rating": "متوسط التقييم",
      "Would Recommend": "يوصون بنا",
      "Smiles Created": "ابتسامة تم إنشاؤها",
      "Patient Testimonials": "آراء المرضى",
      "Don't just take our word for it - hear from our amazing patients":
        "لا تأخذ كلامنا فقط - اسمع من مرضانا الرائعين",
      "Regular Patient": "مريض منتظم",
      "Recovered Patient": "مريض متعافي",
      "New Patient": "مريض جديد",
      "Happy Patient": "مريض سعيد",
      "Orthodontic Patient": "مريض تقويم",
      "Pediatric Patient's Mom": "أم مريض أطفال",
      "Best Dental Care Experience": "أفضل تجربة رعاية أسنان",
      "I've been coming to this clinic for over 3 years and I couldn't be happier. The staff is incredibly friendly, and Dr. Sarah made my root canal procedure completely painless. Highly recommended!":
        "أتردد على هذه العيادة منذ أكثر من 3 سنوات وأنا سعيد جداً. الموظفون ودودون للغاية، والدكتورة سارة جعلت عملية علاج العصب غير مؤلمة تماماً. أنصح بها بشدة!",
      "Root Canal Treatment": "علاج العصب",
      "Amazing Smile Transformation": "تحول مذهل في الابتسامة",
      "After years of being embarrassed about my teeth, I finally decided to get veneers. Dr. Chen did an incredible job! My smile looks completely natural and I feel confident again. Thank you!":
        "بعد سنوات من الإحراج بسبب أسناني، قررت أخيراً الحصول على القشور الخزفية. الدكتور مايكل قام بعمل رائع! ابتسامتي تبدو طبيعية تماماً وأشعر بالثقة مرة أخرى. شكراً لكم!",
      "Cosmetic Veneers": "قشور خزفية تجميلية",
      "Welcoming and Professional": "ترحيب واحترافية",
      "As a new patient, I was nervous about my first visit. The team made me feel welcome from the moment I walked in. The facility is spotless, and Dr. Rodriguez explained everything clearly. I'm so glad I chose this clinic!":
        "كمريض جديد، كنت متوتراً بشأن زيارتي الأولى. جعلني الفريق أشعر بالترحيب منذ لحظة دخولي. المنشأة نظيفة للغاية، والدكتورة إيميلي شرحت كل شيء بوضوح. أنا سعيد جداً باختياري لهذه العيادة!",
      "Dental Cleaning & Check-up": "تنظيف وفحص أسنان",
      "Excellent Emergency Care": "رعاية طارئة ممتازة",
      "I had a dental emergency on a Sunday and they saw me within an hour. The care was exceptional and the pain relief was immediate. Truly grateful for their emergency service!":
        "كانت لدي حالة طوارئ أسنان يوم الأحد واستقبلوني في غضون ساعة. كانت الرعاية استثنائية وتخفيف الألم فورياً. ممتن حقاً لخدمة الطوارئ!",
      "Emergency Dental Care": "رعاية أسنان طارئة",
      "Perfect Braces Results": "نتائج تقويم مثالية",
      "My daughter just finished her braces treatment with Dr. Chen, and the results are amazing! The team was always patient and supportive throughout the entire process. We couldn't be happier with her smile!":
        "ابنتي أنهت للتو علاج التقويم مع الدكتور مايكل، والنتائج مذهلة! كان الفريق صبوراً وداعماً طوال العملية. لا يمكننا أن نكون أكثر سعادة بابتسامتها!",
      "Orthodontic Treatment": "علاج تقويم الأسنان",
      "Great with Kids!": "رائع مع الأطفال!",
      "My 5-year-old was terrified of the dentist, but Dr. Sarah made the experience fun and stress-free. Now my daughter actually looks forward to her dental visits! Thank you for being so patient with children.":
        "كانت ابنتي البالغة من العمر 5 سنوات خائفة من طبيب الأسنان، لكن الدكتورة سارة جعلت التجربة ممتعة وخالية من التوتر. الآن ابنتي تتطلع حقاً لزيارات الأسنان! شكراً لصبركم مع الأطفال.",
      "Pediatric Dentistry": "طب أسنان الأطفال",
      "Share Your Experience": "شارك تجربتك",
      "Had a great experience with us? We'd love to hear about it!":
        "هل كانت لديك تجربة رائعة معنا؟ نحن نحب أن نسمع عنها!",
      "Write a Review": "اكتب تقييماً",

      // وفي كائن ar:
      "Our Journey": "رحلتنا",
      "A timeline of our growth, milestones, and commitment to excellence in dental care":
        "جدول زمني لنمونا وإنجازاتنا والتزامنا بالتميز في رعاية الأسنان",
      "Year Established": "سنة التأسيس",
      "Years Combined Experience": "سنوات الخبرة المشتركة",
      "Happy Patients": "مرضى سعداء",
      "Awards & Recognitions": "جوائز وتكريمات",
      "Our Timeline": "الجدول الزمني",
      "Milestones that shaped our dental clinic into what it is today":
        "محطات رئيسية شكلت عيادتنا للأسنان إلى ما هي عليه اليوم",
      "Key Achievements": "إنجازات رئيسية",
      "Looking Ahead": "نظرة إلى المستقبل",
      "We're committed to continuous improvement and innovation in dental care. Our future plans include:":
        "نحن ملتزمون بالتحسين المستمر والابتكار في رعاية الأسنان. خططنا المستقبلية تشمل:",
      "AI-Powered Diagnostics": "تشخيص مدعوم بالذكاء الاصطناعي",
      "Implementing artificial intelligence for early detection of dental issues":
        "تطبيق الذكاء الاصطناعي للكشف المبكر عن مشاكل الأسنان",
      "Tele-dentistry Services": "خدمات طب الأسنان عن بعد",
      "Virtual consultations and remote monitoring for patient convenience":
        "استشارات افتراضية ومراقبة عن بعد لراحة المرضى",
      "Dental Education Center": "مركز التثقيف السني",
      "Community outreach and educational programs for oral health awareness":
        "برامج توعوية مجتمعية للتوعية بصحة الفم",
      "State-of-the-Art Dental Equipment": "معدات أسنان حديثة",
      "We invested in the latest digital imaging technology, including 3D CBCT scanners and intraoral cameras, allowing for more precise diagnoses and treatment planning.":
        "استثمرنا في أحدث تقنيات التصوير الرقمي، بما في ذلك ماسحات CBCT ثلاثية الأبعاد والكاميرات داخل الفم، مما يتيح تشخيصاً أكثر دقة وتخطيطاً للعلاج.",
      "3D CBCT Scanner installed": "تركيب ماسح CBCT ثلاثي الأبعاد",
      "Intraoral cameras for all operatories":
        "كاميرات داخل الفم لجميع العيادات",
      "Digital smile design software": "برنامج تصميم الابتسامة الرقمي",
      "New Pediatric Wing Opening": "افتتاح جناح طب أسنان الأطفال الجديد",
      "We opened a dedicated pediatric dentistry wing designed specifically for children, featuring a kid-friendly environment, entertainment systems, and specialized pediatric dentists.":
        "افتتحنا جناحاً متخصصاً في طب أسنان الأطفال مصمماً خصيصاً للأطفال، يتميز ببيئة صديقة للأطفال وأنظمة ترفيهية وأطباء أسنان متخصصين في الأطفال.",
      "Child-friendly treatment rooms": "غرف علاج صديقة للأطفال",
      "Sedation dentistry services": "خدمات طب الأسنان بالتخدير",
      "School outreach program launched": "إطلاق برنامج التوعية المدرسية",
      "Expanded Orthodontic Services": "توسيع خدمات تقويم الأسنان",
      "Dr. Michael Chen joined our team, bringing expertise in traditional braces and modern clear aligners. We now offer comprehensive orthodontic treatments for all ages.":
        "انضم الدكتور مايكل تشين إلى فريقنا، مما أضاف خبرة في التقويم التقليدي والمصففات الشفافة الحديثة. نقدم الآن علاجات تقويم شاملة لجميع الأعمار.",
      "Clear aligner treatments available": "علاجات المصففات الشفافة متاحة",
      "Early intervention orthodontics": "تقويم التدخل المبكر",
      "Retainer services": "خدمات المثبتات",
      "Emergency Dental Care 24/7": "رعاية أسنان طارئة على مدار الساعة",
      "Launched our 24/7 emergency dental service to provide immediate care for dental emergencies, including severe toothaches, broken teeth, and dental trauma.":
        "أطلقنا خدمة الطوارئ السنية على مدار الساعة لتوفير رعاية فورية لحالات الطوارئ السنية، بما في ذلك آلام الأسنان الشديدة وكسر الأسنان وإصابات الفم.",
      "24/7 on-call dentists": "أطباء أسنان على مدار الساعة",
      "Emergency treatment within 1 hour": "علاج طارئ خلال ساعة",
      "Pain management protocols": "بروتوكولات إدارة الألم",
      "Dental Implant Center Established": "إنشاء مركز زراعة الأسنان",
      "We established a dedicated dental implant center, bringing together specialists in oral surgery and restorative dentistry to provide comprehensive implant solutions.":
        "أنشأنا مركزاً متخصصاً لزراعة الأسنان، يجمع متخصصين في جراحة الفم وطب الأسنان الترميمي لتقديم حلول زراعة شاملة.",
      "Same-day implant placement": "زراعة الأسنان في نفس اليوم",
      "All-on-4 implant solutions": "حلول زراعة All-on-4",
      "Implant-supported dentures": "أطقم أسنان مدعومة بالزرعات",
      "Clinic Founded": "تأسيس العيادة",
      "Our dental clinic opened its doors with a mission to provide exceptional, patient-centered dental care using the latest technology and techniques.":
        "افتتحت عيادتنا للأسنان أبوابها بمهمة تقديم رعاية أسنان استثنائية تركز على المريض باستخدام أحدث التقنيات والأساليب.",
      "2 treatment rooms": "غرفتي علاج",
      "3 experienced dentists": "3 أطباء أسنان ذوي خبرة",
      "Comprehensive dental services": "خدمات أسنان شاملة",

      // وفي كائن ar:
      "Welcome Back": "مرحباً بعودتك",
      "Please login to your account": "الرجاء تسجيل الدخول إلى حسابك",
      "Email Address": "البريد الإلكتروني",
      "Enter your email": "أدخل بريدك الإلكتروني",
      Password: "كلمة المرور",
      "Enter your password": "أدخل كلمة المرور",
      "Remember me": "تذكرني",
      "Forgot Password?": "نسيت كلمة المرور؟",
      "Login failed. Please check your email and password.":
        "فشل تسجيل الدخول. الرجاء التحقق من بريدك الإلكتروني وكلمة المرور.",
      "Logging in...": "جاري تسجيل الدخول...",
      "Don't have an account?": "ليس لديك حساب؟",
      "Sign up": "إنشاء حساب",
      "Hide password": "إخفاء كلمة المرور",
      "Show password": "إظهار كلمة المرور",
      "Expert Dentists": "أطباء أسنان خبراء",
      "Modern Equipment": "معدات حديثة",
      "Pain-Free Treatments": "علاجات بدون ألم",

      // وفي كائن ar:
      "Join Our Dental Family": "انضم إلى عائلتنا السنية",
      "Create an account to book appointments, view your dental records, and receive personalized care.":
        "أنشئ حساباً لحجز المواعيد، عرض سجلات الأسنان الخاصة بك، والحصول على رعاية شخصية.",
      "Easy Appointment Booking": "حجز مواعيد سهل",
      "Access Dental Records": "الوصول إلى السجلات السنية",
      "Treatment Reminders": "تذكيرات العلاج",
      "Secure & Private": "آمن وخاص",
      "Create Account": "إنشاء حساب",
      "Sign up to get started with your dental care journey":
        "سجل للبدء في رحلة رعاية أسنانك",
      "Full Name": "الاسم الكامل",
      "Enter your full name": "أدخل اسمك الكامل",
      "Email Address": "البريد الإلكتروني",
      "Enter your email": "أدخل بريدك الإلكتروني",
      Password: "كلمة المرور",
      "Create a password": "أنشئ كلمة مرور",
      "Confirm Password": "تأكيد كلمة المرور",
      "Confirm your password": "تأكيد كلمة المرور الخاصة بك",
      "Password must be at least 6 characters":
        "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
      "Passwords do not match": "كلمات المرور غير متطابقة",
      "Registration successful! 🎉": "تم التسجيل بنجاح! 🎉",
      "Registration failed": "فشل التسجيل",
      "Creating account...": "جاري إنشاء الحساب...",
      "Already have an account?": "لديك حساب بالفعل؟",
      "Sign in": "تسجيل الدخول",
      "By creating an account, you agree to our": "بإنشاء حساب، فإنك توافق على",
      "Terms of Service": "شروط الخدمة",
      and: "و",
      "Privacy Policy": "سياسة الخصوصية",
      "Hide password": "إخفاء كلمة المرور",
      "Show password": "إظهار كلمة المرور",

      Notifications: "الإشعارات",
      "No new notifications": "لا توجد إشعارات جديدة",
      "Alert acknowledged": "تم تأكيد التنبيه",
      "Failed to acknowledge alert": "فشل تأكيد التنبيه",
      "New alert received": "تم استلام تنبيه جديد",

      // Notification priorities
      high: "عالية",
      medium: "متوسطة",
      low: "منخفضة",

      // Notification messages
      "High failed reminders": "تذكيرات فاشلة كثيرة",
      "Reminders stuck in processing": "تذكيرات عالقة قيد المعالجة",
      "There are {{count}} failed reminders that need review":
        "هناك {{count}} تذكيرات فاشلة تحتاج إلى مراجعة",
      "There are {{count}} reminders stuck for more than 10 minutes":
        "هناك {{count}} تذكيرات عالقة منذ أكثر من 10 دقائق",

      Notifications: "الإشعارات",
      "Stay updated with important system alerts and reminders":
        "ابق على اطلاع دائم بتنبيهاات النظام والتذكيرات الهامة",
      "Filter Notifications": "تصفية الإشعارات",
      "Notifications List": "قائمة الإشعارات",
      notifications: "إشعار",
      "No notifications found.": "لا توجد إشعارات",
      Unread: "غير مقروء",
      "High Priority": "أولوية عالية",
      "Loading notifications...": "جاري تحميل الإشعارات...",
      Priority: "الأولوية",
      Count: "العدد",
      Code: "الكود",
      Acknowledge: "تأكيد",
      Normal: "عادي",

      "See All Notifications": "عرض كل الإشعارات",

      Today: "اليوم",
      Yesterday: "أمس",
      "days ago": " أيام ",
      ago: "منذ",
      "No high priority notifications": "لا توجد إشعارات عالية الأهمية",
      "No unread notifications!": "🎉 لا توجد إشعارات غير مقروءة!",
      "No more notifications": "لا توجد إشعارات أخرى",

      // وفي كائن ar:
      Radiology: "الأشعة",
      "Radiology Images": "صور الأشعة",
      "X-Ray": "أشعة سينية",
      Panorama: "بانوراما",
      CBCT: "CBCT",
      Cephalometric: "قياس الرأس",
      Other: "أخرى",
      "Click or drag file to upload": "انقر أو اسحب الملف للرفع",
      "Upload Radiology": "رفع صورة أشعة",
      "Uploading...": "جاري الرفع...",
      "e.g., Pre-op X-Ray": "مثال: أشعة قبل العملية",
      "File Type": "نوع الملف",
      "Captured At": "تاريخ التقاط الصورة",
      "Additional notes about this image...": "ملاحظات إضافية عن هذه الصورة...",
      "No radiology images found": "لا توجد صور أشعة",
      "Upload X-rays, Panorama, or CBCT images for this patient":
        "رفع صور أشعة، بانوراما، أو CBCT لهذا المريض",
      "Loading images...": "جاري تحميل الصور...",
      "Are you sure you want to delete this image?":
        "هل أنت متأكد من حذف هذه الصورة؟",
      "Image Gallery": "صور المعرض",
      "Upload New": "ارفع ملف جديد",

      "Analytics Overview": "نظرة تحليلية",
      "Real-time insights at a glance": "رؤى فورية في لمحة",
      "Revenue Overview": "نظرة عامة على الإيرادات",
      "Appointments Today": "مواعيد اليوم",
      Today: "اليوم",
      Month: "الشهر",
      Total: "الإجمالي",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      "No data available": "لا توجد بيانات",
      appointments: "مواعيد",

      critical: "حرج",
      attention: "انتباه",
      info: "معلومات",
      "View Details": "عرض التفاصيل",
      "Acknowledge All": "تأكيد الكل",
      Acknowledge: "تأكيد",

      day: "يوم",
      week: "أسبوع",
      month: "شهر",
      Revenue: "الإيرادات",
      Appointments: "المواعيد",
      Completed: "مكتمل",
      Cancelled: "ملغي",
      "No Show": "لم يحضر",
      "Unpaid Invoices": "فواتير غير مدفوعة",
      "Paid Invoices": "فواتير مدفوعة",
      "New Patients": "مرضى جدد",
      "vs previous": "مقارنة بالسابق",
      "Reset View": "إعادة الضبط",

      "Smart Summary": "ملخص ذكي",
      summary_revenue_up: "الإيرادات ارتفعت بشكل ملحوظ مقارنة بالفترة السابقة",
      summary_revenue_down: "الإيرادات انخفضت مقارنة بالفترة السابقة",
      summary_appointments_up: "المواعيد تتزايد بسرعة ملحوظة",
      summary_no_show_high: "عدد حالات عدم الحضور مرتفع اليوم",
      summary_unpaid_high: "لديك عدد كبير من الفواتير غير المدفوعة",
      summary_cancelled_up: "نسبة الإلغاء مرتفعة اليوم",

      "Current Period": "الفترة الحالية",
      "Previous Period": "الفترة السابقة",
      "Anomaly Detected": "تم اكتشاف شذوذ",
      "Revenue Overview": "نظرة عامة على الإيرادات",
      "Appointments Overview": "نظرة عامة على المواعيد",
      "Total Appointments": "إجمالي المواعيد",
      Completed: "مكتملة",
      Cancelled: "ملغية",
      Current: "الحالي",
      Previous: "السابق",
      Change: "التغير",
      Total: "الإجمالي",
      "vs previous": "مقابل السابق",
      day: "يوم",
      week: "أسبوع",
      month: "شهر",
      "Compare with previous period": "مقارنة بالفترة السابقة",

      Global: "عالمي",
      "All Companies": "كل الشركات",
      Active: "نشط",
      Trial: "تجريبي",
      Suspended: "موقوف",

      "SaaS Management Dashboard": "لوحة تحكم إدارة المنصة",
      "Monitor and manage all clinics from one place":
        "مراقبة وإدارة جميع العيادات من مكان واحد",
      "Total Companies": "إجمالي الشركات",
      "Active Companies": "الشركات النشطة",
      "Trial Companies": "الشركات التجريبية",
      MRR: "الإيراد الشهري المتكرر",
      "Total Revenue": "إجمالي الإيرادات",
      "Suspended Companies": "الشركات المعلقة",
      "vs last period": "مقارنة بالفترة السابقة",
      "vs last month": "مقارنة بالشهر السابق",
      "of total": "من الإجمالي",
      "Monthly Recurring Revenue (MRR)": "الإيراد الشهري المتكرر (MRR)",
      "Companies Growth": "نمو الشركات",
      New: "جديد",
      Churned: "منسحب",
      "New Companies": "شركات جديدة",
      "Churned Companies": "شركات منسحبة",
      "Companies by Status": "الشركات حسب الحالة",
      "Top Performing Clinics": "أفضل العيادات أداءً",
      appts: "مواعيد",
      "Quick Actions": "إجراءات سريعة",
      "Manage your platform efficiently": "إدارة منصتك بكفاءة",
      "Add New Company": "إضافة شركة جديدة",
      "Manage Companies": "إدارة الشركات",
      "Manage Plans": "إدارة الخطط",
      "SaaS Reports": "تقارير المنصة",
      "Recent Companies": "أحدث الشركات",
      "View All": "عرض الكل",
      Company: "الشركة",
      Status: "الحالة",
      Created: "تاريخ الإنشاء",
      "Trial Ends": "انتهاء التجربة",
      "Recent Activities": "آخر النشاطات",
      "No recent companies": "لا توجد شركات حديثة",
      "No recent activities": "لا توجد نشاطات حديثة",
      "No data available": "لا توجد بيانات",
      Active: "نشط",
      Trial: "تجريبي",
      Suspended: "معلق",
      Cancelled: "ملغي",
      Month: "الشهر",
      Net: "الصافي",
      "Loading SaaS Dashboard...": "جاري تحميل لوحة تحكم المنصة...",
      "Something went wrong": "حدث خطأ ما",
      "Try Again": "حاول مرة أخرى",
      "Good Morning": "صباح الخير",
      "Good Afternoon": "مساء الخير",
      "Good Evening": "مساء الخير",
      day: "يوم",
      week: "أسبوع",
      month: "شهر",
      year: "سنة",
      company_created: "تم تسجيل شركة جديدة",
      company_activated: "تم تفعيل الشركة",
      company_suspended: "تم تعليق الشركة",
      subscription_created: "تم إنشاء اشتراك جديد",
      payment_received: "تم استلام دفعة",
      trial_started: "بدأت فترة تجريبية",
      trial_expired: "انتهت فترة تجريبية",

      Companies: "الشركات",
      "Manage all clinics on your platform": "إدارة جميع العيادات على منصتك",
      "Add New Company": "إضافة شركة جديدة",
      "Search by name or slug...": "بحث بالاسم أو المعرف...",
      "All Status": "جميع الحالات",
      Active: "نشط",
      Trial: "تجريبي",
      Suspended: "معلق",
      Cancelled: "ملغي",
      Refresh: "تحديث",
      Company: "الشركة",
      Slug: "المعرف",
      Status: "الحالة",
      Created: "تاريخ الإنشاء",
      "Trial Ends": "انتهاء التجربة",
      Users: "المستخدمين",
      Actions: "إجراءات",
      "No companies found": "لا توجد شركات",
      View: "عرض",
      Edit: "تعديل",
      Suspend: "تعليق",
      Activate: "تفعيل",
      Delete: "حذف",
      "Page {{current}} of {{total}}": "صفحة {{current}} من {{total}}",
      "Loading companies...": "جاري تحميل الشركات...",
      "Something went wrong": "حدث خطأ ما",
      "Try Again": "حاول مرة أخرى",
      "Company suspended successfully": "تم تعليق الشركة بنجاح",
      "Company activated successfully": "تم تفعيل الشركة بنجاح",
      "Company deleted successfully": "تم حذف الشركة بنجاح",
      "Are you sure you want to suspend {{name}}?":
        "هل أنت متأكد من تعليق {{name}}؟",
      "Are you sure you want to activate {{name}}?":
        "هل أنت متأكد من تفعيل {{name}}؟",
      "Are you sure you want to delete {{name}}? This action cannot be undone.":
        "هل أنت متأكد من حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.",
      "{{days}} days left": "{{days}} يوم متبقي",
      Expired: "منتهي",

      "Edit Company": "تعديل الشركة",
      "Add New Company": "إضافة شركة جديدة",
      "Update company information": "تحديث معلومات الشركة",
      "Create a new clinic on your platform": "إنشاء عيادة جديدة على منصتك",
      "Basic Information": "المعلومات الأساسية",
      "Company Name": "اسم الشركة",
      "Enter company name": "أدخل اسم الشركة",
      Slug: "المعرف",
      Check: "تحقق",
      "Slug is available": "المعرف متاح",
      "Slug is already taken": "المعرف مستخدم بالفعل",
      "Company Email": "البريد الإلكتروني للشركة",
      "Company Phone": "هاتف الشركة",
      Address: "العنوان",
      "Enter company address": "أدخل عنوان الشركة",
      "Contact Person": "الشخص المسؤول",
      "Primary contact name": "اسم الشخص المسؤول الرئيسي",
      "Status Information": "معلومات الحالة",
      Status: "الحالة",
      Trial: "تجريبي",
      Active: "نشط",
      Suspended: "معلق",
      Cancelled: "ملغي",
      "Trial Ends At": "تاريخ انتهاء التجربة",
      "Admin Account": "حساب المدير",
      "Create the first admin user for this company":
        "إنشاء أول مستخدم مدير لهذه الشركة",
      "Admin Name": "اسم المدير",
      "Enter admin full name": "أدخل الاسم الكامل للمدير",
      "Admin Email": "البريد الإلكتروني للمدير",
      "Admin Password": "كلمة مرور المدير",
      "Minimum 8 characters": "8 أحرف على الأقل",
      "Company name is required": "اسم الشركة مطلوب",
      "Slug is required": "المعرف مطلوب",
      "Admin name is required": "اسم المدير مطلوب",
      "Admin email is required": "البريد الإلكتروني للمدير مطلوب",
      "Admin password is required": "كلمة مرور المدير مطلوبة",
      Cancel: "إلغاء",
      "Saving...": "جاري الحفظ...",
      "Update Company": "تحديث الشركة",
      "Create Company": "إنشاء الشركة",
      "Loading company data...": "جاري تحميل بيانات الشركة...",
      "Company created successfully": "تم إنشاء الشركة بنجاح",
      "Company updated successfully": "تم تحديث الشركة بنجاح",
      "Failed to create company": "فشل إنشاء الشركة",
      "Failed to update company": "فشل تحديث الشركة",

      "Company Details": "تفاصيل الشركة",
      "Loading company details...": "جاري تحميل تفاصيل الشركة...",
      "Company suspended successfully": "تم تعليق الشركة بنجاح",
      "Company activated successfully": "تم تفعيل الشركة بنجاح",
      "Company deleted successfully": "تم حذف الشركة بنجاح",
      "Are you sure you want to suspend this company?":
        "هل أنت متأكد من تعليق هذه الشركة؟",
      "Are you sure you want to activate this company?":
        "هل أنت متأكد من تفعيل هذه الشركة؟",
      "Are you sure you want to delete this company? This action cannot be undone.":
        "هل أنت متأكد من حذف هذه الشركة؟ لا يمكن التراجع عن هذا الإجراء.",
      "Total Users": "إجمالي المستخدمين",
      "Total Patients": "إجمالي المرضى",
      "Total Appointments": "إجمالي المواعيد",
      "Total Revenue": "إجمالي الإيرادات",
      MRR: "الإيراد الشهري المتكرر",
      "Outstanding Invoices": "الفواتير المستحقة",
      "Company Information": "معلومات الشركة",
      Email: "البريد الإلكتروني",
      Phone: "الهاتف",
      Address: "العنوان",
      "Contact Person": "الشخص المسؤول",
      Created: "تاريخ الإنشاء",
      "Trial Ends": "انتهاء التجربة",
      Overview: "نظرة عامة",
      Users: "المستخدمين",
      Subscriptions: "الاشتراكات",
      "Activity Logs": "سجل النشاطات",
      "Recent Performance": "الأداء الأخير",
      "Appointments This Month": "المواعيد هذا الشهر",
      "Revenue This Month": "الإيرادات هذا الشهر",
      "New Patients This Month": "المرضى الجدد هذا الشهر",
      "No users found": "لا يوجد مستخدمين",
      Name: "الاسم",
      Role: "الدور",
      Active: "نشط",
      Inactive: "غير نشط",
      "No subscriptions found": "لا يوجد اشتراكات",
      Plan: "الخطة",
      Amount: "المبلغ",
      "Start Date": "تاريخ البدء",
      "End Date": "تاريخ الانتهاء",
      "No activity logs found": "لا يوجد سجل نشاطات",
      created: "إنشاء",
      updated: "تحديث",
      deleted: "حذف",
      suspended: "تعليق",
      activated: "تفعيل",

      "Plans & Pricing": "الخطط والأسعار",
      "Manage subscription plans for your platform":
        "إدارة خطط الاشتراك لمنصتك",
      "Add New Plan": "إضافة خطة جديدة",
      "Loading plans...": "جاري تحميل الخطط...",
      "Plan created successfully": "تم إنشاء الخطة بنجاح",
      "Plan updated successfully": "تم تحديث الخطة بنجاح",
      "Plan deleted successfully": "تم حذف الخطة بنجاح",
      "Plan status updated": "تم تحديث حالة الخطة",
      "Failed to create plan": "فشل إنشاء الخطة",
      "Failed to update plan": "فشل تحديث الخطة",
      "Are you sure you want to delete {{name}}?":
        "هل أنت متأكد من حذف {{name}}؟",
      Inactive: "غير نشط",
      month: "شهر",
      year: "سنة",
      "Up to {{count}} users": "حتى {{count}} مستخدم",
      "Unlimited users": "مستخدمين غير محدودين",
      "Up to {{count}} patients": "حتى {{count}} مريض",
      "Up to {{count}} appointments/month": "حتى {{count}} موعد/شهر",
      Edit: "تعديل",
      Disable: "تعطيل",
      Enable: "تفعيل",
      "Edit Plan": "تعديل الخطة",
      "Plan Name (English)": "اسم الخطة (إنجليزي)",
      "Plan Name (Arabic)": "اسم الخطة (عربي)",
      "Description (English)": "الوصف (إنجليزي)",
      "Description (Arabic)": "الوصف (عربي)",
      "Monthly Price (EGP)": "السعر الشهري (جنيه)",
      "Yearly Price (EGP)": "السعر السنوي (جنيه)",
      "Max Users": "الحد الأقصى للمستخدمين",
      "Max Patients": "الحد الأقصى للمرضى",
      "Max Appointments per Month": "الحد الأقصى للمواعيد شهريًا",
      Unlimited: "غير محدود",
      "Features (comma separated)": "المميزات (مفصولة بفواصل)",
      "Active (available for new subscriptions)":
        "نشط (متاح للاشتراكات الجديدة)",
      "Create Plan": "إنشاء الخطة",
      "Update Plan": "تحديث الخطة",

      Subscriptions: "الاشتراكات",
      "Manage all company subscriptions": "إدارة جميع اشتراكات الشركات",
      "Add Subscription": "إضافة اشتراك",
      "Loading subscriptions...": "جاري تحميل الاشتراكات...",
      "Search by company or plan...": "بحث بالشركة أو الخطة...",
      "All Status": "جميع الحالات",
      Pending: "قيد الانتظار",
      Expired: "منتهي",
      Company: "الشركة",
      Plan: "الخطة",
      Amount: "المبلغ",
      "Start Date": "تاريخ البدء",
      "End Date": "تاريخ الانتهاء",
      "Payment Method": "طريقة الدفع",
      "Transaction ID": "رقم العملية",
      "No subscriptions found": "لا يوجد اشتراكات",
      Renew: "تجديد",
      Cancel: "إلغاء",
      "Subscription created successfully": "تم إنشاء الاشتراك بنجاح",
      "Subscription updated successfully": "تم تحديث الاشتراك بنجاح",
      "Subscription cancelled successfully": "تم إلغاء الاشتراك بنجاح",
      "Subscription renewed successfully": "تم تجديد الاشتراك بنجاح",
      "Failed to create subscription": "فشل إنشاء الاشتراك",
      "Failed to update subscription": "فشل تحديث الاشتراك",
      "Are you sure you want to cancel this subscription?":
        "هل أنت متأكد من إلغاء هذا الاشتراك؟",
      "Are you sure you want to renew this subscription?":
        "هل أنت متأكد من تجديد هذا الاشتراك؟",
      "Edit Subscription": "تعديل الاشتراك",
      "Select Company": "اختر الشركة",
      "Select Plan": "اختر الخطة",
      "Amount (EGP)": "المبلغ (جنيه)",
      "Cash, Card, Transfer...": "نقدي، بطاقة، تحويل...",
      Optional: "اختياري",
      Notes: "ملاحظات",
      "Additional notes...": "ملاحظات إضافية...",
      "Create Subscription": "إنشاء الاشتراك",
      "Update Subscription": "تحديث الاشتراك",

      "SaaS Reports": "تقارير المنصة",
      "Analytics and insights for your platform": "تحليلات ورؤى لمنصتك",
      Export: "تصدير",
      Overview: "نظرة عامة",
      Revenue: "الإيرادات",
      Growth: "النمو",
      Churn: "معدل التسرب",
      "Top Companies": "أفضل الشركات",
      "Total Companies": "إجمالي الشركات",
      "Active Companies": "الشركات النشطة",
      "Avg Revenue/Company": "متوسط الإيراد/شركة",
      "Churn Rate": "معدل التسرب",
      "Revenue Trend": "اتجاه الإيرادات",
      "Companies Growth": "نمو الشركات",
      New: "جديد",
      Churned: "منسحب",
      Net: "الصافي",
      "Plans Distribution": "توزيع الخطط",
      "Companies by Status": "الشركات حسب الحالة",
      "Total Revenue": "إجمالي الإيرادات",
      ARR: "الإيراد السنوي المتكرر",
      "Avg Transaction": "متوسط المعاملة",
      "Revenue Breakdown": "تفصيل الإيرادات",
      Subscriptions: "الاشتراكات",
      "Net Growth": "النمو الصافي",
      "New Companies": "شركات جديدة",
      "Churned Companies": "شركات منسحبة",
      "Monthly Growth": "النمو الشهري",
      "Retention Rate": "معدل الاحتفاظ",
      "Avg Lifetime (months)": "متوسط العمر (شهور)",
      "Churn Trend": "اتجاه معدل التسرب",
      "Top Performing Companies": "أفضل الشركات أداءً",
      "Recent Activity": "آخر النشاطات",
      "Loading reports...": "جاري تحميل التقارير...",
      "No data available": "لا توجد بيانات",

      "Platform Settings": "إعدادات المنصة",
      "Configure your SaaS platform settings": "تكوين إعدادات منصتك",
      General: "عام",
      Branding: "العلامة التجارية",
      Email: "البريد الإلكتروني",
      Notifications: "الإشعارات",
      Maintenance: "الصيانة",
      Security: "الأمان",
      API: "واجهة البرمجة",
      "General Settings": "الإعدادات العامة",
      "Platform Name": "اسم المنصة",
      "Platform Email": "البريد الإلكتروني للمنصة",
      "Platform Phone": "هاتف المنصة",
      "Platform Address": "عنوان المنصة",
      "Enter platform address": "أدخل عنوان المنصة",
      "Default Language": "اللغة الافتراضية",
      "Default Timezone": "المنطقة الزمنية الافتراضية",
      "Default Currency": "العملة الافتراضية",
      "Date Format": "تنسيق التاريخ",
      "Time Format": "تنسيق الوقت",
      "Branding Settings": "إعدادات العلامة التجارية",
      Logo: "الشعار",
      Favicon: "أيقونة الموقع",
      "Primary Color": "اللون الأساسي",
      "Secondary Color": "اللون الثانوي",
      "Accent Color": "اللون التمييزي",
      "Email Settings": "إعدادات البريد الإلكتروني",
      Mailer: "نظام البريد",
      "SMTP Host": "مضيف SMTP",
      "SMTP Port": "منفذ SMTP",
      "SMTP Username": "اسم مستخدم SMTP",
      "SMTP Password": "كلمة مرور SMTP",
      Encryption: "التشفير",
      "From Address": "عنوان المرسل",
      "From Name": "اسم المرسل",
      "Notification Settings": "إعدادات الإشعارات",
      "Enable Email Notifications": "تفعيل إشعارات البريد الإلكتروني",
      "Enable SMS Notifications": "تفعيل إشعارات الرسائل النصية",
      "Enable Push Notifications": "تفعيل الإشعارات الفورية",
      "Admin Notifications": "إشعارات المدير",
      "New Company Registration": "تسجيل شركة جديدة",
      "New Subscription Created": "إنشاء اشتراك جديد",
      "Payment Received": "استلام دفعة",
      "Trial Ending Soon": "قرب انتهاء التجربة",
      "Maintenance Settings": "إعدادات الصيانة",
      "Enable Maintenance Mode": "تفعيل وضع الصيانة",
      "Maintenance Message": "رسالة الصيانة",
      "We'll be back soon!": "سنعود قريبًا!",
      "Allowed IP Addresses": "عناوين IP المسموح بها",
      "One IP per line": "IP واحد لكل سطر",
      "These IPs can access the site during maintenance":
        "هذه العناوين يمكنها الوصول للموقع أثناء الصيانة",
      "Security Settings": "إعدادات الأمان",
      "Max Login Attempts": "الحد الأقصى لمحاولات الدخول",
      "Lockout Duration (minutes)": "مدة الحظر (دقائق)",
      "Session Lifetime (minutes)": "مدة الجلسة (دقائق)",
      "Password Expiry (days)": "انتهاء كلمة المرور (أيام)",
      "Require Two-Factor Authentication for Admins":
        "طلب المصادقة الثنائية للمديرين",
      "API Settings": "إعدادات API",
      "Enable Public API": "تفعيل API العامة",
      "Rate Limit (requests per minute)": "حد الطلبات (طلب/دقيقة)",
      "Webhook URL": "رابط Webhook",
      "Webhook Secret": "كلمة سر Webhook",
      "Save Changes": "حفظ التغييرات",
      "Settings saved successfully": "تم حفظ الإعدادات بنجاح",
      "Failed to save settings": "فشل حفظ الإعدادات",
      "Loading settings...": "جاري تحميل الإعدادات...",

      "Activity Logs": "سجل النشاطات",
      "Monitor all activities across your platform":
        "مراقبة جميع النشاطات عبر منصتك",
      Refresh: "تحديث",
      "Loading activity logs...": "جاري تحميل سجل النشاطات...",
      "Search by action, user, or subject...":
        "بحث بالإجراء، المستخدم، أو الموضوع...",
      "All Actions": "جميع الإجراءات",
      "Company Created": "إنشاء شركة",
      "Company Updated": "تحديث شركة",
      "Company Deleted": "حذف شركة",
      "Company Activated": "تفعيل شركة",
      "Company Suspended": "تعليق شركة",
      "User Created": "إنشاء مستخدم",
      "User Updated": "تحديث مستخدم",
      "User Deleted": "حذف مستخدم",
      "Product Created": "إنشاء منتج",
      "Product Updated": "تحديث منتج",
      "Product Deleted": "حذف منتج",
      "Invoice Created": "إنشاء فاتورة",
      "Invoice Updated": "تحديث فاتورة",
      "Payment Created": "إنشاء دفعة",
      "Appointment Created": "إنشاء موعد",
      "Appointment Updated": "تحديث موعد",
      "No activity logs found": "لا يوجد سجل نشاطات",
      "View Details": "عرض التفاصيل",
      "Page {{current}} of {{total}}": "صفحة {{current}} من {{total}}",
      "Something went wrong": "حدث خطأ ما",
      "Try Again": "حاول مرة أخرى",

      "Billing & Subscription": "الفوترة والاشتراك",
      "Manage your subscription and payment methods":
        "إدارة اشتراكك ووسائل الدفع",
      "Current Plan": "الخطة الحالية",
      "No Active Plan": "لا توجد خطة نشطة",
      Started: "تاريخ البدء",
      "Renews on": "التجديد في",
      "days left": "يوم متبقي",
      "Change Plan": "تغيير الخطة",
      "Cancel Subscription": "إلغاء الاشتراك",
      "You don't have an active subscription": "ليس لديك اشتراك نشط",
      "Choose a Plan": "اختر خطة",
      "Payment Methods": "وسائل الدفع",
      "Add Payment Method": "إضافة وسيلة دفع",
      Default: "افتراضي",
      Expires: "تنتهي في",
      "Billing History": "سجل الفواتير",
      Invoice: "الفاتورة",
      Date: "التاريخ",
      Amount: "المبلغ",
      "No billing history": "لا يوجد سجل فواتير",
      "Choose Your Plan": "اختر خطتك",
      Monthly: "شهري",
      Yearly: "سنوي",
      "Save 20%": "وفر 20%",
      mo: "شهر",
      yr: "سنة",
      Current: "الحالية",
      "Processing...": "جاري المعالجة...",
      Subscribe: "اشتراك",
      "Loading billing information...": "جاري تحميل معلومات الفوترة...",
      "Subscription updated successfully": "تم تحديث الاشتراك بنجاح",
      "Failed to update subscription": "فشل تحديث الاشتراك",
      "Subscription cancelled successfully": "تم إلغاء الاشتراك بنجاح",
      "Failed to cancel subscription": "فشل إلغاء الاشتراك",
      "Payment method added successfully": "تمت إضافة وسيلة الدفع بنجاح",
      "Payment method removed": "تمت إزالة وسيلة الدفع",
      "Are you sure you want to cancel your subscription?":
        "هل أنت متأكد من إلغاء اشتراكك؟",

      "Cardholder Name": "اسم حامل البطاقة",
      "John Doe": "محمد أحمد",
      "Card Number": "رقم البطاقة",
      "Expiry Month": "شهر الانتهاء",
      "Expiry Year": "سنة الانتهاء",
      CVC: "رمز الأمان",
      "Set as default payment method": "تعيين كوسيلة دفع افتراضية",
      "Add Card": "إضافة البطاقة",
      "Processing...": "جاري المعالجة...",
      "Payment method added successfully": "تمت إضافة وسيلة الدفع بنجاح",
      "Failed to add payment method": "فشل إضافة وسيلة الدفع",
      Cancel: "إلغاء",

      "Active Subscriptions": "الاشتراكات النشطة",
      "Churn Rate": "معدل التسرب",
      "Avg Revenue/Company": "متوسط الإيراد/شركة",
      "this month": "هذا الشهر",
      "Recent Transactions": "آخر المعاملات",
      Invoice: "الفاتورة",
      Company: "الشركة",
      Amount: "المبلغ",
      Date: "التاريخ",
      "No recent transactions": "لا توجد معاملات حديثة",
      "subscription.created": "إنشاء اشتراك",
      "subscription.cancelled": "إلغاء اشتراك",
      "subscription.changed": "تغيير الاشتراك",
      "payment.received": "استلام دفعة",

      "All Branches": "كل الفروع",
      Branches: "الفروع",

      "Full Name": "الاسم الكامل",
      "Email Address": "البريد الإلكتروني",
      "Create Employee": "إضافة موظف",
      "Edit Employee": "تعديل موظف",
      "Failed to load employee.": "فشل تحميل بيانات الموظف.",

      "Print Invoice": "طباعة الفاتورة",
      INVOICE: "فاتورة",
      "Dental Clinic": "عيادة الأسنان",
      "Phone:": "الهاتف:",
      "Email:": "البريد الإلكتروني:",
      "Patient:": "المريض:",
      "Date:": "التاريخ:",
      "Status:": "الحالة:",
      Item: "الصنف",
      "Unit Price": "سعر الوحدة",
      Subtotal: "المجموع الفرعي",
      Discount: "الخصم",
      "Thank you for your trust!": "شكراً لثقتكم!",
      "This invoice was generated electronically.":
        "تم إصدار هذه الفاتورة إلكترونياً.",
      "Invoice not found": "الفاتورة غير موجودة",
      "No items found": "لا توجد أصناف",
      "Go Back": "العودة",
      Print: "طباعة",
      "Print Purchase Order": "طباعة أمر الشراء",
      "PURCHASE ORDER": "أمر شراء",
      "Supplier:": "المورد:",
      Supply: "مستلزم",
      "Unit Cost": "سعر الوحدة",
      "Total Paid": "إجمالي المدفوع",
      Remaining: "المتبقي",
      "Thank you for your business!": "شكراً لتعاملكم معنا!",
      "This purchase order was generated electronically.":
        "تم إصدار أمر الشراء هذا إلكترونياً.",
      "Purchase order not found": "أمر الشراء غير موجود",
      "Supplier Statement": "كشف حساب المورد",
      "Supplier Statement:": "كشف حساب المورد:",
      "Account movements and balance": "حركات الحساب والرصيد",
      From: "من",
      To: "إلى",
      Clear: "مسح",
      "Opening Balance": "الرصيد الافتتاحي",
      "Closing Balance": "الرصيد الختامي",
      Supplier: "المورد",
      "Account Movements": "حركات الحساب",
      entries: "قيود",
      Description: "البيان",
      Type: "النوع",
      Debit: "مدين",
      Credit: "دائن",
      Balance: "الرصيد",
      "No entries found.": "لا توجد قيود.",
      "Failed to load supplier statement.": "فشل تحميل كشف حساب المورد.",
      Supplies: "المستلزمات",
      "Manage clinic supplies and stock": "إدارة مستلزمات العيادة والمخزون",
      "Add Supply": "إضافة مستلزم",
      "Supplies List": "قائمة المستلزمات",
      supplies: "مستلزمات",
      "No supplies found.": "لا توجد مستلزمات.",
      Name: "الاسم",
      SKU: "رمز التخزين",
      "In Stock": "في المخزون",
      "Edit Supply": "تعديل المستلزم",
      "Delete Supply": "حذف المستلزم",
      'Are you sure you want to delete "{{name}}"?':
        'هل أنت متأكد من حذف "{{name}}"؟',
      "Supply deleted successfully.": "تم حذف المستلزم بنجاح.",
      "Failed to delete supply.": "فشل حذف المستلزم.",
      "Failed to load supplies.": "فشل تحميل المستلزمات.",
      "Manage supply details, cost, and stock":
        "إدارة تفاصيل المستلزم والتكلفة والمخزون",
      "Back to Supplies": "العودة للمستلزمات",
      "Supply Details": "تفاصيل المستلزم",
      "New Supply": "مستلزم جديد",
      "Stock Quantity": "كمية المخزون",
      Category: "الفئة",
      "-- Select Category --": "-- اختر الفئة --",
      "-- Select Supplier --": "-- اختر المورد --",
      "Save Changes": "حفظ التغييرات",
      "Create Supply": "إنشاء المستلزم",
      "Saving...": "جاري الحفظ...",
      "Creating...": "جاري الإنشاء...",
      Cancel: "إلغاء",
      "Supply updated successfully.": "تم تحديث المستلزم بنجاح.",
      "Supply created successfully.": "تم إنشاء المستلزم بنجاح.",
      "Failed to save supply.": "فشل حفظ المستلزم.",
      "ID, name, SKU, unit cost...": "الرقم، الاسم، رمز التخزين، التكلفة...",
      "Create Purchase Order": "إنشاء أمر شراء",
      "View Purchase Orders": "عرض أوامر الشراء",
      Retry: "إعادة المحاولة",
      Back: "رجوع",
      "Loading...": "جاري التحميل...",

      "Purchase Total": "إجمالي المشتريات",
      "Orders Count": "عدد الطلبات",
      "Paid to Suppliers": "المدفوع للموردين",
      "Remaining to Pay": "المتبقي للسداد",
      Purchases: "المشتريات",
      "Monitor your procurement and supplier payments":
        "مراقبة المشتريات والمدفوعات للموردين",
      "Recent Purchase Orders": "أحدث أوامر الشراء",
      "No recent purchase orders.": "لا توجد أوامر شراء حديثة.",
      "PO #": "أمر شراء #",
      Paid: "المدفوع",
      "Low Stock Supplies": "مستلزمات منخفضة المخزون",
      "Inventory Value": "قيمة المخزون",
      Inventory: "المخزون",
      "Stock levels and inventory valuation": "مستويات المخزون وتقييمه",
      "Purchase Returns": "قيمة المرتجعات",
      "Net Purchases": "صافي المشتريات",

      "Financial Overview": "نظرة مالية عامة",
      "Key financial health indicators": "مؤشرات الصحة المالية الرئيسية",
      "Net Profit": "صافي الربح",
      "Outstanding Receivables": "المستحقات على المرضى",
      "Outstanding Payables": "المستحقات للموردين",
      "Purchase Balance": "رصيد المشتريات",

      "Low Stock Supplies": "مستلزمات منخفضة المخزون",
      Name: "الاسم",
      "In Stock": "في المخزون",
      "Unit Cost": "سعر الوحدة",
      "Total Value": "القيمة الإجمالية",
      "View All": "عرض الكل",

      "Max Branches": "الحد الأقصى للفروع",
      "Up to {{count}} branches": "حتى {{count}} فروع",
      "You have reached the maximum number of branches allowed by your plan.":
        "لقد وصلت إلى الحد الأقصى لعدد الفروع المسموح به في باقتك.",

      Branches: "الفروع",
      "Manage clinic branches": "إدارة فروع العيادة",
      "Add Branch": "إضافة فرع",
      "Branches List": "قائمة الفروع",
      branches: "فروع",
      "No branches found.": "لم يتم العثور على فروع.",
      "Edit Branch": "تعديل فرع",
      "Delete Branch": "حذف فرع",
      'Are you sure you want to delete branch "{{name}}"?':
        'هل أنت متأكد من حذف الفرع "{{name}}"؟',
      "Branch deleted successfully.": "تم حذف الفرع بنجاح.",
      "Failed to delete branch.": "فشل حذف الفرع.",
      "Failed to load branches.": "فشل تحميل الفروع.",
      "New Branch": "فرع جديد",
      "Branch Details": "تفاصيل الفرع",
      Slug: "المعرف المختصر",
      "Save Changes": "حفظ التغييرات",
      "Create Branch": "إنشاء فرع",
      "Branch updated successfully.": "تم تحديث الفرع بنجاح.",
      "Branch created successfully.": "تم إنشاء الفرع بنجاح.",
      "You have reached the maximum number of branches allowed by your plan.":
        "لقد وصلت إلى الحد الأقصى لعدد الفروع المسموح به في خطتك.",
      "Up to {{count}} branches": "حتى {{count}} فروع",
      "Max Branches": "الحد الأقصى للفروع",
      "Subscribe Now": "اشترك الان",

      "Print Invoice": "طباعة الفاتورة",
      "Subscription Invoice": "فاتورة الاشتراك",
      Description: "الوصف",
      "Tax (14%)": "الضريبة (14%)",
      "Thank you for your subscription!": "شكراً لاشتراكك!",
      "This invoice was generated electronically.":
        "تم إصدار هذه الفاتورة إلكترونياً.",
      "Failed to load invoice.": "فشل تحميل الفاتورة.",
      "Invoice not found": "الفاتورة غير موجودة",
      "Paid At": "تاريخ الدفع",

      "Manage Your Dental Clinic Smarter": "أدر عيادة أسنانك بذكاء",
      "The all-in-one platform for dental clinics — appointments, invoices, inventory, reports, and more.":
        "المنصة الشاملة لعيادات الأسنان — مواعيد، فواتير، مخزون، تقارير، والمزيد.",
      "Start Free Trial": "ابدأ تجربة مجانية",
      Login: "تسجيل الدخول",
      "Everything You Need": "كل ما تحتاجه",
      "From appointments to inventory, we've got every aspect of your clinic covered.":
        "من المواعيد إلى المخزون، نغطي كل جوانب عيادتك.",
      Appointments: "المواعيد",
      "Smart scheduling, reminders, and online booking for patients.":
        "جدولة ذكية وتذكيرات وحجز إلكتروني.",
      "Invoices & Payments": "الفواتير والمدفوعات",
      "Track payments, issue invoices, and manage billing with ease.":
        "تتبع المدفوعات وإصدار الفواتير بسهولة.",
      "Inventory & Supplies": "المخزون والمستلزمات",
      "Monitor stock levels and manage supplier purchases.":
        "مراقبة المخزون وإدارة مشتريات الموردين.",
      "Reports & Insights": "التقارير والإحصائيات",
      "Real-time dashboards and detailed clinic performance reports.":
        "لوحات تحكم مباشرة وتقارير أداء مفصلة.",
      "Patient Records": "سجلات المرضى",
      "Comprehensive patient profiles, medical history, and timelines.":
        "ملفات مرضى شاملة وتاريخ طبي.",
      "Multi-Branch": "تعدد الفروع",
      "Manage multiple clinic branches from one account.":
        "إدارة عدة فروع للعيادة من حساب واحد.",
      "Simple Pricing": "أسعار بسيطة",
      "Choose a plan that fits your clinic size. Upgrade anytime as you grow.":
        "اختر خطة تناسب حجم عيادتك. قم بالترقية في أي وقت.",
      "Get Started": "ابدأ الآن",
      "Ready to Transform Your Clinic?": "مستعد لتطوير عيادتك؟",
      "Join hundreds of dental clinics already using our platform. Start your free 14-day trial today.":
        "انضم إلى مئات العيادات التي تستخدم منصتنا. ابدأ تجربتك المجانية لمدة 14 يومًا اليوم.",
      Clinics: "عيادة",
      "Appointments Managed": "موعد مُدار",
      "EGP Processed": "جنيه مصري تمت معالجته",

      "Analytics Dashboard": "لوحة التحليلات",
      Period: "الفترة",
      Invoiced: "تمت الفوترة",
      Collected: "تم تحصيله",
      "Generated on": "تم الإنشاء في",
      "No data": "لا توجد بيانات",

      "Appointments Report": "تقرير المواعيد",
      Total: "الإجمالي",
      Scheduled: "مجدول",
      Completed: "مكتمل",
      Cancelled: "ملغى",
      "No Show": "لم يحضر",
      "In Progress": "قيد التنفيذ",
      "No appointments found.": "لا توجد مواعيد.",
      "Generated on": "تم الإنشاء في",

      "Doctor Performance Report": "تقرير أداء الأطباء",
      "Total Doctors": "إجمالي الأطباء",
      "Total Appointments": "إجمالي المواعيد",
      "Avg Completion Rate": "متوسط نسبة الإكمال",
      Specialty: "التخصص",
      "No data available.": "لا توجد بيانات متاحة",
      "Generated on": "تم الإنشاء في",

      "Revenue Report": "تقرير الإيرادات",
      "Total Invoiced": "إجمالي الفواتير",
      "Gross Paid": "إجمالي المدفوع",
      Refunded: "مسترجع",
      "Net Paid": "صافي المدفوع",
      Remaining: "المتبقي",
      Period: "الفترة",
      "No revenue rows found.": "لا توجد صفوف إيرادات.",
      "Generated on": "تم الإنشاء في",

      "Payments Report": "تقرير المدفوعات",
      "Total Payments": "إجمالي المدفوعات",
      "Number of Payments": "عدد الدفعات",
      "Average Payment": "متوسط الدفعة",
      "Payment ID": "رقم الدفعة",
      Applied: "المطبق",
      Method: "طريقة الدفع",
      "No payments found.": "لا توجد مدفوعات.",
      "Generated on": "تم الإنشاء في",

      "Treatment Plans Report": "تقرير خطط العلاج",
      "Total Plans": "إجمالي الخطط",
      "Total Cost": "إجمالي التكلفة",
      "Total Paid": "إجمالي المدفوع",
      "Total Remaining": "إجمالي المتبقي",
      "Completion Rate": "نسبة الإكمال",
      "Plan Rows": "صفوف الخطط",
      "No treatment plans found.": "لا توجد خطط علاج.",
      Active: "نشط",
      Completed: "مكتمل",
      Cancelled: "ملغى",
      Created: "تاريخ الإنشاء",
      "Generated on": "تم الإنشاء في",

      "Patients Report": "تقرير المرضى",
      "Total Patients": "إجمالي المرضى",
      Active: "نشط",
      Inactive: "غير نشط",
      Male: "ذكر",
      Female: "أنثى",
      Gender: "الجنس",
      "All Genders": "جميع الأجناس",
      "Date of Birth": "تاريخ الميلاد",
      Age: "العمر",
      Code: "الكود",
      "Patient Rows": "صفوف المرضى",
      "No patients found.": "لا يوجد مرضى.",
      Created: "تاريخ الإنشاء",
      "Export CSV": "تصدير CSV",
      Print: "طباعة",
      "Back to Reports": "العودة للتقارير",
      "Apply Filters": "تطبيق الفلاتر",
      "From Date": "من تاريخ",
      "To Date": "إلى تاريخ",
      "Failed to load patients report.": "فشل تحميل تقرير المرضى.",

      "SaaS Reports": "تقارير المنصة",
      "Total Companies": "إجمالي الشركات",
      "Active Companies": "الشركات النشطة",
      MRR: "الإيراد الشهري المتكرر",
      "Avg Revenue/Company": "متوسط العائد لكل شركة",
      "Churn Rate": "معدل التخلي",
      "Revenue Trend": "اتجاه الإيرادات",
      "Companies Growth": "نمو الشركات",
      "Plans Distribution": "توزيع الخطط",
      "Companies by Status": "الشركات حسب الحالة",
      "Top Performing Companies": "أفضل الشركات أداءً",
      Period: "الفترة",
      Print: "طباعة",
      "No data": "لا توجد بيانات",
      "Generated on": "تم الإنشاء في",

      "Contact Us": "اتصل بنا",
      "Have a question or need help? Fill out the form below and we'll get back to you shortly.":
        "هل لديك سؤال أو تحتاج مساعدة؟ املأ النموذج أدناه وسنعاود الاتصال بك قريباً.",
      "Your Name": "اسمك",
      "Email Address": "البريد الإلكتروني",
      Subject: "الموضوع",
      "How can we help you?": "كيف يمكننا مساعدتك؟",
      Message: "الرسالة",
      "Tell us more about your inquiry...": "أخبرنا المزيد عن استفسارك...",
      "Send Message": "إرسال الرسالة",
      "Sending...": "جارٍ الإرسال...",
      "Your message has been sent successfully. We will get back to you soon.":
        "تم إرسال رسالتك بنجاح. سنعاود الاتصال بك قريباً.",
      "Failed to send your message. Please try again.":
        "فشل إرسال رسالتك. يرجى المحاولة مرة أخرى.",
      "Your message has been sent successfully. We will get back to you soon.":
        "تم إرسال رسالتك بنجاح. سنعاود الاتصال بك قريباً.",

      "Contact Messages": "رسائل الاتصال",
      "Messages received from the contact form":
        "الرسائل الواردة من نموذج الاتصال",
      "No messages found.": "لا توجد رسائل.",
      "Mark as Read": "تعليم كمقروء",
      Read: "مقروء",
      Unread: "غير مقروء",
      Phone: "الهاتف",
      Clear: "مسح",
      "Failed to load messages.": "فشل تحميل الرسائل.",
      "Message deleted successfully.": "تم حذف الرسالة بنجاح.",
      "Failed to mark as read.": "فشل تعليم الرسالة كمقروءة.",
      "Failed to delete message.": "فشل حذف الرسالة.",

      "Terms of Service": "شروط الخدمة",
      "Last Updated": "آخر تحديث",
      "1. Acceptance of Terms": "١. قبول الشروط",
      "By accessing and using our platform, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.":
        "باستخدامك منصتنا، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق، يُرجى عدم استخدام خدماتنا.",
      "2. Description of Service": "٢. وصف الخدمة",
      "We provide a cloud-based dental practice management software (SaaS) that allows clinics to manage appointments, patients, invoices, inventory, and more.":
        "نحن نقدم برنامجاً سحابياً لإدارة عيادات الأسنان (SaaS) يتيح للعيادات إدارة المواعيد والمرضى والفواتير والمخزون والمزيد.",
      "3. User Accounts": "٣. حسابات المستخدمين",
      "You are responsible for maintaining the confidentiality of your account credentials. You must notify us immediately of any unauthorized use of your account.":
        "أنت مسؤول عن الحفاظ على سرية بيانات دخول حسابك. يجب عليك إبلاغنا فوراً عن أي استخدام غير مصرح به لحسابك.",
      "4. Subscription and Payments": "٤. الاشتراك والمدفوعات",
      "Some features require a paid subscription. You agree to pay all fees associated with your plan. Subscription fees are non-refundable unless required by law.":
        "بعض الميزات تتطلب اشتراكاً مدفوعاً. أنت توافق على دفع جميع الرسوم المرتبطة بخطتك. رسوم الاشتراك غير قابلة للاسترداد إلا إذا نص القانون على ذلك.",
      "5. Limitation of Liability": "٥. تحديد المسؤولية",
      "We shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.":
        "لا نتحمل المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية تنشأ عن استخدامك للمنصة.",
      "6. Changes to Terms": "٦. تعديل الشروط",
      "We reserve the right to update these terms at any time. Continued use of the platform after changes constitutes acceptance of the new terms.":
        "نحتفظ بالحق في تحديث هذه الشروط في أي وقت. استمرارك في استخدام المنصة بعد التعديلات يعني قبولك للشروط الجديدة.",
      "7. Contact": "٧. الاتصال",
      "For any questions about these terms, please contact us through our contact page.":
        "لأي استفسار حول هذه الشروط، يُرجى التواصل معنا عبر صفحة الاتصال.",

      "Privacy Policy": "سياسة الخصوصية",
      "Last Updated": "آخر تحديث",
      "1. Information We Collect": "١. المعلومات التي نجمعها",
      "We collect information you provide when registering, such as name, email address, clinic information, and payment details. We also collect usage data automatically.":
        "نقوم بجمع المعلومات التي تقدمها عند التسجيل، مثل الاسم، البريد الإلكتروني، بيانات العيادة، وتفاصيل الدفع. كما نجمع بيانات الاستخدام تلقائياً.",
      "2. How We Use Your Information": "٢. كيف نستخدم معلوماتك",
      "We use your information to provide, maintain, and improve our services, process payments, send notifications, and comply with legal obligations.":
        "نستخدم معلوماتك لتقديم خدماتنا وصيانتها وتحسينها، ومعالجة المدفوعات، وإرسال الإشعارات، والامتثال للالتزامات القانونية.",
      "3. Data Sharing": "٣. مشاركة البيانات",
      "We do not sell your personal data. We may share data with trusted third-party service providers (such as payment gateways) only as necessary to provide the service.":
        "نحن لا نبيع بياناتك الشخصية. قد نشارك البيانات مع مقدمي خدمات خارجيين موثوقين (مثل بوابات الدفع) فقط بقدر ما هو ضروري لتقديم الخدمة.",
      "4. Data Security": "٤. أمن البيانات",
      "We implement industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure.":
        "نحن نطبق إجراءات أمنية معيارية في المجال لحماية بياناتك. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100%.",
      "5. Your Rights": "٥. حقوقك",
      "You have the right to access, correct, or delete your personal data. You may also object to or restrict certain processing activities.":
        "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. كما يمكنك الاعتراض على أو تقييد بعض أنشطة المعالجة.",
      "6. Cookies": "٦. ملفات تعريف الارتباط (كوكيز)",
      "We use cookies to improve your browsing experience. You can disable cookies in your browser settings, but this may affect the functionality of the platform.":
        "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح لديك. يمكنك تعطيل الكوكيز في إعدادات المتصفح، لكن هذا قد يؤثر على وظائف المنصة.",
      "7. Contact": "٧. الاتصال",
      "For any questions about this privacy policy, please contact us through our contact page.":
        "لأي استفسار حول سياسة الخصوصية هذه، يُرجى التواصل معنا عبر صفحة الاتصال.",

      "Clinic Management Platform": "منصة إدارة العيادات",
      "The smart way to manage your dental clinic – appointments, invoices, inventory, and more.":
        "الطريقة الذكية لإدارة عيادة الأسنان – المواعيد، الفواتير، المخزون، والتقارير.",
      "Appointment Management": "إدارة المواعيد",
      "Invoicing & Payments": "الفواتير والمدفوعات",
      "Inventory & Reports": "المخزون والتقارير",
      "Supplier Credits": "مستحقات لدى الموردين",

      "Export Clinic Data": "تصدير بيانات العيادة",
      "Exporting...": "جارٍ التصدير...",
      "Export completed. Download started.": "اكتمل التصدير. بدأ التحميل.",
      "Export failed. Please try again.": "فشل التصدير. حاول مرة أخرى.",

      "Security Feed": "سجل الأمان",
      "Monitor all security-related events in real-time":
        "مراقبة جميع الأحداث الأمنية في الوقت الفعلي",
      "Event Type": "نوع الحدث",
      "All Types": "جميع الأنواع",
      "Failed Login": "تسجيل دخول فاشل",
      "Suspicious Activity": "نشاط مشبوه",
      "Admin Override": "تجاوز إداري",
      Email: "البريد الإلكتروني",
      "Search by email": "البحث بالبريد الإلكتروني",
      From: "من",
      To: "إلى",
      "Clear Filters": "مسح الفلاتر",
      "No security events found.": "لم يتم العثور على أحداث أمنية.",
      Type: "النوع",
      Reason: "السبب",
      "User ID": "معرف المستخدم",
      Previous: "السابق",
      Next: "التالي",
      "Page {{current}} of {{total}}": "صفحة {{current}} من {{total}}",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("appLanguage") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
